<template>
  <div>
    <!-- v-if="userdata.jwt!=undefined" -->
    <div class="dmv-container-fluid">

      <div>
        <nav class="navbar navbar-expand-lg bg-info text-white" style="position:fixed;width:100%;z-index:5;">
          <span v-if="deal.dealerDMV == 'Y'">
            <b>DMV Title {{ deal.loanNumber }} - Dealer Doing DMV {{ emailMilestoneResponse }}</b>
          </span>
          <span v-else-if="deal.dealerDMV == 'N'">
            <b>DMV Title {{ deal.loanNumber }} - LLP Doing DMV {{ emailMilestoneResponse }}</b>
          </span>
          <span v-else>
            <b>DMV Title</b>
          </span>
        </nav>
      </div>
      <div v-if="this.selecteddmvid == ''">
        <deals></deals>
      </div>
      <div v-if="this.selecteddmvid != ''">
        <div class="row">
          <div class="col-lg-2">
            <ul class="nav flex-lg-column flex-sm-column flex-md-row mb-3 ml-2 mt-3 nav-tabs border mt-5" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#deal" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Lease Information </a>
              </li>
              <li>
                <a class="nav-link" data-toggle="tab" href="#lesseeinfotab" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Lessee Info</a>
              </li>
              <li>
                <a class="nav-link" data-toggle="tab" href="#vehicleinfotab" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Vehicle Info</a>
              </li>

              <li class="nav-item dropdown">
                <a class="nav-link" data-toggle="tab" href="#motorVehicle" role="tab"
                  @click="disableCurbWeight(), disableTrim(), getTitleSentToTrust();">Motor Vehicle</a>
              </li>


              <!-- <li class="nav-item dropdown">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  href="#manageTitle"
                  role="tab"
                  >Manage Title</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tempreg" role="tab"
                  >Manage Temp Registration</a
                >
              </li>-->
              <li>
                <a class="nav-link" data-toggle="tab" href="#payablereceivable" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Financials</a>
              </li>
              <li>
                <a class="nav-link" data-toggle="tab" href="#documentstab" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Documents</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#notes" id="note1" role="tab"
                  @click="disableCurbWeight(), disableTrim()">Notes</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#viewReminders" role="tab"
                  @click="getDmvMileStone, disableCurbWeight(), disableTrim()">View Reminders</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#manageMilestoneStatus" role="tab"
                  @click="getManageMilestoneStatus(), disableCurbWeight(), disableTrim(), diasableMileage()">Manage Milestone
                  Status</a>
              </li>
            </ul>
          </div>

          <div class="col-10 mt-5">
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="deal">
                <div v-if="this.selecteddmvid != ''">
                  <div>
                    <nav>
                      <span>
                        <b>Lease Information</b>
                      </span>
                    </nav>
                  </div>
                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                    <div class="col-12 col-md-12 d-lg-flex flex-column">
                      <label for="Date title received from dealer"
                        class="col-form-label col-form-label-sm labelFont">Lease Number</label>

                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.selectedLoan }}</label>
                    </div>
                    <div class="col-12 col-md-12 d-lg-flex flex-column">
                      <label for="Date title received from dealer"
                        class="col-form-label col-form-label-sm labelFont">Funding Date</label>
                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.dateOfSaleToLLP | moment("MM/DD/YYYY")
                      }}</label>
                    </div>
                    <div class="col-12 col-md-12 d-lg-flex flex-column">
                      <label for="old title number" class="col-form-label col-form-label-sm labelFont">State of
                        Registration</label>
                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.registrationState }}</label>
                    </div>
                  </div>

                  <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                    <div class="col-12 col-md-12 d-lg-flex flex-column">

                      <label for="old title number" class="col-form-label col-form-label-sm labelFont">DMV Title
                        Milestone</label>
                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.loanStatusData }}</label>

                    </div>
                    <div class="col-12 col-md-12 d-lg-flex flex-column">

                      <label for="old title number" class="col-form-label col-form-label-sm labelFont">Dealer Doing
                        DMV</label>
                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.dealerDMV }}</label>

                    </div>

                  </div>

                  <div>
                    <center>
                      <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                        Back
                      </button>
                    </center>
                  </div>
                </div>
              </div>

              <div role="tabpanel" class="tab-pane" id="payablereceivable">
                <div>
                  <center>
                    <span :style="msgcolor">
                      <b>{{ responseFinancialMessage }}</b>
                    </span>
                  </center>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">DMV Fee Collected</th>
                        <th scope="col">
                          Actual Fee Paid for DMV Service Provider
                        </th>
                        <!-- <th scope="col">Payback to Lesse</th>
                        <th scope="col">Owed to Lessee</th>-->
                        <th scope="col">Owed to LLp</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="luxuryTaxEnable == 'Y'">
                        <td>Sales Tax</td>
                        <td>${{ this.financialSalesTax }}</td>
                        <td></td>
                        <td></td>
                        <!-- <td></td>
                        <td></td>-->
                      </tr>
                      <tr
                        v-if="luxuryTaxEnable == 'Y' && deal.dealbookRegistrationState == 'NJ' && selectedDealData[0].leaseDealerType == 'New'">
                        <td>Luxury Tax</td>
                        <td>${{ parseFloat(this.luxuryTax).toFixed(2) }}</td>
                        <td></td>
                        <td></td>
                        <!--  <td></td>
                        <td></td>-->
                      </tr>
                      <tr>
                        <td>Registration Fee</td>
                        <td>${{ parseFloat(this.deal.dmvFees).toFixed(2) }}</td>
                        <td></td>
                        <td></td>
                        <!--  <td></td>
                        <td></td>-->
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>${{ this.financialTotal }}</td>
                        <td v-if="deal.amount != null && deal.amount != ''">
                          ${{ parseFloat(deal.amount).toFixed(2) }}
                        </td>
                        <td v-else-if="deal.amount == ''">{{ deal.amount }}</td>
                        <td v-else>{{ deal.amount }}</td>
                        <!--    <td
                          v-if="
                            paybackToLessee != null && paybackToLessee != ''
                          "
                        >
                          ${{ paybackToLessee }}
                        </td>
                      <td v-else-if="paybackToLessee  == ''">
                          {{ paybackToLessee  }}
                        </td>
                        <td v-else>{{ paybackToLessee }}</td>
                       <td :style="msgOwnedcolor" v-if = "ownedToLessee != ''">${{ ownedToLessee }}</td>
                        <td :style="msgOwnedcolor" v-else>{{ ownedToLessee }}</td>
                       -->
                        <td :style="msgOwnedcolor" v-if="ownedToLLP != ''">${{ parseFloat(ownedToLLP).toFixed(2) }}</td>
                        <td :style="msgOwnedcolor" v-else>{{ ownedToLLP }}</td>
                      </tr>
                    </tbody>
                  </table>

                  <br>

                  <div class="row">
                    <div class="col-sm-6">
                      <div class="col-12 col-md-12 d-flex flex-column">
                        <label for="source" class="col-form-label col-form-label-sm labelFont">MV Penalty</label>
                        <div>
                          <b> <label v-if="mvPenaltyEnable == 'Y' && penaltyApplied == 'Y'" for="source"
                              class="col-form-label col-form-label-sm text-danger">$ {{
                                parseFloat(mvPenalityFee).toFixed(2) }}</label>
                            <label v-if="mvPenaltyEnable == 'Y' && penaltyApplied == 'N'" for="source"
                              class="col-form-label col-form-label-sm text-success">$ {{ mvPenalityFee }}</label></b>
                        </div>
                      </div>
                    </div>
                  </div><br>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">Actual Fee Paid for DMV Service Provider</h5>
                          <br>
                          <div class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                            <div class="col-12 col-md-12 d-flex ">
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == ''">
                                <div class="input-group">
                                  <input type="text" name="checknumber" class="input-create" @change="dmvValidation"
                                    @click="clearMessages" v-model="deal.checkNumber" autocomplete="nope" required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create">Check Number</label>
                                </div>
                              </div>
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == 'required'">
                                <div class="input-group">
                                  <input type="text" name="checknumber" class="input-create" @click="clearMessages"
                                    data-vv-name="Check Number" v-validate="'required'" v-model="deal.checkNumber"
                                    autocomplete="nope" required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create required">Check Number</label>
                                  <div v-if="errors.has('Check Number')" class="alert-danger">
                                    {{ errors.first("Check Number") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-12 ">

                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == ''">
                                <div class="input-group">
                                  <small class="small-label">Check Date</small>
                                  <date-picker type="date" name="oldTitle" @click="clearMessages" format="MM/DD/YYYY"
                                    v-model="deal.checkDate" @change="dmvValidation" class="input-create dob"
                                    valuetype="format" autocomplete="nope" />
                                  <span class="bar"></span>
                                </div>
                              </div>
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == 'required'">
                                <div class="input-group">
                                  <small class="small-label required">Check Date</small>
                                  <date-picker type="date" format="MM/DD/YYYY" @click="clearMessages" name="oldTitle"
                                    v-model="deal.checkDate" data-vv-name="Check Date" v-validate="'required'"
                                    class="input-create dob" valuetype="format" autocomplete="nope" />
                                  <span class="bar"></span>
                                  <div v-if="errors.has('Check Date')" class="alert-danger">
                                    {{ errors.first("Check Date") }}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                            <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == ''">
                              <div class="input-group">
                                <input type="text" name="checknumber" @change="dmvValidation" @click="clearMessages"
                                  v-model="deal.checkPayableTo" class="input-create" autocomplete="nope" required />
                                <span class="bar"></span>
                                <label for="source" class="label-create">Check Payable to</label>
                              </div>
                            </div>
                            <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="dmvValidate == 'required'">
                              <div class="input-group">
                                <input type="text" name="checknumber" @click="clearMessages"
                                  data-vv-name="Check Payable to" v-validate="'required'" v-model="deal.checkPayableTo"
                                  class="input-create" autocomplete="nope" required />
                                <span class="bar"></span>
                                <label for="source" class="label-create required">Check Payable to</label>
                                <div v-if="errors.has('Check Payable to')" class="alert-danger">
                                  {{ errors.first("Check Payable to") }}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                          <div class="col-12 col-md-12 d-flex ">
                            <div style="display: flex" class="col-12">
                              <div style="margin-top: 5%">$</div>
                              <div class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          " v-if="dmvValidate == ''">
                                <div class="input-group">
                                  <input type="text" name="oldTitle" class="input-create" v-model="deal.amount"
                                    @click="clearMessages" @change="getOwnedAmountData" autocomplete="nope"
                                    onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                                    required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create">Amount</label>
                                </div>
                              </div>
                              <div class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          " v-if="dmvValidate == 'required'">
                                <div class="input-group">
                                  <input type="text" name="oldTitle" data-vv-name="Amount" v-validate="'required'"
                                    class="input-create" v-model="deal.amount" @click="clearMessages"
                                    @change="getOwnedAmountData" autocomplete="nope"
                                    onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                                    required />
                                  <span class="bar"></span>

                                  <label for="source" class="label-create required">Amount</label>
                                  <div v-if="errors.has('Amount')" class="alert-danger">
                                    {{ errors.first("Amount") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    <!--<div class="col-sm-6">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Payback to Lesse</h5>
       <br>
       <div
                    class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                     <div class="col-12 col-md-12">
                      <div
                        class="
                          col-13 col-md-13
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @change="lesseeValidation"
                            @click="clearMessages"
                            class="input-create"
                            v-model="deal.lesseeCheckNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Number</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Number"
                            class="input-create"
                            v-validate="'required'"
                            v-model="deal.lesseeCheckNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Number</label
                          >
                          <div
                            v-if="errors.has('Lessee Check Number')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Number") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 ">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <small class="small-label">Check Date</small>
                          <date-picker
                            type="date"
                            name="oldTitle"
                            @click="clearMessages"
                            format="MM/DD/YYYY"
                            @change="lesseeValidation"
                            v-model="deal.lesseeCheckDate"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <small class="small-label required">Check Date</small>
                          <date-picker
                            type="date"
                            name="oldTitle"
                            format="MM/DD/YYYY"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Date"
                            v-model="deal.lesseeCheckDate"
                            v-validate="'required'"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                          <div
                            v-if="errors.has('Lessee Check Date')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Date") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  
                  <div
                    class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                    <div class="col-12 col-md-12 ">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            @change="lesseeValidation"
                            class="input-create"
                            v-model="deal.lesseeCheckPayableTo"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Payable to</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Payable to"
                            v-validate="'required'"
                            class="input-create"
                            v-model="deal.lesseeCheckPayableTo"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Payable to</label
                          >
                          <div
                            v-if="errors.has('Lessee Check Payable to')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Payable to") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                   <div
                    class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
<div class="col-12 col-md-12 ">
                      <div style="display: flex">
                        <div style="margin-top: 5%">$</div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="lesseeValidate == ''"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              v-model="deal.lesseeAmount"
                              @click="clearMessages"
                              class="input-create"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>
                            <label for="source" class="label-create"
                              >Amount</label
                            >
                          </div>
                        </div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="lesseeValidate == 'required'"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              data-vv-name="Lessee Amount"
                              v-validate="'required'"
                              @click="clearMessages"
                              v-model="deal.lesseeAmount"
                              class="input-create"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>
                            <label for="source" class="label-create required"
                              >Amount</label
                            >
                            <div
                              v-if="errors.has('Lessee Amount')"
                              class="alert-danger"
                            >
                              {{ errors.first("Lessee Amount") }}
                            </div>
                          </div>
                        </div>
                      </div>
					  </div>
					  </div>

      </div>
    </div>
  </div>-->
                  </div>
                  <br>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="card">
                        <div class="card-body">
                          <h5 class="card-title">Refund to Lessee</h5>
                          <br>
                          <div class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                            <div class="col-12 col-md-12">
                              <div class="
                          col-13 col-md-13
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == ''">
                                <div class="input-group">
                                  <input type="text" name="checknumber" @change="lesseeValidation" @click="clearMessages"
                                    class="input-create" v-model="deal.lesseeCheckNumber" autocomplete="nope" required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create">Check Number</label>
                                </div>
                              </div>
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == 'required'">
                                <div class="input-group">
                                  <input type="text" name="checknumber" @click="clearMessages"
                                    data-vv-name="Lessee Check Number" class="input-create" v-validate="'required'"
                                    v-model="deal.lesseeCheckNumber" autocomplete="nope" required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create required">Check Number</label>
                                  <div v-if="errors.has('Lessee Check Number')" class="alert-danger">
                                    {{ errors.first("Lessee Check Number") }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-12 ">
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == ''">
                                <div class="input-group">
                                  <small class="small-label">Check Date</small>
                                  <date-picker type="date" name="oldTitle" @click="clearMessages" format="MM/DD/YYYY"
                                    @change="lesseeValidation" v-model="deal.lesseeCheckDate" class="input-create dob"
                                    valuetype="format" autocomplete="nope" />
                                  <span class="bar"></span>
                                </div>
                              </div>
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == 'required'">
                                <div class="input-group">
                                  <small class="small-label required">Check Date</small>
                                  <date-picker type="date" name="oldTitle" format="MM/DD/YYYY" @click="clearMessages"
                                    data-vv-name="Lessee Check Date" v-model="deal.lesseeCheckDate"
                                    v-validate="'required'" class="input-create dob" valuetype="format"
                                    autocomplete="nope" />
                                  <span class="bar"></span>
                                  <div v-if="errors.has('Lessee Check Date')" class="alert-danger">
                                    {{ errors.first("Lessee Check Date") }}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                            <div class="col-12 col-md-12 ">
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == ''">
                                <div class="input-group">
                                  <input type="text" name="checknumber" @click="clearMessages" @change="lesseeValidation"
                                    class="input-create" v-model="deal.lesseeCheckPayableTo" autocomplete="nope"
                                    required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create">Check Payable to</label>
                                </div>
                              </div>
                              <div class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        " v-if="lesseeValidate == 'required'">
                                <div class="input-group">
                                  <input type="text" name="checknumber" @click="clearMessages"
                                    data-vv-name="Lessee Check Payable to" v-validate="'required'" class="input-create"
                                    v-model="deal.lesseeCheckPayableTo" autocomplete="nope" required />
                                  <span class="bar"></span>
                                  <label for="source" class="label-create required">Check Payable to</label>
                                  <div v-if="errors.has('Lessee Check Payable to')" class="alert-danger">
                                    {{ errors.first("Lessee Check Payable to") }}
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="
                      row row-cols-lg-1 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    ">
                            <div class="col-12 col-md-12 ">
                              <div style="display: flex">
                                <div style="margin-top: 5%">$</div>
                                <div class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          " v-if="lesseeValidate == ''">
                                  <div class="input-group">
                                    <input type="text" name="oldTitle" v-model="deal.lesseeAmount"
                                      @change="getOwnedAmountData" @click="clearMessages" class="input-create"
                                      autocomplete="nope"
                                      onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                                      required />
                                    <span class="bar"></span>
                                    <label for="source" class="label-create">Amount</label>
                                  </div>
                                </div>
                                <div class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          " v-if="lesseeValidate == 'required'">
                                  <div class="input-group">
                                    <input type="text" name="oldTitle" data-vv-name="Lessee Amount"
                                      v-validate="'required'" @click="clearMessages" v-model="deal.lesseeAmount"
                                      @change="getOwnedAmountData" class="input-create" autocomplete="nope"
                                      onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                                      required />
                                    <span class="bar"></span>
                                    <label for="source" class="label-create required">Amount</label>
                                    <div v-if="errors.has('Lessee Amount')" class="alert-danger">
                                      {{ errors.first("Lessee Amount") }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <!--  <div
                    class="row row-cols-lg-3 row-cols-md-3 row-cols-sm-1 row-cols-1 p-1"
                  >
                    <div class="col-12 col-md-12 d-flex">
                      <span>
                        <b>Actual Fee Paid for DMV Service Provider</b>
                      </span>
                    </div>
                    <div class="col-12 col-md-12">
                      <nav>
                        <span>
                          <b>Payback to Lesse</b>
                        </span>
                      </nav>
                    </div>
                  </div>

                  <div
                    class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                    <div class="col-12 col-md-12 d-flex border-right">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            class="input-create"
                            @change="dmvValidation"
                            @click="clearMessages"
                            v-model="deal.checkNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Number</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            class="input-create"
                            @click="clearMessages"
                            data-vv-name="Check Number"
                            v-validate="'required'"
                            v-model="deal.checkNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Number</label
                          >
                          <div
                            v-if="errors.has('Check Number')"
                            class="alert-danger"
                          >
                            {{ errors.first("Check Number") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 border-left">
                      <div
                        class="
                          col-13 col-md-13
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @change="lesseeValidation"
                            @click="clearMessages"
                            class="input-create"
                            v-model="deal.lesseeCheckNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Number</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Number"
                            class="input-create"
                            v-validate="'required'"
                            v-model="deal.lesseeCheckNumber"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Number</label
                          >
                          <div
                            v-if="errors.has('Lessee Check Number')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Number") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div
                    class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                    <div class="col-12 col-md-12 d-flex border-right">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @change="dmvValidation"
                            @click="clearMessages"
                            v-model="deal.checkPayableTo"
                            class="input-create"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Payable to</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            data-vv-name="Check Payable to"
                            v-validate="'required'"
                            v-model="deal.checkPayableTo"
                            class="input-create"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Payable to</label
                          >
                          <div
                            v-if="errors.has('Check Payable to')"
                            class="alert-danger"
                          >
                            {{ errors.first("Check Payable to") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 border-left">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            @change="lesseeValidation"
                            class="input-create"
                            v-model="deal.lesseeCheckPayableTo"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create"
                            >Check Payable to</label
                          >
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <input
                            type="text"
                            name="checknumber"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Payable to"
                            v-validate="'required'"
                            class="input-create"
                            v-model="deal.lesseeCheckPayableTo"
                            autocomplete="nope"
                            required
                          />
                          <span class="bar"></span>
                          <label for="source" class="label-create required"
                            >Check Payable to</label
                          >
                          <div
                            v-if="errors.has('Lessee Check Payable to')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Payable to") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                    <div class="col-12 col-md-12 d-flex border-right">
                      <div style="display: flex" class="col-12">
                        <div style="margin-top: 5%">$</div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="dmvValidate == ''"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              class="input-create"
                              v-model="deal.amount"
                              @click="clearMessages"
                              @change="getOwnedAmountData"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>
                            <label for="source" class="label-create"
                              >Amount</label
                            >
                          </div>
                        </div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="dmvValidate == 'required'"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              data-vv-name="Amount"
                              v-validate="'required'"
                              class="input-create"
                              v-model="deal.amount"
                              @click="clearMessages"
                              @change="getOwnedAmountData"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>

                            <label for="source" class="label-create required"
                              >Amount</label
                            >
                            <div
                              v-if="errors.has('Amount')"
                              class="alert-danger"
                            >
                              {{ errors.first("Amount") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 border-left">
                      <div style="display: flex">
                        <div style="margin-top: 5%">$</div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="lesseeValidate == ''"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              v-model="deal.lesseeAmount"
                              @click="clearMessages"
                              class="input-create"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>
                            <label for="source" class="label-create"
                              >Amount</label
                            >
                          </div>
                        </div>
                        <div
                          class="
                            col-12 col-md-12
                            d-flex
                            justify-content-lg-end
                            align-items-center
                          "
                          v-if="lesseeValidate == 'required'"
                        >
                          <div class="input-group">
                            <input
                              type="text"
                              name="oldTitle"
                              data-vv-name="Lessee Amount"
                              v-validate="'required'"
                              @click="clearMessages"
                              v-model="deal.lesseeAmount"
                              class="input-create"
                              autocomplete="nope"
                              onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                              required
                            />
                            <span class="bar"></span>
                            <label for="source" class="label-create required"
                              >Amount</label
                            >
                            <div
                              v-if="errors.has('Lessee Amount')"
                              class="alert-danger"
                            >
                              {{ errors.first("Lessee Amount") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      row row-cols-lg-2 row-cols-md-3 row-cols-sm-1 row-cols-1
                      p-1 mt-2
                    "
                  >
                    <div class="col-12 col-md-12 d-flex border-right">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == ''"
                      >
                        <div class="input-group">
                          <small class="small-label">Check Date</small>
                          <date-picker
                            type="date"
                            name="oldTitle"
                            @click="clearMessages"
                            format="MM/DD/YYYY"
                            v-model="deal.checkDate"
                            @change="dmvValidation"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="dmvValidate == 'required'"
                      >
                        <div class="input-group">
                          <small class="small-label required">Check Date</small>
                          <date-picker
                            type="date"
                            format="MM/DD/YYYY"
                            @click="clearMessages"
                            name="oldTitle"
                            v-model="deal.checkDate"
                            data-vv-name="Check Date"
                            v-validate="'required'"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                          <div
                            v-if="errors.has('Check Date')"
                            class="alert-danger"
                          >
                            {{ errors.first("Check Date") }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 border-left">
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == ''"
                      >
                        <div class="input-group">
                          <small class="small-label">Check Date</small>
                          <date-picker
                            type="date"
                            name="oldTitle"
                            @click="clearMessages"
                            format="MM/DD/YYYY"
                            @change="lesseeValidation"
                            v-model="deal.lesseeCheckDate"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                        </div>
                      </div>
                      <div
                        class="
                          col-12 col-md-12
                          d-flex
                          justify-content-lg-end
                          align-items-center
                        "
                        v-if="lesseeValidate == 'required'"
                      >
                        <div class="input-group">
                          <small class="small-label required">Check Date</small>
                          <date-picker
                            type="date"
                            name="oldTitle"
                            format="MM/DD/YYYY"
                            @click="clearMessages"
                            data-vv-name="Lessee Check Date"
                            v-model="deal.lesseeCheckDate"
                            v-validate="'required'"
                            class="input-create dob"
                            valuetype="format"
                            autocomplete="nope"
                          />
                          <span class="bar"></span>
                          <div
                            v-if="errors.has('Lessee Check Date')"
                            class="alert-danger"
                          >
                            {{ errors.first("Lessee Check Date") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>-->
                  <br />
                  <center>
                    <button type="submit" class="btn btn-secondary mr-3" @click="saveTitle(selecteddmvid)"
                      :disabled="dmvOrLlpDisbale">
                      Submit
                    </button>
                    <button type="submit" class="btn btn-secondary mr-3" @click="displayAllDeals">
                      Back
                    </button>
                  </center>
                  <br />
                  <br />
                  <br />

                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="lesseeinfotab">
                <div>
                  <nav>
                    <span>
                      <b>Lessee Information</b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Name</label>
                    <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                      deal.selectedLesseeName }}</label>
                  </div>

                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Lessee Address</label>

                    <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                      deal.selectedLesseeAddress }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">City</label>

                    <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                      deal.selectedLesseeCity }}</label>
                  </div>
                </div>
                <div role="tabpanel" class="tab-pane" id="lesseeinfotab">
                  <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" class="col-form-label col-form-label-sm labelFont">State</label>

                      <p for="Date title received from dealer" class="col-form-label col-form-label-sm">
                        {{ deal.selectedLesseeState }}
                      </p>
                    </div>
                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" class="col-form-label col-form-label-sm labelFont">Zip</label>

                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.selectedLesseeZip }}</label>
                    </div>
                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" class="col-form-label col-form-label-sm labelFont">Phone</label>

                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.selectedLesseePhone }}</label>
                    </div>
                  </div>
                  <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" class="col-form-label col-form-label-sm labelFont">Email</label>

                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.selectedLesseeEmail }}</label>
                    </div>
                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" class="col-form-label col-form-label-sm labelFont">Additional Email</label>

                      <label for="Date title received from dealer" class="col-form-label col-form-label-sm">{{
                        deal.additionalEmail }}</label>
                    </div>


                    <div class="col-12 col-md-12 d-flex flex-column">
                      <label for="source" style="color:green;"
                        class="col-form-label col-form-label-sm labelFont">County</label>

                      <center>
                        <span :style="msgOwnedcolor">{{ countyMessage }}</span>
                      </center>

                      <!--   <input type="text" v-model="deal.registrationCounty "
                        for="Date title received from dealer"
                        class="col-form-label col-form-label-sm"
                        >
                    </div>-->

                      <label for="source" class="col-form-label col-form-label-sm" v-if="countyLesseEnable == false"> <img
                          @click="enableLesseCounty" src="../assets/new_pen.png" style="height:30px;width: 15%;margin-top : 1%;
  border-radius: 10px;padding : 0px;" class="blur" />{{ deal.registrationCounty }}</label>

                      <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="countyLesseEnable == true">
                        <input v-model="deal.registrationCounty" type="text" id="PickList_Options" name="PickList_Options"
                          value="" class="form-control input-sm">
                        <button @click="saveCounty" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                            class="blur" /></button>&nbsp;
                        <button @click="disableLesseCounty" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                      </div>
                    </div>
                  </div>
                  <div>
                    <nav>
                      <span>
                        <b>Dealer Information</b>
                      </span>
                    </nav>
                  </div>

                  <div>
                    <div class="row no-gutters p-2 justify-content-center rowWrap">
                      <div class="col">
                        <div class="table-responsive table-responsive-sm" style="height: 387px; overflow: auto">
                          <v-table id="myappsTable" :data="dmvTitleDataList" :currentPage.sync="currentPage"
                            :pageSize="50" @totalPagesChanged="totalPages = $event"
                            class="table table-sm table-bordered table-striped">
                            <thead class="table-month-header-blue wrap-text" slot="head">
                              <v-th sortKey="dealerName">Dealer Name</v-th>
                              <v-th sortKey="firstName">First Name</v-th>
                              <v-th sortKey="middleName">Middle Name</v-th>
                              <v-th sortKey="lastName">Last Name</v-th>
                              <v-th sortKey="contactTitle">Contact Title</v-th>
                              <v-th sortKey="workNumber">Work Number</v-th>
                              <v-th sortKey="mobileNumber">Mobile Number</v-th>
                              <v-th sortKey="faxNumber">Fax Number</v-th>
                              <v-th sortKey="email">Email</v-th>
                              <v-th sortKey="contactType">Contact Type</v-th>
                            </thead>
                            <tbody slot="body" slot-scope="{ displayData }">
                              <tr v-for="(deal, index) in dmvDealerContactsList" class="col-form-label col-form-label-sm">
                                <td>{{ deal.dealerName }}</td>
                                <td>{{ deal.firstName }}</td>
                                <td>{{ deal.middleName }}</td>
                                <td>{{ deal.lastName }}</td>
                                <td>{{ deal.contactTitle }}</td>
                                <td>{{ deal.workNumber }}</td>
                                <td>{{ deal.mobileNumber }}</td>
                                <td>{{ deal.faxNumber }}</td>
                                <td>{{ deal.email }}</td>
                                <td>{{ deal.contactType }}</td>
                              </tr>
                            </tbody>
                          </v-table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <center>
                    <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                      Back
                    </button>
                  </center>
                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="vehicleinfotab">
                <div>
                  <nav>
                    <span>
                      <b>Vehicle Information</b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Year</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.selectedYear }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Make</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.selectedMake }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Model</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.selectedModel }}</label>
                  </div>
                </div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont" style="color:green;">Trim
                      Style</label>

                    <label for="source" class="col-form-label col-form-label-sm" v-if="trimEnable == false"
                      @click="enableTrim">{{ vinaudit.trim }}</label>
                    <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="trimEnable == true">
                      <input v-model="vinaudit.trim" type="text" id="PickList_Options" name="PickList_Options" value=""
                        class="form-control input-sm">
                      <button @click="saveCurbWeight" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                          class="blur" /></button>&nbsp;
                      <button @click="disableTrim" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Color</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.selectedColor }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <center>
                      <span :style="msgOwnedcolor">{{ mileageMessage }}</span>
                    </center>


                    <label for="source" class="col-form-label col-form-label-sm labelFont"
                      style="color:green;">Mileage</label>

                    <label for="source" class="col-form-label col-form-label-sm" v-if="milesEnable == false"
                      @click="enableMileage">{{ deal.milesReported }}</label>
                    <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="milesEnable == true">
                      <input v-model="deal.milesReported" type="text" id="PickList_Options" name="PickList_Options"
                        value="" class="form-control input-sm">
                      <button @click="saveMileage" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                          class="blur" /></button>&nbsp;
                      <button @click="diasableMileage" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                    </div>
                  </div>
                </div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">VIN</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.selectedVin }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <center>
                      <span :style="msgOwnedcolor">{{ curbWeightMessage }}</span>
                    </center>
                    <label for="source" class="col-form-label col-form-label-sm labelFont" style="color:green;">Curb
                      Weight</label>

                    <label for="source" class="col-form-label col-form-label-sm" v-if="curbWeightEnable == false"
                      @click="enableCurbWeight">{{ vinaudit.curbWeight }}</label>
                    <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="curbWeightEnable == true">
                      <input v-model="vinaudit.curbWeight" type="text" id="PickList_Options" name="PickList_Options"
                        value="" class="form-control input-sm"
                        onkeypress="return !(event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                      <button @click="saveCurbWeight" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                          class="blur" /></button>&nbsp;
                      <button @click="disableCurbWeight" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" style="color:green;"
                      class="col-form-label col-form-label-sm labelFont">Cylinder</label>

                    <center>
                      <span :style="msgOwnedcolor">{{ cylinderMessage }}</span>
                    </center>

                    <!--   <input type="text" v-model="deal.registrationCounty "
                        for="Date title received from dealer"
                        class="col-form-label col-form-label-sm"
                        >
                    </div>-->

                    <label for="source" class="col-form-label col-form-label-sm" v-if="cylinderEnable == false"
                      @click="enableCylinder">{{ vinaudit.cylinders }}</label>

                    <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="cylinderEnable == true">
                      <input v-model="vinaudit.cylinders" type="text" id="PickList_Options" name="PickList_Options"
                        value="" class="form-control input-sm">
                      <button @click="saveCylinder" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                          class="blur" /></button>&nbsp;
                      <button @click="disableCylinder" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                    </div>
                  </div>
                </div>
                <center>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                </center>
              </div>
              <div role="tabpanel" class="tab-pane" id="documentstab">
                <div>
                  <nav>
                    <span>
                      <b>Documents</b>
                    </span>
                  </nav>
                </div>
                <center>
                  <span :style="msgcolor">
                    <b>{{ responseMessage }}</b>
                  </span>
                </center>

                <div id="getdoc" class="modal">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2> No Documents Available</h2>
                    </div>
                    <br />
                    <div class="modal-footer">
                      <button class="btn-blue-save nextButton" @click="clearModal()">
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Document Title</th>
                      <th scope="col">Select File</th>
                      <th scope="col">Upload</th>
                      <th scope="col">Received Date</th>
                      <th scope="col">View Document</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <div class="d-flex align-items-center" v-if="allDocs == 'Y'">
                    <strong>Loading...</strong>
                    <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                  </div>
                  <div id="uploaddoc" class="modal">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h2> uploading Document Please wait ...</h2>
                      </div>
                      <br />
                    </div>
                  </div>
                  <tbody v-for="(link, index) in links">
                    <tr class="col-form-label col-form-label-sm">
                      <!-- <td>{{link.split("/")[5].split("?")[0].split(".")[0]}}</td>
                        <td><a href="#" @click = "myFunction(link)">View</a></td>-->
                      <td>{{ link.docName }}</td>
                      <td>
                        <input type="file" @change="onFileSelected" name="UploadFile" :id="'UploadFile' + index"
                          class="form-control input-sm" :ref="'file' + index" />
                      </td>
                      <td>
                        <button type="submit" class="btn btn-secondary" @click="
                          uploadDocuments(
                            link.docName,
                            link.docId,
                            index
                          )
                          ">
                          upload
                        </button>
                      </td>
                      <td>
                        {{
                          link.docReceivedDate | moment("MM/DD/YYYY HH:mm:ss")
                        }}
                      </td>
                      <td v-if="link.dropboxUrl.length != 0">
                        <span v-for="(url, index) in link.dropboxUrl"><a href="#"
                            @click="myFunction(url.url)">{{ url.fileName.split(".")[0] }}</a><span
                            v-if="link.dropboxUrl.length > 1 && link.dropboxUrl.length - 1 != index"
                            style="padding: 2%;">|</span></span>
                      </td>
                      <td v-if="link.dropboxUrl.length != 0">
                        <span style="color:blue;">
                          <b>Document Uploaded</b>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!--   <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm required">Attach Doc's</label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                    <input type="file"  @change="onFileSelected" id="UploadFile" class="form-control input-sm" ref="file"/>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm required">Document Type</label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                   <select class="form-control input-sm" v-model="documentName" @click="clearMessages">
         <option disabled value="">Please select one</option>
        <option v-for="(option,index) in dmvDocsRequiredList" v-bind:key="index">{{option.docName}}</option>
         
     </select>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm"></label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                    <button type="submit" class="btn btn-secondary" @click="uploadDocuments">upload</button>
                      
                  </div>
                 
                </div> -->
                <div v-if="selectedDealData[0].dealbookRegistrationState != null ||
                  selectedDealData[0].dealbookRegistrationState != ''
                  ">
                  <nav>
                    <span>
                      <b class="navbar navbar-expand-lg bg-info text-white">State DMV Forms</b>
                    </span>
                  </nav>
                </div>
                <table class="table" v-if="selectedDealData[0].dealbookRegistrationState != null ||
                  selectedDealData[0].dealbookRegistrationState != ''
                  ">
                  <thead>
                    <tr>
                      <th scope="col">File Name</th>
                      <th scope="col">DMV Form</th>
                      <th scope="col">Last Modified Date</th>
                      <th scope="col">Action</th>
                      <!-- <th scope="col">Choose File</th>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="col-form-label col-form-label-sm" v-for="(linkUrl, index) in link">
                      <td>
                        {{ linkUrl.fileName.split("/")[2].replace(".pdf", "") }}
                      </td>
                      <td>
                        <span><a href="#" @click="myFunction(linkUrl.url)">View DMV Form</a></span>
                      </td>
                      <td>{{ linkUrl.lastModifiedDate | moment("MM/DD/YYYY HH:mm:ss") }}</td>
                      <td>
                        <button type="submit" style="margin-left : 4%;" class="btn btn-secondary"
                          @click="deleteStateForm(linkUrl.fileName)">
                          Delete
                        </button>
                      </td>
                      <!-- <td>
                        <input
                          type="file"
                          @change="onFileSelectedForm"
                          name="UploadFileForm"
                          :id="'UploadFileForm'"
                          class="form-control input-sm"
                          :ref="'fileForm'" 
                        />
                      </td>-->
                    </tr>
                    <tr v-if="enableDmvForm == 'Y'">

                      <td><input type="file" @change="onFileSelectedForm" name="UploadFileForm" :id="'UploadFileForm'"
                          class="form-control input-sm" :ref="'fileForm'" /></td>
                      <td></td>
                      <td></td>
                      <td> <button type="submit" style="margin-left : 4%;" class="btn btn-secondary"
                          @click="displayDisableDMVForm">
                          Remove
                        </button></td>
                    </tr>
                  </tbody>
                </table>
                <center>
                  <!--<button type="submit"  class="btn btn-secondary" @click="download" v-if="links.length != 0">Launch DMV FORM</button>-->
                  <button type="submit" style="margin-left : 4%;" class="btn btn-secondary" @click="uploadStateForm">
                    Upload
                  </button>
                  <button type="submit" style="margin-left : 4%;" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                  <button type="submit" style="margin-left : 4%;" class="btn btn-secondary" @click="displayEnableDMVForm">
                    Add
                  </button>
                </center>
              </div>


              <div role="tabpanel" class="tab-pane" id="financialstab">
                <div>
                  <nav>
                    <span>
                      <b>Financials</b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Customer Doc's</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input type="textbox" class="form-control input-sm" />
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Need To See</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input type="textbox" class="form-control input-sm" />
                  </div>
                </div>
                <center>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                </center>
              </div>
              <div role="tabpanel" class="tab-pane" id="dealerService">
                <div>
                  <nav>
                    <span>
                      <b>Dealer Service</b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Select Title Service</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <select class="form-control input-sm"></select>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">DMV Forms</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input type="textbox" class="form-control input-sm" />
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Checklist Need to Fulfill</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input type="textbox" class="form-control input-sm" />
                  </div>
                </div>
                <center>
                  <button type="submit" class="btn btn-secondary mr-3">
                    Save
                  </button>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                </center>
              </div>
              <div role="tabpanel" class="tab-pane" id="motorVehicle">
                <div>
                  <nav>
                    <div class="heading"><span> <b>MV WORK</b></span></div>

                  </nav>
                </div>
                <center :style="msgcolor">{{ manageTitle.message }}</center>
                <div v-if="manageQuoteIdList.length != 0">
                  <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      Select Quote
                    </div>
                    <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                      <select v-model="manageTitle.selectedQuote" @change="getManageQuote(manageTitle.selectedQuote)"
                        :disabled="disabledropdown">
                        <option disabled value=""> Select a Quote </option>
                        <option v-for="(option, index) in manageQuoteIdList" v-bind:key="index">{{ option.manageQuoteid }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">State Of Registration</label>

                    <label for="source" class="col-form-label col-form-label-sm">{{ deal.dealbookRegistrationState
                    }}</label>
                  </div>

                </div>
                <div class="
                    row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2
                    p-2
                    mb-3
                  ">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">MV Penalty</label>

                    <b> <label v-if="mvPenaltyEnable == 'Y' && penaltyApplied == 'Y'" for="source"
                        class="col-form-label col-form-label-sm text-danger">$ {{
                          parseFloat(mvPenalityFee).toFixed(2) }}</label>
                      <label v-if="mvPenaltyEnable == 'Y' && penaltyApplied == 'N'" for="source"
                        class="col-form-label col-form-label-sm text-success">$ {{ mvPenalityFee }}</label></b>

                  </div>
                </div>


                <div>
                  <nav>
                    <span>
                      <b>
                        Registered Address
                        <Address></Address>
                      </b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input style="font-size:90%;" type="text" name="oldTitle" data-vv-as="Old Title"
                        data-vv-scope="manageTitle" class="input-create"
                        v-model.trim="manageTitle.registrationAddressStreet1" autocomplete="nope" required />
                      <span class="bar"></span>
                      <label for="source" class="label-create">Address Line1</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input style="font-size:90%;" type="text" name="oldTitle" data-vv-as="Old Title"
                        data-vv-scope="manageTitle" class="input-create"
                        v-model.trim="manageTitle.registrationAddressCity" autocomplete="nope" required />
                      <span class="bar"></span>
                      <label for="source" class="label-create">City</label>
                    </div>
                  </div>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input style="font-size:90%;" type="text" name="oldTitle" data-vv-as="Old Title"
                        data-vv-scope="manageTitle" class="input-create"
                        v-model.trim="manageTitle.registrationAddressState" autocomplete="nope" required />
                      <span class="bar"></span>
                      <label for="source" class="label-create">State</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input style="font-size:90%;" type="text" maxlength="5" class="input-create"
                        v-model.trim="manageTitle.registrationAddressZipcode"
                        onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                        autocomplete="nope" />
                      <span class="bar"></span>
                      <label for="source" class="label-create">Zip Code</label>
                      <div v-if="errors.has('Zip Code')" class="alert-danger">
                        {{ errors.first("Zip Code") }}
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">

                    <div class="input-group">
                      <input style="font-size:90%;" type="text" name="oldTitle" data-vv-as="Old Title"
                        data-vv-scope="manageTitle" class="input-create"
                        v-model.trim="manageTitle.registrationAddressCountry" autocomplete="nope" disabled />
                      <span class="bar"></span>
                      <label class="label-create">Country</label>
                    </div>
                  </div>

                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" style="color:green;"
                      class="col-form-label col-form-label-sm labelFont">County</label>

                    <center>
                      <span :style="msgOwnedcolor">{{ countyMessage }}</span>
                    </center>

                    <!--   <input type="text" v-model="deal.registrationCounty "
                        for="Date title received from dealer"
                        class="col-form-label col-form-label-sm"
                        >
                    </div>-->

                    <label for="source" class="col-form-label col-form-label-sm" v-if="countyEnable == false"><img
                        @click="enableCounty" src="../assets/new_pen.png" style="height:30px;width: 15%;margin-top : 1%;
  border-radius: 10px;padding : 0px;" class="blur" />{{ deal.registrationCounty }}</label>

                    <div class="col-sm-12 buttonwrapper" style="padding: 0px;" v-if="countyEnable == true">
                      <input v-model="deal.registrationCounty" type="text" id="PickList_Options" name="PickList_Options"
                        value="" class="form-control input-sm">
                      <button @click="saveCounty" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;"> <img src="../assets/check.png" style="height:20px;"
                          class="blur" /></button>&nbsp;
                      <button @click="disableCounty" style="width: 30%;margin-top : 4%;border: 1px solid #DADDDE;
  border-radius: 10px;padding : 0px;">X</button>
                    </div>
                  </div>
                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label v-show="hideLLPDoingQuoteDate && hideQuoteDate" for="source"
                      class="col-form-label col-form-label-sm labelFont">Quote Date</label>

                    <label v-show="hideLLPDoingQuoteDate && hideQuoteDate" for="source"
                      class="col-form-label col-form-label-sm">{{ manageTitle.quoteDate | moment("MM/DD/YYYY") }}</label>
                  </div>

                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex flex-column ">
                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm labelFont">Quote
                      Requested Date</label>

                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm">{{
                      manageTitle.quoteDate | moment("MM/DD/YYYY")
                    }}</label>
                  </div>


                  <div class="col-12 col-md-12 d-flex flex-column">
                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm labelFont">Quote
                      Accepted Date</label>

                    <label v-show="hideQuoteDate" for="source" class="col-form-label col-form-label-sm">{{
                      manageTitle.acceptedDate | moment("MM/DD/YYYY")
                    }}</label>
                  </div>


                  <div class="col-12 col-md-12 d-flex flex-column ">
                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm labelFont">MV Work
                      Accepted</label>

                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm">{{
                      manageTitle.mvWorkSentDate | moment("MM/DD/YYYY")
                    }}</label>
                  </div>

                  <div class="col-12 col-md-12 d-flex flex-column ">
                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm labelFont">MV Work
                      Package Sent</label>

                    <label for="source" v-show="hideQuoteDate" class="col-form-label col-form-label-sm">{{
                      manageTitle.mvWorkPackageSentDate | moment("MM/DD/YYYY")
                    }}</label>
                  </div>

                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">


                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group mb-0.5" v-show="hideQuoteDate">
                      <small class="small-label title_fields required">Service Provider</small>
                      <div v-if="this.registeredServiceProvider.length != 0">
                        <multiselect style="font-size: 12px" v-model="manageTitle.serviceCompanyId"
                          :options="registeredServiceProvider" :value="registeredServiceProvider.StateVehicleId"
                          label="ServiceName" @select="getServiceProviderDetails(manageTitle.serviceCompanyId)"
                          selected="selected" class="input-create dob" disabled></multiselect>
                        <span class="bar"></span>
                      </div>
                      <div v-else>
                        <input type="text" disabled placeholder="No data available" />
                      </div>
                    </div>

                  </div>

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">

                    <input v-show="hideQuoteDate"
                      v-if="this.serviceProviderStatesList.length != 0 && manageTitle.mailSentDate != null" type="checkbox"
                      class="mr-1" :disabled="manageTitle.mvWorkSentDate != null" id="chkService"
                      @click="EnableDisableService()" />

                    <div class="input-group mb-0.5" v-show="hideQuoteDate">
                      <small class="small-label title_fields">Select Another serviceProvider</small>
                      <div v-if="this.serviceProviderStatesList.length != 0">

                        <select id="statesdd" @change="getServiceProviderDetails(manageTitle.anotherServiceCompanyId)"
                          :disabled="disableAnotherServiceProvider" v-model="manageTitle.anotherServiceCompanyId">
                          <option value="" disabled selected>Select Another Service Provider</option>
                          <option v-for="(option, index) in serviceProviderStatesList" :value="option.StateVehicleID"
                            :key="index">{{ option.ServiceName }}</option>
                        </select>

                        <span class="bar"></span>
                      </div>
                      <div v-else>
                        <input type="text" disabled placeholder="No data available" />
                      </div>
                    </div>


                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                    v-if="contactEmails.length != 0 && this.registeredServiceProvider.length != 0" v-show="hideQuoteDate">
                    <div>
                      <div v-show="hideQuoteDate" class="input-group mb-0.5" style="font-size:90%;">
                        <small class="small-label title_fields required">Select Contact Email</small>


                        <div v-for="(email, index) in contactEmails">
                          <div>
                            <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                              <input type="checkbox" class="mr-1 " :value="email" name="serviceProviderEmails"
                                :id="'email' + index" v-model="serviceProviderEmails" @click="getServiceProviderMails()" />
                              <span style="font-size:90%;margin-right:50px"> {{ email }}</span>
                              <button type="button" class="btn btn-primary btn-sm mr-1 "
                                @click="deleteServiceProviderContactEmail(email)">X</button>
                            </div>
                          </div>
                          <!-- <div v-else>
                        <input
                          type="checkbox"
                          class="mr-1"
                          :value="email" 
                          name="serviceProviderEmails"
                          @click="getServiceProviderMails()"
                        />
                      <span style="font-size:90%;margin-right:5px"> {{ email }}</span>
                      </div> -->
                        </div>
                      </div>
                      <div class="emailmsgcolor">{{ emailNotSelected }}</div>
                    </div>
                  </div>
                </div>
                <div>
                  <center>
                    <span :style="msgcolor"><b>{{ addEmailMessage }}</b></span>
                  </center>
                </div>

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <button v-show="hideQuoteDate" v-if="this.registeredServiceProvider.length != 0" type="submit"
                      @click="enableTextBox" class="col-form-label col-form-label-sm btn btn-secondary">Add Email</button>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                    v-show="hideTextBox">
                    <input for="email" type="email" placeholder="Please enter your email here" id="email" name="email"
                      v-model="newEmail" @change="verifyServiceProviderEmail" class="form-control input-sm" />
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <button type="submit" :disabled="disableSaveButton" @click="addServiceProviderEmail"
                      class="btn btn-secondary" v-show="hideTextBox">SAVE</button>&nbsp;&nbsp;

                    <button type="submit" @click="disableTextBox" class="btn btn-secondary"
                      v-show="hideTextBox">X</button>
                  </div>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input type="text" name="oldTitle" data-vv-as="Old Title" data-vv-scope="manageTitle"
                        class="input-create" v-model.trim="manageTitle.oldTitleNumber" autocomplete="nope" />
                      <span class="bar"></span>
                      <label for="source" class="label-create ">Reassigned Title Number</label>
                    </div>
                  </div>

                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <div class="input-group">
                      <small class="small-label title_fields">Reassigned Title Date</small>
                      <date-picker type="date" name="oldTitle" v-model="manageTitle.oldTitleDate" @change="checkOldDate()"
                        data-vv-as="Old Title" data-vv-scope="manageTitle" class="input-create dob" valuetype="format"
                        format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                    <div :style="msgcolor">{{ this.oldDate }}</div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <select id="statesdd" class="input-create" v-model="manageTitle.selectedOldTitleStateCode">

                        <option v-for="(option, index) in states" :value="option.stateFipsC" :key="index">{{ option.stateN
                        }}</option>
                      </select>
                      <span class="bar"></span>
                      <label for="source" class="label-create ">Select Reassigned Tilte State</label>
                    </div>
                  </div>
                </div>
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input type="text" name="oldTitle" data-vv-as="Old Title" data-vv-scope="manageTitle"
                        class="input-create" v-model.trim="manageTitle.interimTitleNumber" autocomplete="nope" />
                      <span class="bar"></span>
                      <label for="source" class="label-create ">Interim Title Number</label>
                    </div>
                  </div>

                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <div class="input-group">
                      <small class="small-label title_fields">Interim Title Date</small>
                      <date-picker type="date" name="oldTitle" v-model="manageTitle.interimTitleDate"
                        data-vv-as="Old Title" data-vv-scope="manageTitle" class="input-create dob" valuetype="format"
                        format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <select id="statesdd" class="input-create" v-model="manageTitle.selectedInterimStateCode">

                        <option v-for="(option, index) in states" :value="option.stateFipsC" :key="index">{{ option.stateN
                        }}</option>
                      </select>
                      <span class="bar"></span>
                      <label for="source" class="label-create ">Select Interim State</label>
                    </div>
                  </div>
                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input type="text" name="plateNumber" data-vv-as="plate Number" data-vv-scope="manageTitle"
                        class="input-create" v-model.trim="manageTitle.plateNumber" autocomplete="nope" required />
                      <span class="bar"></span>
                      <label for="source" class="label-create">License Plate Number</label>
                    </div>
                  </div>

                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <div class="input-group">
                      <small class="small-label title_fields">License Plate Number Date</small>
                      <date-picker type="date" name="plateDate" v-model="manageTitle.licensePlateNumberDate"
                        data-vv-as="licensePlateNumberDate" data-vv-scope="manageTitle" class="input-create dob"
                        valuetype="format" format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                  </div>

                </div>

                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <input type="text" name="oldTitle" data-vv-as="Old Title" data-vv-scope="manageTitle"
                        class="input-create" v-model.trim="manageTitle.newTitleNumber" autocomplete="nope" required />
                      <span class="bar"></span>
                      <label for="source" class="label-create">Final Title Number</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 mt-2">
                    <div class="input-group mb-2">
                      <small class="small-label title_fields">Final Title Date</small>
                      <date-picker type="date" name="oldTitle" data-vv-as="Old Title" @change="checkNewDate()"
                        v-model="manageTitle.newTitleDate" data-vv-scope="manageTitle" class="input-create dob mt-1"
                        valuetype="format" format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                    <div :style="msgcolor">{{ this.newDate }}</div>
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group">
                      <select id="statesdd" class="input-create" v-model="manageTitle.selectedNewTitleStateCode">

                        <option v-for="(option, index) in states" :value="option.stateFipsC" :key="index">{{ option.stateN
                        }}</option>
                      </select>
                      <span class="bar"></span>
                      <label for="source" class="label-create ">Select Final Tilte State</label>
                    </div>
                  </div>

                </div>
                <!-- LLP 552 - removed @change="checkNewDate()" function from <small class="small-label title_fields">Elt Ordered Title Work Complete Date</small> -->
                <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group mb-2">
                      <small class="small-label title_fields">Elt Ordered Title Work Complete Date</small>
                      <date-picker type="date" name="oldTitle" data-vv-as="Old Title"
                        v-model="manageTitle.eltOrderedTitleWorkComplete" data-vv-scope="manageTitle"
                        class="input-create dob mt-1" valuetype="format" format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                    <!-- <div :style="msgcolor">{{ this.newDate }}</div>   -->
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group mb-2">
                      <small class="small-label title_fields">Sending Title To Trust Date</small>
                      <date-picker type="date" name="oldTitle" data-vv-as="Old Title" @change="checkNewDate()"
                        v-model="manageTitle.sendingTitleToTrust" data-vv-scope="manageTitle"
                        class="input-create dob mt-1" valuetype="format" format="MM/DD/YYYY" autocomplete="nope" />
                      <span class="bar"></span>
                    </div>
                    <!-- <div :style="msgcolor">{{ this.newDate }}</div>   -->
                  </div>

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <div class="input-group mb-2">
                      <small class="small-label title_fields">Title at Trust</small>
                      <date-picker type="text" name="oldTitle" data-vv-as="Old Title" @change="checkNewDate()"
                        v-model="manageTitle.titleSentToTrust" data-vv-scope="manageTitle" class="input-create dob mt-1"
                        valuetype="format" format="MM/DD/YYYY" autocomplete="nope" :disabled="disableTitleAtTrust" />
                      <span class="bar"></span>
                    </div>
                    <!-- <div :style="msgcolor">{{ this.newDate }}</div>   -->
                  </div>

                </div>
                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12  d-flex">
                    <label class="col-form-label col-form-label-sm ">
                      Additional Mail Instructions</label>
                  </div>
                  <!--col end-->
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                    <textarea v-model.trim="manageTitle.additionalInstructions" maxlength="250" spellcheck="true"
                      placeholder="Enter Special Instructions To Service Provider And please do not add # symbol to beginning of the text"
                      rows="5" cols="50" />
                  </div>
                  <!--col end-->
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"></div>
                  <div class="col-12 col-md-12 d-flex">
                    <span>Available Documents</span>
                  </div>
                  <div class="col-12 col-md-12  justify-content-lg-end align-items-center">
                    <table>
                      <tbody v-for="(link, index) in links">
                        <tr class="col-form-label col-form-label-sm">


                          <td v-if="link.dropboxUrl.length != 0">
                            <span v-for="(url, index) in link.dropboxUrl">
                              <input type="checkbox" class="mr-1" id="documentLink" :value="url.url" name="documentLinks"
                                @click="getAvailableDocuments()" />
                              <a href="#" @click="myFunction(url.url)">{{ url.fileName.split(".")[0] }}</a><span
                                v-if="link.dropboxUrl.length > 1 && link.dropboxUrl.length - 1 != index"
                                style="padding: 2%;">|</span></span>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- row end-->
                <center>
                  <span :style="msgcolor"><b>{{ requestQuoteStatus }}</b></span>
                </center>
                <br>
                <center>
                  <button type="submit" class="btn btn-secondary mr-3" @click="saveManageTitle()"
                    :disabled="serviceProviderEmails.length > 0">
                    Save
                  </button>
                  <button type="submit" class="btn btn-secondary mr-3" @click="sendQuote()"
                    :disabled="disablequote || dmvOrLlpDisbale || this.registeredServiceProvider == 0 || this.contactEmails.length == 0">
                    Request Quote
                  </button>
                  <button type="submit" class="btn btn-secondary mr-3" @click="sendContract()" :disabled="disableSendContract ||
                    dmvOrLlpDisbale || this.registeredServiceProvider == 0 || this.contactEmails.length == 0
                    ">
                    Accept DMV Work
                  </button>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                </center>
                <div id="requestquote" class="modal">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2>Request Quote Alert</h2>
                    </div>
                    <div class="modal-body">
                      No email for service provider
                    </div>
                    <br />
                    <div class="modal-footer">
                      <button class="btn-blue-save nextButton" @click="saveManageTitleQuote()">
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div id="myModal" class="modal">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2>Send DMV Work Alert</h2>
                      <button type="button" class="close" aria-label="Close" @click="cancelContract()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" v-if="this.serviceProviderEmails == null &&
                      this.contactEmails.length != 1
                      ">
                      No email for service provider
                    </div>
                    <div class="modal-body" v-else>
                      <div v-if="manageTitle.quoteDate != null && manageTitle.anotherServiceCompanyId != ''">
                        This deal already requsted for a quote. Do you really want to send DMV work with diffrent service
                        provider
                      </div>
                      <div v-else>

                        Do you really want to send DMV work
                      </div>
                    </div>
                    <br />
                    <div class="modal-footer" v-if="this.serviceProviderEmails == null &&
                      this.contactEmails.length != 1
                      ">
                      <button class="btn-blue-save nextButton" @click="saveManageTitleContract()">
                        OK
                      </button>
                    </div>
                    <div class="modal-footer" v-else>
                      <button class="btn-blue-save nextButton" @click="saveManageTitleContract()">
                        OK
                      </button>
                      <button class="btn-blue-save nextButton" @click="cancelContract()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
                <div id="myModalData" class="modal">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2>Change Service provider</h2>
                      <button type="button" class="close" aria-label="Close" @click="cancelServiceProvider()">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body" v-if="this.serviceProviderEmails == null &&
                      this.contactEmails.length != 1
                      ">
                      No email for service provider
                    </div>
                    <div class="modal-body" v-else>
                      This deal is already assigned to one service provider.
                      Do you really want to inactivate existing serviceprovider
                    </div>
                    <br />

                    <div class="modal-footer">
                      <button class="btn-blue-save nextButton" @click="saveMultipleManageTitleContract()">
                        YES
                      </button>
                      <button class="btn-blue-save nextButton" @click="cancelServiceProvider()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
                <br />
                <hr class="border-2 border-top" />
                <div>
                  <nav>
                    <span>
                      <b>Service Provider Information</b>
                    </span>
                  </nav>
                </div>
                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Company Name</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ companyName }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Service Name</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ serviceName }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">license</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ license }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Service Fee</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ serviceFee }}</label>
                  </div>
                </div>


                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Contact Person</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ contactPerson }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Phone Number</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ phonePerson }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Email</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ emailId }}</label>
                  </div>
                </div>
                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Web Url</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ webURL }}</label>
                  </div>
                </div>


                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Street1</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ street1 }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Street2</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ street2 }}</label>
                  </div>

                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">State</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ state }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">State Code</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ stateCode }}</label>
                  </div>
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Zipcode</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ zipcode }}</label>
                  </div>
                </div>
                <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-lg-flex flex-column">
                    <label for="source" class="col-form-label col-form-label-sm labelFont">Address Notes</label>
                    <label for="source" class="col-form-label col-form-label-sm">{{ addressNotes }}</label>
                  </div>
                </div>

                <div>
                  <div>
                    <nav>

                      <div class="heading"><span> <b>Manage Temp Registration</b></span></div>

                    </nav>
                  </div>

                  <div class="row p-2 justify-content-center rowWrap">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <div v-if="saved">
                          <center>
                            <span :style="msgcolor"><b>{{ saveDmvTempmessage }}</b></span>
                          </center>
                        </div>
                        <table class="table table-sm table-bordered table-striped">
                          <thead>
                            <tr class="table-month-header-blue">
                              <th v-for="head in heads">{{ head.name }}</th>
                            </tr>
                            <tr v-if="this.tempTagRegListData.length <= 1 &&
                              this.tempTag == true
                              ">
                              <td>
                                {{ deal.selectedLoan }}
                              </td>
                              <td>
                                <input type="text" class="form-control input-sm" v-model="tempTagRegList.temptagdata" />
                              </td>
                              <td>
                                <input type="date" class="form-control input-sm" v-model="tempTagRegList.issueDate" />
                              </td>
                              <td>
                                <input type="date" :min="minDate" class="form-control input-sm"
                                  v-model="tempTagRegList.dateOfExpiry" />
                              </td>

                              <td>
                                <select class="form-control input-sm" v-model="tempTagRegList.issuedBy">
                                  <option value="Lynn">Lynn</option>
                                  <option value="Alicia">Alicia</option>
                                  <option value="Dealer">Dealer</option>
                                </select>
                              </td>


                              <td>
                                <input type="text" class="form-control input-sm" v-model="tempTagRegList.confNumber" />
                              </td>

                              <td><label for="source" class="col-form-label col-form-label-sm labelFont">
                                  {{ deal.selectedVin }}</label></td>
                              <!-- <td>
                              <input
                                type="text"
                                class="form-control input-sm"
                                id="userName"
                                v-model="tempTagRegList.vehicle"
                              />
                              
                            </td> -->
                              <td><label for="source" class="col-form-label col-form-label-sm labelFont">
                                  {{ deal.selectedYear + " " + deal.selectedMake + " " + deal.selectedModel }}</label></td>



                              <td>
                                <input type="text" class="form-control input-sm" id="userName"
                                  v-model="tempTagRegList.whoIsIssued" />
                              </td>
                              <td>
                                <input type="date" class="form-control input-sm" v-model="tempTagRegList.transDate" />
                              </td>
                              <td>
                                <input type="text" class="form-control input-sm" id="userName"
                                  v-model="tempTagRegList.tempType" />
                              </td>
                              <td>
                                <input type="text" class="form-control input-sm" id="userName"
                                  v-model="tempTagRegList.cost" />
                              </td>
                              <td>
                                <input type="text" class="form-control input-sm" id="userName"
                                  v-model="tempTagRegList.location" />
                              </td>
                              <td>

                                <div class="dropdown">
                                  <button class=" dropdown-toggle" style="background-color:white" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Select Email
                                  </button>
                                  <form class="dropdown-menu" style="position:relative;height:140px;overflow:scroll"
                                    aria-labelledby="dropdownMenuButton">


                                    <div v-for="(value, key, index) in employeelist" :key="index">
                                      <label style=" display: inline-block;margin-left: 1.0rem;">
                                        <input type="checkbox" name="Toemailids" :value="value.emailId"
                                          @click="getToemailids()" :id="key">
                                        {{ value.fullName }} </label>
                                    </div>

                                  </form>
                                </div>



                                <!-- 
                              <div
                                class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 form-inline"
                              >
                                <div
                                  id="list2"
                                  class="dropdown-check-list"
                                  tabindex="100"
                                  @click="emailidslist()"
                                >
                                  <span class="anchor">Select</span>
                                  <ul id="items1" class="items list-group">
                                    <li
                                      class="list-group-item"
                                      v-for="(option, index) in employeelist"
                                      v-bind:value="option.emailId"
                                      v-bind:key="index.key"
                                    >
                                      <input
                                        type="checkbox"
                                        :value="option.emailId"
                                        class="checkbox"
                                        name="Toemailids"
                                        id="toemailids1"
                                        @click="getToemailids()"
                                      />
                                      {{ option.fullName }}
                                    </li>
                                  </ul>
                                </div>
                              </div> -->
                              </td>
                              <!-- <td>   <button type="submit" class="btn-blue-save" style="width:5%" @click="addTempTagData">+</button></td>-->
                            </tr>

                            <tr></tr>

                            <tr class="table-month-row"></tr>
                            <tr v-for="(entry, index) of temptagRegListDataUpdate" :key="index" v-if="index <= 1">

                              <td class="table-month-td">{{ deal.selectedLoan }}</td>
                              <td class="table-month-td">
                                <input type="text" class="form-control input-sm" v-model="entry.tempTag" />

                              </td>
                              <td class="table-month-td">
                                <!-- <input
                                type="date"                                
                                class="form-control input-sm"
                                v-model="entry.creationD"
                              />                        -->
                                {{ entry.creationD }}
                              </td>
                              <td class="table-month-td">

                                <input type="date" class="form-control input-sm" v-model="entry.dateOfExpiry" />
                              </td>
                              <td class="table-month-td">

                                <select class="form-control input-sm" v-model="entry.issuedBy">
                                  <option value="Lynn">Lynn</option>
                                  <option value="Alicia">Alicia</option>
                                  <option value="Dealer">Dealer</option>
                                </select>

                              </td>
                              <td class="table-month-td">
                                <input type="text" class="form-control input-sm" v-model="entry.confNumber" />
                              </td>
                              <td class="table-month-td">{{ deal.selectedVin }}</td>
                              <td class="table-month-td">{{ deal.selectedYear + " " + deal.selectedMake + " "+deal.selectedModel }}</td>
                              <td class="table-month-td">
                                <input type="text" class="form-control input-sm" v-model="entry.whoIssued" />
                              </td>
                              <td class="table-month-td">

                                <input type="date" class="form-control input-sm" v-model="entry.transDate" />

                              </td>
                              <td class="table-month-td">
                                <input type="text" class="form-control input-sm" v-model="entry.tempType" />

                              </td>
                              <td class="table-month-td">
                                <input type="text" class="form-control input-sm" v-model="entry.cost" />
                              </td>
                              <td class="table-month-td"> <input type="text" class="form-control input-sm"
                                  v-model="entry.location" /> </td>


                              <td class="table-month-td" style="word-wrap: break-word;min-width: 160px;max-width: 160px;">
                                <div class="dropdown">
                                  <button class=" dropdown-toggle" style="background-color:white" id="dropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Select Email
                                  </button>
                                  <form class="dropdown-menu" style="position:relative;height:140px;overflow:scroll"
                                    aria-labelledby="dropdownMenuButton">


                                    <div v-for="(value, key, index) in employeelist" :key="index">
                                      <label style=" display: inline-block;margin-left: 1.0rem;">
                                        <input type="checkbox" v-model="entry.employeeEmails" name="Toemailids"
                                          :value="value.emailId" @click="getToemailids(entry.employeeEmails)" :id="index">
                                        {{ value.fullName }} </label>
                                    </div>

                                  </form>
                                </div>

                              </td>
                              <!--    <td class="table-month-td">
       <button type="submit" class="btn-blue-save" style="width:10%"  @click="deleteContact(index)">-</button>
          </td>-->

                              <td>

                                <button type="submit" class="btn btn-secondary mr-3 mb-2"
                                  @click="
                                    updateTempRegistrationById(index, entry.dmvTempID, entry.tempTag, entry.creationD, entry.dateOfExpiry, entry.issuedBy, entry.confNumber, entry.whoIssued, entry.transDate, entry.tempType, entry.cost, entry.location, entry.employeeEmails)">
                                  Update
                                </button>

                              </td>

                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>

                  <center>
                    <button :disabled="isActive" type="submit" class="btn btn-secondary mr-3 mb-2"
                      @click="issueTempTag()">
                      Issue temp Tag
                    </button>
                    <button :disabled="isActive" type="submit" class="btn btn-secondary mr-3 mb-2"
                      @click="addnewTempTag()">
                      Submit
                    </button>
                    <button type="submit" class="btn btn-secondary mr-3 mb-2" @click="displayAllDeals">
                      Back
                    </button>
                  </center>
                </div>
              </div>
              <div role="tabpanel" class="tab-pane" id="viewReminders">
                <div>
                  <nav>
                    <span>
                      <b>View Reminders</b>
                    </span>
                  </nav>
                </div>
                <!-- <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-3">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Milestone Status</label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                    <input type="text" class="form-control input-sm" />
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Target time</label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                    <input type="date" class="form-control input-sm" />
                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label for="source" class="col-form-label col-form-label-sm">Get Old Title</label>
                  </div>
                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  >
                    <input type="text" class="form-control input-sm" />
                  </div>
                </div>-->
                <!--  <center>
                  <button type="submit" class="btn btn-secondary mr-3">Save</button>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">Back</button>
                </center>-->

                <div>
                  <div class="row p-2 justify-content-center rowWrap">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <v-table id="myappsTable" :data="dmvMilestoneList" :currentPage.sync="currentPage1" :pageSize="50"
                          @totalPagesChanged="totalPages1 = $event" class="table table-sm table-bordered table-striped">
                          <thead class="table-month-header-blue wrap-text" slot="head">

                            <v-th sortKey="milestone">MilesStone</v-th>
                            <v-th sortKey="state">State</v-th>
                            <v-th sortKey="receipient">Sent To</v-th>
                            <v-th sortKey="status">Status(mail success/fail)</v-th>

                            <v-th sortKey="dayOut">DayOut</v-th>
                            <v-th sortKey="notice">ClockFlag</v-th>
                            <v-th sortKey="startDate">Reminder Sent Date</v-th>
                            <v-th sortKey="endDate">Next Reminder</v-th>
                            <v-th sortKey="elapsedDays">Lapsed Days</v-th>
                          </thead>
                          <tbody slot="body" slot-scope="{ displayData }">
                            <tr v-for="(option, index) in displayData">

                              <td class="table-month-td">
                                {{ option.milestone }}
                              </td>
                              <td class="table-month-td">{{ option.state }}</td>
                              <td class="table-month-td">{{ option.receipient }}</td>
                              <td class="table-month-td">{{ option.status }}</td>



                              <td class="table-month-td">
                                {{ option.dayOut }}
                              </td>
                              <td class="table-month-td">
                                {{ option.notice }}
                              </td>
                              <td class="table-month-td">
                                {{ option.startDate | moment("MM/DD/YYYY") }}
                              </td>
                              <td class="table-month-td">
                                {{ option.nextReminderDate | moment("MM/DD/YYYY") }}
                              </td>
                              <td class="table-month-td">
                                {{ option.elapsedDays }}
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                        <smart-pagination :currentPage.sync="currentPage1" :totalPages="totalPages1"
                          :style="{ listStyle: none }" />
                      </div>
                      <div class="row row-cols-lg-5 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 "
                        v-if="stopReminderList[0].reminderStopped == 'N'">
                        <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                          <label for="source" class="col-form-label col-form-label-sm">Stop Reminder Reasons : </label>
                        </div>
                        <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                          <select v-model="stopReminder" class="form-control input-sm">
                            <option value>Select a Reason...</option>
                            <option v-for="(option) in stopReminderReasons" :value="option.id" :key="option.id">{{
                              option.keyValue }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="stopReminderList[0].reminderStopped == 'Y'">
                  <br>
                  <nav>
                    <span>
                      <b>Reminders Stopped</b>
                    </span>
                  </nav>
                </div>
                <div v-if="stopReminderList[0].reminderStopped == 'Y'">
                  <div class="row p-2 justify-content-center rowWrap">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <v-table id="myappsTable" :data="stopReminderList" :currentPage.sync="currentPage1" :pageSize="50"
                          @totalPagesChanged="totalPages1 = $event" class="table table-sm table-bordered table-striped">
                          <thead class="table-month-header-blue wrap-text" slot="head">

                            <v-th sortKey="milestone">Reminders Stopped Reason</v-th>
                            <v-th sortKey="state">Reminders Stopped By</v-th>
                            <v-th sortKey="receipient">Reminders Stopped On</v-th>
                          </thead>

                          <tbody slot="body" slot-scope="{ displayData }">
                            <tr v-for="(option, index) in displayData">

                              <td class="table-month-td">
                                {{ option.reminderStoppedReason }}
                              </td>
                              <td class="table-month-td">{{ option.reminderStoppedBy }}</td>
                              <td class="table-month-td">{{ option.reminderStoppedOn | moment("MM/DD/YYYY") }}</td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <center>
                  <button type="submit" class="btn btn-secondary mr-3" @click="displayAllDeals">
                    Back
                  </button>
                  <button type="submit" class="btn btn-secondary mr-3" @click="submitReminderStoppedDetails"
                    v-if="this.stopReminderList[0].reminderStopped == 'N' && stopReminder != ''">Submit</button>
                </center>
              </div>

              <div role="tabpanel" class="tab-pane" id="notes">
                <div>
                  <nav>
                    <span>
                      <b>Notes</b>
                    </span>
                  </nav>
                  <div v-if="saved">
                    <center>
                      <span :style="msgcolor"><b>{{ savemessage }}</b></span>
                    </center>
                  </div>
                </div>
                <!--    <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label class="required">Notes</label>
                  </div>
                </div>
              <quill-editor
                  v-model="content"
                  ref="myQuillEditor"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                ></quill-editor> -->

                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label class="col-form-label col-form-label-sm required">
                      Notes</label>
                  </div>
                  <!--col end-->
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                    <textarea v-model.trim="content" maxlength="250" spellcheck="true" placeholder="Enter Notes" rows="5"
                      cols="100" />
                  </div>
                  <!--col end-->
                </div>
                <!-- row end-->
                <br />
                <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">


                  </div>
                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <input type="checkbox" v-model="dmvStatusNotes" id="statusNotes"
                      class="col-form-label col-form-label-sm ">&nbsp;&nbsp;&nbsp;
                    <label style="font-size:12px" class="col-form-label col-form-label-sm ">DMV Status Notes</label>
                  </div>

                  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
                    <label class="col-form-label col-form-label-sm ">Email TO</label>
                  </div>

                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Select Email
                    </button>
                    <form class="dropdown-menu" style="position:relative;height:150px;overflow:scroll"
                      aria-labelledby="dropdownMenuButton">


                      <div v-for="(value, key, index) in employeelist" :key="index">
                        <label style="    display: inline-block;margin-left: 1.0rem;">
                          <input type="checkbox" name="emailids" :value="value.emailId" @click="getemailids()" :id="key">
                          {{ value.fullName }} </label>
                      </div>

                    </form>
                  </div>


                  <!-- 

                  <div
                    class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 form-inline"
                  >
                    <div 
                      id="list1"
                      class="dropdown-check-list"
                      tabindex="100"
                      @click="listemailids()"
                    >
                      <span class="anchor" style="width:200%;">Select</span>
                      <ul
                        id="items"
                        class="items list-group"
                        style="width:200%;"
                      >
                        <li
                          class="list-group-item"
                          v-for="(option, index) in employeelist"
                          v-bind:value="option.emailId"
                          v-bind:key="index.key"
                        >
                          <input
                            type="checkbox"
                            :value="option.emailId"
                            class="checkbox"
                            name="emailids"
                            @click="getemailids()"
                          />
                          {{ option.fullName }}
                        </li>
                      </ul>
                    </div>
                  </div> -->
                </div>
                <div class="tab-pane">
                  <div class="row p-2 justify-content-center" style="height:187px;overflow:auto;">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <table class="table table-sm table-bordered table-striped">
                          <thead>
                            <tr class="table-month-header-blue">
                              <th v-for="head in emailheads">
                                {{ head.name }}
                              </th>
                            </tr>
                            <tr v-for="(option, index) in employeemailids" :key="index">
                              <!-- <td>  <button type="submit" class="btn-blue-save" style="width:10%"  @click="deleteEmails(index)">-</button></td> -->
                              <td class="table-month-td">{{ option }}</td>
                              <td>
                                <input type="checkbox" class="checkbox" id="toemailidscheck" :value="option"
                                  name="toemailids" @click="getTOemailids()" />
                              </td>
                              <td>
                                <input type="checkbox" class="checkbox" id="ccemailidscheck" :value="option"
                                  name="ccemailids" @click="getCCemailids()" />
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <center>
                  <button v-if="toEmailids.length == 0" type="submit" class="btn btn-secondary mr-3 mb-2"
                    @click="saveDmvNotes(1)">
                    Save
                  </button>

                  <button type="submit" class="btn btn-secondary mr-3 mb-2" @click="saveDmvNotes(2)">
                    Save and Email
                  </button>
                  <button type="submit" class="btn btn-secondary mr-3 mb-2" @click="displayAllDeals">
                    Back
                  </button>
                </center>
                <br>
                <div class="
            row
            no-gutters
            row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2
            p-2
          ">
                  <div class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            ">

                    <label for="source" class="col-form-label col-form-label-sm">Select Date </label>
                  </div>

                  <div class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            " v-if="dmvNotesCreationDate.length != 0">

                    <div class="input-group">

                      <select id="statesdd" class="input-create" v-model.trim="selectedDate"
                        @change="getNotesListByDate()">
                        <option value="All">All</option>
                        <option v-for="(option, index) in dmvNotesCreationDate" :value="option.creationD" :key="index">{{
                          option.creationD | moment("MM/DD/YYYY") }}</option>
                      </select>

                    </div>
                  </div>
                  <div class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            " v-else>
                    <input type="text" disabled placeholder="No data available" />
                  </div>


                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="
              col-12 col-md-12
              d-flex
              justify-content-lg-end
              align-items-center
              mr-2
            ">
                    <label for="source" class="col-form-label col-form-label-sm">Created By</label>
                  </div>

                  <div class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            " v-if="dmvNotesuserName.length != 0">


                    <div class="input-group">
                      <select id="statesdd" class="input-create" v-model.trim="userNameData"
                        @change="getNotesListByDate()">
                        <option value="All">All</option>
                        <option v-for="(option, index) in dmvNotesuserName" :value="option.userName" :key="index">{{
                          option.userName }}</option>
                      </select>



                    </div>
                  </div>

                  <div class="
              col-12 col-md-12
              justify-content-end
              align-items-center
              mb-3 mb-lg-0 mb-md-3 mb-sm-3
            " v-else>
                    <input type="text" disabled placeholder="No data available" />
                  </div>


                  <center>
                    <button type="submit" class="btn btn-secondary" @click="resetDmvNotes()">
                      Reset
                    </button>
                  </center>


                </div>


                <center>
                  <span :style="msgOwnedcolor">{{ notesUpdateMessage }}</span>
                </center>
                <div class="tab-pane">
                  <div class="row p-2 justify-content-center rowWrap">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <v-table id="myappsTable" :data="notesList" :currentPage.sync="currentPage3" :pageSize="50"
                          @totalPagesChanged="totalPages3 = $event" class="table table-sm table-bordered table-striped">
                          <thead class="table-month-header-blue wrap-text" slot="head">

                            <v-th style="width:10%" sortKey="creationD">Creation Date</v-th>
                            <v-th style="width:40%" sortKey="notes">Notes</v-th>
                            <v-th style="width:10%">Action</v-th>


                          </thead>

                          <tbody slot="body" slot-scope="{ displayData }">
                            <tr v-for="(data, index) in displayData">

                              <td class="table-month-td">
                                <center> {{
                                  data.creationD | moment("MM/DD/YYYY hh:mm:ss")
                                }}</center>
                              </td>

                              <td v-if="data.creationDEdit == data.creationDNew" class="table-month-td"><input type="text"
                                  class="form-control input-sm" v-model="data.notes"></td>

                              <td v-else class="table-month-td">{{ data.notes }}</td>

                              <td class="table-month-td">
                                <center><button type="submit" class="btn btn-secondary"
                                    v-if="data.creationDEdit == data.creationDNew" @click="
                                      updateNotesData(
                                        data.id,
                                        data.notes,
                                        index
                                      )">

                                    Update
                                  </button> </center>
                              </td>

                            </tr>
                          </tbody>
                        </v-table>
                        <smart-pagination :currentPage.sync="currentPage3" :totalPages="totalPages3"
                          :style="{ listStyle: none }" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div role="tabpanel" class="tab-pane" id="manageMilestoneStatus">
                <center>
                  <span :style="msgcolor"><b>{{ saveMilestoneStatus }}</b></span>
                </center>
                <div>
                  <nav>
                    <span>
                      <b>Manage MileStone Status</b>
                    </span>
                  </nav>
                </div>
                <div class="tab-pane">
                  <div class="row p-2 justify-content-center rowWrap">
                    <div class="col">
                      <div class="table-responsive table-responsive-sm">
                        <v-table id="myappsTable" :data="milestoneStatusList" :currentPage.sync="currentPage2"
                          :pageSize="50" @totalPagesChanged="totalPages2 = $event"
                          class="table table-sm table-bordered table-striped">
                          <thead class="table-month-header-blue wrap-text" slot="head">
                            <v-th>SNO</v-th>
                            <v-th sortKey="loanStatus">MilesStone Status</v-th>
                            <v-th sortKey="keyValue">MileStone Status Description</v-th>
                            <v-th sortKey="changeDate">Status Change Date</v-th>
                            <v-th sortKey="elapsedDays">Elapsed Days</v-th>
                            <v-th>Action</v-th>
                          </thead>
                          <tbody slot="body" slot-scope="{ displayData }" v-if="deal.dealerDMV == 'N'">
                            <tr v-for="(entry, index) in displayData" :key="index"
                              :style="entry.loanStatus == 1 || entry.loanStatus == 12 || entry.loanStatus == 5 || entry.loanStatus == 6 || entry.loanStatus == 2 ? { 'color': '#D3D3D3' } : ''">
                              <td class="table-month-td">{{ index + 1 }}</td>
                              <td class="table-month-td">
                                {{ entry.loanStatus }}
                              </td>
                              <td class="table-month-td">
                                {{ entry.keyValue }}
                              </td>

                              <td class="table-month-td"
                                v-if="entry.loanStatus == 1 || entry.loanStatus == 2 || entry.loanStatus == 12 || entry.loanStatus == 5 || entry.loanStatus == 6">
                                {{ entry.changeDate }}
                                <!-- <input
                                  type="date"
                                  v-model="entry.changeDate"
                                  v-if="entry.loanStatus == 2 "
                                  :disabled="disabledate"
                                  class="form-control input-sm"
                                />-->
                              </td>
                              <td class="table-month-td" v-else-if="entry.loanStatus == 13">
                                <input type="text" class="form-control input-sm" v-model="entry.dmvOrStillWorkNeeded">
                              </td>
                              <td v-else>
                                <input type="date" v-model="entry.changeDate" :disabled="!disabledate"
                                  class="form-control input-sm" />

                                <!-- <input type="date" v-if="milestoneStatusList[index-1].changeDate  === null && entry.changeDateFlag === false" name="date" id="date1" v-model="entry.changeDate" :disabled="true" class="form-control input-sm"> 
                    <input type="date" @change="getStartDate(index)" :min="minDate"    v-if="milestoneStatusList[index-1].changeDate  !== null && entry.changeDateFlag === true" name="date" id="date1" v-model="entry.changeDate" :disabled="false" class="form-control input-sm">
                    <input type="date" v-if="milestoneStatusList[index-1].changeDate !== null &&  entry.changeDateFlag  === false"   disabled v-model="entry.changeDate"  name="" id="date1" class="form-control input-sm" >-->

                                <!--<span class="alert-danger" v-if="index>4">{{startDateMessage}}</span> -->
                              </td>

                              <td class="table-month-td" v-if="entry.loanStatus == 13">
                                {{ 0 }}
                              </td>

                              <td v-else class="table-month-td">
                                {{ entry.elapsedDays }}
                              </td>
                              <td class="table-month-td">
                                <button type="submit" class="btn btn-secondary"
                                  v-if="entry.loanStatus != 1 && entry.loanStatus != 2 && entry.loanStatus != 12 && entry.loanStatus != 13 && entry.loanStatus != 5 && entry.loanStatus != 6"
                                  @click="
                                    updateAuditStatus(
                                      entry.dmvId,
                                      entry.loanStatus,
                                      entry.changeDate,
                                      entry.dmvOrStillWorkNeeded,
                                      index
                                    )
                                    ">
                                  Update
                                </button>


                                <button type="submit" class="btn btn-secondary" v-if="entry.loanStatus == 13" @click="
                                  updateAuditStatusForDMVOrTitleWork(
                                    entry.dmvId,
                                    entry.dmvOrStillWorkNeeded,
                                    index
                                  )
                                  ">
                                  Update
                                </button>
                              </td>



                            </tr>
                          </tbody>
                          <tbody slot="body" slot-scope="{ displayData }" v-else-if="deal.dealerDMV == 'Y'">
                            <tr v-for="(entry, index) in displayData" :key="index"
                              :style="entry.loanStatus == 1 || entry.loanStatus == 2 || entry.loanStatus == 3 || entry.loanStatus == 4 || entry.loanStatus == 5 || entry.loanStatus == 6 || entry.loanStatus == 12 || entry.loanStatus == 7 ? { 'color': '#D3D3D3' } : ''">
                              <td class="table-month-td">{{ index + 1 }}</td>
                              <td class="table-month-td">
                                {{ entry.loanStatus }}
                              </td>
                              <td class="table-month-td">
                                {{ entry.keyValue }}
                              </td>

                              <td class="table-month-td"
                                v-if="entry.loanStatus == 1 || entry.loanStatus == 2 || entry.loanStatus == 3 || entry.loanStatus == 4 || entry.loanStatus == 5 || entry.loanStatus == 6 || entry.loanStatus == 7 || entry.loanStatus == 12">
                                {{ entry.changeDate }}

                                <!--  <input
                                  type="date"
                                  v-model="entry.changeDate"
                                  v-if="entry.loanStatus == 3 || entry.loanStatus == 4 || entry.loanStatus == 5 || entry.loanStatus == 6 || entry.loanStatus == 7"
                                  :disabled="disabledate"
                                  class="form-control input-sm"
                                />-->
                              </td>
                              <td class="table-month-td" v-else-if="entry.loanStatus == 13">
                                <input type="text" class="form-control input-sm" v-model="entry.dmvOrStillWorkNeeded">
                              </td>
                              <td v-else>
                                <input type="date" v-model="entry.changeDate" :disabled="!disabledate"
                                  class="form-control input-sm" />

                                <!-- <input type="date" v-if="milestoneStatusList[index-1].changeDate  === null && entry.changeDateFlag === false" name="date" id="date1" v-model="entry.changeDate" :disabled="true" class="form-control input-sm"> 
                    <input type="date" @change="getStartDate(index)" :min="minDate"    v-if="milestoneStatusList[index-1].changeDate  !== null && entry.changeDateFlag === true" name="date" id="date1" v-model="entry.changeDate" :disabled="false" class="form-control input-sm">
                    <input type="date" v-if="milestoneStatusList[index-1].changeDate !== null &&  entry.changeDateFlag  === false"   disabled v-model="entry.changeDate"  name="" id="date1" class="form-control input-sm" >-->

                                <!--<span class="alert-danger" v-if="index>4">{{startDateMessage}}</span> -->
                              </td>

                              <td class="table-month-td" v-if="entry.loanStatus == 13">
                                {{ 0 }}
                              </td>

                              <td v-else class="table-month-td">
                                {{ entry.elapsedDays }}
                              </td>
                              <td class="table-month-td">
                                <button type="submit" class="btn btn-secondary"
                                  v-if="entry.loanStatus != 1 && entry.loanStatus != 2 && entry.loanStatus != 3 && entry.loanStatus != 4 && entry.loanStatus != 5 && entry.loanStatus != 6 && entry.loanStatus != 7 && entry.loanStatus != 12 && entry.loanStatus != 13"
                                  @click="
                                    updateAuditStatus(
                                      entry.dmvId,
                                      entry.loanStatus,
                                      entry.changeDate,
                                      entry.dmvOrStillWorkNeeded,
                                      index
                                    )
                                    ">
                                  Update
                                </button>


                                <button type="submit" class="btn btn-secondary" v-if="entry.loanStatus == 13" @click="
                                  updateAuditStatusForDMVOrTitleWork(
                                    entry.dmvId,
                                    entry.dmvOrStillWorkNeeded,
                                    index
                                  )
                                  ">
                                  Update
                                </button>
                              </td>



                            </tr>
                          </tbody>
                        </v-table>
                        <smart-pagination :currentPage.sync="currentPage2" :totalPages="totalPages2"
                          :style="{ listStyle: none }" />
                        <!-- <ul class="progressbar" >
          <li   v-for="(entry, index) in milestoneStatusList"
                              :key="index" v-bind:class="{ 'active': entry.activeStatus }">{{entry.keyValue}}( {{entry.changeDate}} )</li>  
  </ul>-->

                      </div>
                    </div>
                  </div>
                </div>

                <center>
                  <button type="submit" class="btn btn-secondary" @click="displayAllDeals">
                    Back
                  </button>
                </center>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpdmvtitle from "../js/http-dmvtitledata.js";
import PaymentInfo from "@/components/PaymentInfo.vue";
import deals from "@/components/AutopalData.vue";
import payablesreceivables from "@/components/PayablesReceivables.vue";
import DatePicker from "vue2-datepicker";
import httpcommon from "../js/http-common.js";
import { bus } from "../main";
import moment from 'moment';
import { PDFDocumentFactory, PDFDocument } from 'pdf-lib';
export default {
  components: {
    PaymentInfo,
    deals,
    payablesreceivables,
    DatePicker
  },
  data() {
    return {
      disableTitleAtTrust: true,
      disableServiceProvider: true,
      notesUpdateMessage: '',
      manageTitledmvTitleId: '',
      manageTitleServiceId: '',
      manageTitleQuoteId: '',
      validEmail: false,
      disableSaveButton: true,
      addEmailMessage: '',
      hideTextBox: false,
      newEmail: '',
      emailMilestoneResponse: '',
      allDocs: 'Y',
      testId: '',
      disableAnotherServiceProvider: true,
      serviceProviderStatesList: [],
      serviceProviderStatesList1: [],
      //disableList:false,
      userNameDisabled: false,
      dmvStatusNotes: true,
      dmvNotesuserName: [],
      dmvNotesCreationDate: [],
      selectedDate: null,
      userNameData: '',
      userNameDataOne: '',
      notesList: [],
      loanStatusList: [],
      countyMessage: '',
      cylinderMessage: '',
      mileageMessage: '',
      curbWeightMessage: '',
      states: [],
      vinaudit: [],
      name: "Pagination",
      currentPage: 1,
      totalPages: 0,
      luxuryTaxEnable: 'N',
      luxuryTax: '',
      currentPage1: 1,
      totalPages1: 0,
      currentPage2: 1,
      totalPages2: 0,
      currentPage3: 1,
      totalPages3: 0,
      ownedToLessee: '',
      ownedToLLP: '',
      paybackToLessee: '',
      startDateMessage: '',
      saveMilestoneStatus: '',
      requestQuoteStatus: '',
      disabledate: true,
      milestoneStatusList: [],
      dmvDealerContactsList: [],
      userName: '',
      dmvMilestoneList: [],
      toEmailids: [],
      ccEmailids: [],
      links: [],      
      linkss: [{docReceivedDate:'20-10-2024', docName:'test doc', docId:'12546'}],
      imageContainer: [],
      dmvDocsRequiredList: [],
      documentName: '',
      count: 1,
      files: [],
      pdfDataUri: '',
      yodleedatalist: [],
      link: [],
      name: '',
      pdfurl: '',
      pdfbyteurl: '',
      dmvValidate: '',
      lesseeValidate: '',
      temptagAddDaysData: [],
      minDate: new Date().toISOString().split('T')[0],
      minChangeDate: new Date().toISOString().split('T')[0],
      isActive: false,
      saved: false,
      financialSalesTax: '',
      financialTotal: '',
      savemessage: "",
      selectedFile: null,
      selectedFileForm: null,
      saveDmvTempmessage: "",
      ownedAmount: '',
      documents: null,
      emailNotSelected: "",
      stopReminderList: [],
      tempTagRegList: [{
        timesTempTagIssued: '',
        temptagdata: '',
        numberOfTimes: '',
        whoIsIssued: '',
        issuedBy: 'LLP',
        dateOfExpiry: '',
        emailSentTo: [],
        confNumber: '',
        transDate: '',
        cost: '',
        location: '',
        tempType: '',
        issueDate: ''

      }],

      activeClass: "deal_info",
      checkdate: "",
      userId: "",
      userRole: "",
      selecteddmvid: "",
      notes: "",
      dealnotes: "",
      loan: "",
      dmvTitleDataList: [],
      selectedDealData: [],
      selectedFinancialData: [],
      registeredServiceProvider: [],
      deal: this.intializeSelectedDeal(),
      employeelist: [],

      employeeEmails: [],
      employeemailids: [],
      message: "Unauthorized",
      responseMessage: '',
      responseFinancialMessage: '',
      msgcolor: {
        color: "black"
      },
      msgOwnedcolor: {
        color: "Green"
      },
      msgOwnedbold: {
        fontWeight: "bold"
      },
      activetab: "",
      content: "",
      //userdata: "",
      providerName: "",
      serviceProviders: "",
      serviceProvider: "",
      providerDetails: "",
      registrationState: "",
      manageTitle: this.initializeManageTitle(),
      heads: [
        { name: "Lease Number" },
        { name: " Temp Tag Number" },
        { name: "Issue Date" },
        { name: "Expiration Date" },
        { name: "Issued By" },

        { name: "Conf Number" },

        { name: " VIN" },
        { name: " Vehicle" },
        { name: "User" },
        { name: " Trans Date" },
        { name: " Tag Type" },
        { name: " Cost" },
        { name: " Location" },


        { name: "Email Sent To " },
        { name: "Action" }
      ],
      mileStoneheads: [
        { name: "SNO" },
        { name: "MileStone Status" },
        { name: "MileStone Status Description" },
        { name: "Status Change Date" },
        { name: "Elapsed Days" },
        { name: "Action" },

      ],

      notesheads: [
        { name: "NoteRef" },
        { name: "Creation Date" },
        { name: "Notes" },
        { name: "Emails" },
        { name: "ToEmails" },
        { name: "CCEmails" },


      ],

      emailheads: [

        { name: "Email" },
        { name: "To Email" },
        { name: "CC Email" },
      ],

      tagetsList: [
        { name: "SNO" },
        { name: "MilesStone" },
        { name: "State" },
        { name: "DayOut" },
        { name: "ClockFlag" },
        { name: "Start Date" },
        { name: "End Date" },
        { name: "Lapsed Days" },

      ],

      tempTag: false,
      additionalDate: moment().format("YYYY-MM-DD"),
      tempTagRegListData: [],
      temptagRegListDataUpdate: [],
      state: "",
      serviceName: "",
      companyName: "",
      street1: "",
      street2: "",
      stateCode: "",
      zipcode: "",
      license: "",
      disableSendContract: false,
      disabledropdown: false,
      dmvOrLlpDisbale: false,
      disablequote: false,
      hideQuoteDate: true,
      hideLLPDoingQuoteDate: true,
      contactPerson: "",
      phonePerson: "",
      serviceFee: "",
      checklistCSV: "",
      webURL: "",
      emailId: "",
      instructionNotes: "",
      specialNotes: "",
      processingNotes: "",
      addressNotes: "",
      reviewNotes: "",
      recordType: "",
      contactEmails: [],
      manageQuoteIdList: [],
      countryName: "USA",
      dmvNotesList: [],
      serviceProviderCheckList: [],
      dmvTitleIdStatus: "",
      // checkdetails:this.initializeCheckdata(),
      serviceProviderEmails: [],
      oldDate: "",
      newDate: "",
      selectedQuoteList: [],
      curbWeightEnable: false,
      trimEnable: false,
      countyEnable: false,
      countyLesseEnable: false,
      cylinderEnable: false,
      milesEnable: false,
      mvPenalityFee: '',
      mvPenaltyEnable: 'N',
      penaltyApplied: '',
      penaltyStateList: [],
      enableDmvForm: 'N',
      stoppedReminders: '',
      stoppedRemindersBy: '',
      stoppedRemindersOn: '',
      stoppedRemindersReason: '',
      stopReminder: '',
      stopReminderReasons: []
    }
  },


  methods: {

    getReminderStoppedDetails(dmvId) {

      httpdmvtitle
        .get("/dmvNotifications/getReminderStopped/" + dmvId)
        .then(response => {

          if (response.data != null) {

            this.stopReminderList = response.data;
            //this.stopReminderList.stoppedRemindersBy = response.data.reminderStoppedBy;
            // this.stopReminderList.stoppedRemindersOn = response.data.reminderStoppedOn;
            // this.stopReminderList.stoppedRemindersReason = response.data.reminderStoppedReason;

          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },
    submitReminderStoppedDetails() {
      let stopReminderRequestBody = {

        dmvId: this.selecteddmvid,
        reminderStopped: null,
        reminderStoppedBy: this.userId,
        reminderStoppedOn: null,
        reminderStoppedReasonId: this.stopReminder
      }
      console.log(" sss : " + this.stopReminder)
      if (this.stopReminder != '' || this.stopReminder != null) {
        httpdmvtitle.put("dmvNotifications/updateReminderStopped", stopReminderRequestBody).then(response => {


          if (response.data != null) {
            console.log(" update reponse : " + JSON.stringify(response.data))
            this.stopReminderList = response.data;

          }


        })
          .catch(e => {
            this.errorslist.push(e);
          });
      }

    },
    getDmvLoanStatus() {


      httpdmvtitle
        .get("/DMVTitle/getDmvLoanStatus/" + this.deal.dmvTitleStatus)
        .then(response => {

          if (response.data != null) {
            this.emailMilestoneResponse = '- ' + response.data.keyValue;

          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });

    },
    deleteServiceProviderContactEmail(email) {
      var vehicleId = null;
      console.log(this.manageTitle.anotherServiceCompanyId);

      if (this.manageTitle.anotherServiceCompanyId != "") {

        vehicleId = this.manageTitle.anotherServiceCompanyId

      }
      else {

        vehicleId = this.manageTitle.serviceCompanyId.StateVehicleID
      }
      console.log('vehicle id and email : ' + vehicleId + ' -- ' + email + "length ")

      httpdmvtitle
        .delete("/dmvNotifications/deleteServiceProviderContactEmail/" + vehicleId + "/" + email)
        .then(response => {
          console.log(JSON.stringify(response.data));
          if (response.data != null) {

            this.mileageMessage = response.data;

            setTimeout(() => { this.mileageMessageDisabled() }, 2000);
            var vehicleIdService = null;
            if (this.manageTitle.serviceCompanyId.StateVehicleID != null) {
              vehicleIdService = this.manageTitle.serviceCompanyId;
            }
            else {
              vehicleIdService = this.manageTitle.anotherServiceCompanyId;
            }
            this.contactEmails = [];
            this.getServiceProviderDetails(vehicleIdService)
          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },
    displayEnableDMVForm() {
      this.enableDmvForm = 'Y';
    },
    displayDisableDMVForm() {
      this.enableDmvForm = 'N';
    },
    amountFormat() {
      this.deal.lesseeAmount = parseFloat(this.deal.lesseeAmount).toFixed(2)
    },
    // disableList(){
    //this.disableList=true;

    // },
    enableCurbWeight() {
      this.curbWeightEnable = true;
    },
    disableCurbWeight() {
      this.curbWeightEnable = false;
      this.stopReminder = ''
    },

    enableMileage() {
      this.milesEnable = true;
    },
    enableTextBox() {
      this.hideTextBox = true;
    },
    disableTextBox() {
      this.hideTextBox = false;
      this.newEmail = '';
      this.addEmailMessage = '';

    },

    addServiceProviderEmail() {
      var vehicleId = null;
      console.log(this.manageTitle.anotherServiceCompanyId);

      if (this.manageTitle.anotherServiceCompanyId != "") {

        vehicleId = this.manageTitle.anotherServiceCompanyId

      }
      else {

        vehicleId = this.manageTitle.serviceCompanyId.StateVehicleID
      }
      httpdmvtitle.post("/DMVTitle/updateServiceProviderEmailId" + '/' + vehicleId + '/' + this.newEmail).then(response => {
        if (response.data != null) {
          this.msgcolor.color = "BLUE";
          this.addEmailMessage = response.data;;
        }
        if (this.manageTitle.anotherServiceCompanyId != "") {
          console.log("dsgdjg" + this.manageTitle.anotherServiceCompanyId)
          vehicleId = this.manageTitle.anotherServiceCompanyId
          console.log("dsgdjg" + vehicleId)
        }
        else {
          console.log("fsdgg" + this.manageTitle.serviceCompanyId.StateVehicleID)
          vehicleId = this.manageTitle.serviceCompanyId
        }

        this.getServiceProviderDetails(vehicleId);
      });

      this.disableTextBox();

      setTimeout(() => { this.disableEmailMessage() }, 4000);

    },

    verifyServiceProviderEmail() {

      var vehicleId = null;
      if (this.manageTitle.anotherServiceCompanyId != "") {
        console.log(this.manageTitle.anotherServiceCompanyId);
        vehicleId = this.manageTitle.anotherServiceCompanyId;
      }
      else if (this.manageTitle.serviceCompanyId != "") {
        console.log(this.manageTitle.serviceCompanyId);
        vehicleId = this.manageTitle.serviceCompanyId.StateVehicleID;
      }



      var email = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      this.validEmail = email.test(this.newEmail)
      if (!this.validEmail) {
        this.msgcolor.color = "Red";
        this.addEmailMessage = 'Please Enter a Valid Email';

        this.disableSaveButton = true;
      } else {
        this.addEmailMessage = '';
      }
      if (this.addEmailMessage == '') {
        httpdmvtitle.get("/DMVTitle/getServiceProviderEmailId" + '/' + this.newEmail + '/' + vehicleId).then(response => {
          if (response.data != null) {
            this.msgcolor.color = "Red";
            this.addEmailMessage = response.data;
          }


          if (this.addEmailMessage == 'Email Id Is Already Exist Please Enter Another EmailId') {

            this.disableSaveButton = true;

          }
          if (this.addEmailMessage == 'Email Id Is Validated') {
            this.msgcolor.color = "BLUE";
            this.disableSaveButton = false;

          }
        });
        setTimeout(() => { this.disableEmailMessage() }, 4000);
      }
    },



    resetDmvNotes() {
      this.selectedDate = this.dmvNotesCreationDate[0].creationD;
      this.userNameData = this.userNameDataOne;
      this.dmvStatusNotes = true;
      this.getNotesList();
    },


    saveMileage() {
      if (this.deal.milesReported.length == 0) {
        this.deal.milesReported = 0;
      }
      httpdmvtitle
        .post("/DMVTitle/saveMileage/" + this.selecteddmvid + "/" + this.deal.milesReported)
        .then(response => {

          if (response.data != null) {

            this.mileageMessage = 'SuccessFully Updated Miles Data';
            this.diasableMileage();
            setTimeout(() => { this.mileageMessageDisabled() }, 2000);
          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },
    diasableMileage() {
      this.milesEnable = false;
    },
    enableTrim() {
      this.trimEnable = true;
    },
    disableTrim() {
      this.trimEnable = false;

    },
    enableCounty() {
      this.countyEnable = true;
    },
    disableCounty() {
      this.countyEnable = false;
    },
    enableLesseCounty() {
      this.countyLesseEnable = true;
    },
    disableLesseCounty() {
      this.countyLesseEnable = false;
    },
    enableCylinder() {
      this.cylinderEnable = true;
    },
    disableCylinder() {
      this.cylinderEnable = false;
    },
    saveCounty() {

      if (this.deal.registrationCounty.length == 0) {
        this.deal.registrationCounty = 0;
      }

      httpdmvtitle
        .post("/DMVTitle/saveCounty/" + this.selecteddmvid + "/" + this.deal.registrationCounty)
        .then(response => {

          if (response.data != null) {

            this.countyMessage = 'SuccessFully Updated County Data';
            this.disableCounty();
            this.disableLesseCounty();
            setTimeout(() => { this.countyMessageDisabled() }, 2000);
          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });

    },

    getMultipleServiceProviderDetail(option) {



      this.contactEmails = [];

      var vehicleId = "";
      if (this.manageTitle.anotherServiceCompanyId == "") {
        vehicleId = option.StateVehicleID;
      }
      else {
        vehicleId = option;
        this.disableSendContract = false;

      }


      if (this.manageQuoteIdList != null && this.manageQuoteIdList != '') {
        this.requestQuoteStatus = '';
        var modal = document.getElementById("myModalData");
        modal.style.display = "block";

      }


      else {
        console.log("gu" + vehicleId);
        if (vehicleId != "") {
          httpdmvtitle
            .get("/DMVTitle/getdmvserviceProviderById?id=" + vehicleId)
            .then(response => {
              this.providerDetails = response.data;
              //console.log(response.data);
              var serviceProviderObject = this.providerDetails[0];
              console.log(serviceProviderObject.serviceName);
              (this.state = serviceProviderObject.state),
                (this.serviceName = serviceProviderObject.serviceName),
                (this.companyName = serviceProviderObject.companyName),
                (this.street1 = serviceProviderObject.street1),
                (this.street2 = serviceProviderObject.street2),
                (this.stateCode = serviceProviderObject.stateCode),
                (this.zipcode = serviceProviderObject.zipcode),
                (this.license = serviceProviderObject.license),
                (this.contactPerson = serviceProviderObject.contactPerson),
                (this.emailId = serviceProviderObject.emailId),
                (this.phonePerson = serviceProviderObject.phonePerson),
                (this.serviceFee = serviceProviderObject.serviceFee),
                (this.checklistCSV = serviceProviderObject.checklistCSV),
                (this.webURL = serviceProviderObject.webURL),
                (this.instructionNotes = serviceProviderObject.instructionNotes),
                (this.specialNotes = serviceProviderObject.specialNotes),
                (this.processingNotes = serviceProviderObject.processingNotes),
                (this.addressNotes = serviceProviderObject.addressNotes),
                (this.reviewNotes = serviceProviderObject.reviewNotes),
                (this.recordType = serviceProviderObject.recordType),
                (this.manageTitle.anotherserviceCompanyName = serviceProviderObject.serviceName);
              if (this.contactEmails.length == 0) {
                for (var i = 0; i < this.providerDetails.length; i++) {
                  if (this.providerDetails[i].emailId != "") {
                    if (this.providerDetails[i].emailId != null) {
                      this.contactEmails.push(this.providerDetails[i].emailId);
                    }

                  }
                  console.log(JSON.stringify(this.contactEmails));

                }
              }
              else if (this.manageTitle.anotherServiceCompanyId != "") {
                this.contactEmails = [];
                for (var i = 0; i < this.providerDetails.length; i++) {
                  if (this.providerDetails[i].emailId != "") {
                    this.contactEmails.push(this.providerDetails[i].emailId);
                  }
                }
              }
              for (var i = 0; i < this.contactEmails.length; i++) {
                //console.log(this.contactEmails[i]);
              }
            });
        }
        else {
          this.disableSendContract = true;
          this.disablequote = true
        }
      }
      this.manageTitledmvTitleId = null;
      this.getManageQuoteIdsByStatus();
    },
    saveCylinder() {
      if (this.vinaudit.cylinders == null) {
        this.vinaudit.cylinders = 0;
      }
      httpdmvtitle
        .post("/DMVTitle/saveCylinder/" + this.selecteddmvid + "/" + this.vinaudit.cylinders)
        .then(response => {

          if (response.data != null) {

            this.cylinderMessage = 'SuccessFully Updated Cylinder Data';
            this.disableCylinder();

            setTimeout(() => { this.cylinderMessageDisabled() }, 2000);
          }


        })
        .catch(e => {
          this.errorslist.push(e);
        });

    },

    EnableDisableService() {

      if (document.getElementById("chkService").checked == true) {

        this.disableAnotherServiceProvider = false;
        this.dmvOrLlpDisbale = false

      }
      else {

        this.manageTitle.anotherServiceCompanyId = "";
        this.disableAnotherServiceProvider = true;
        //    if(this.registeredServiceProvider.length==1)
        // {
        //   this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]
        console.log("test id" + this.manageTitle.serviceCompanyId)
        this.getServiceProviderDetails(this.manageTitle.serviceCompanyId)
        // }
        // this.contactEmails=[];

        //this.disableSendContract =true
      }
    },

    countyMessageDisabled() {

      this.countyMessage = '';
    },

    cylinderMessageDisabled() {

      this.cylinderMessage = '';
    },

    mileageMessageDisabled() {

      this.mileageMessage = '';
    },
    disableEmailMessage() {
      this.addEmailMessage = '';

    },
    curbWeightMessageDisabled() {

      this.curbWeightMessage = '';
    },
    saveCurbWeight() {
      if (this.vinaudit.curbWeight.length == 0) {
        this.vinaudit.curbWeight = 0;
      }
      if (this.vinaudit.trim.length == 0) {
        this.vinaudit.trim = " ";
      }
      httpdmvtitle
        .post("/DMVTitle/saveCurbWeight/" + this.selecteddmvid + "/" + this.vinaudit.curbWeight + "/" + this.vinaudit.trim + "/" + this.userId)
        .then(response => {


          if (response.data != null) {

            this.curbWeightMessage = 'SuccessFully Updated CurbWeight Data';

            setTimeout(() => { this.curbWeightMessageDisabled() }, 2000);
          }


          this.disableTrim();
          this.disableCurbWeight();


        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },
    getStartDate(index) {



      if (this.milestoneStatusList[index].changeDate > this.milestoneStatusList[index + 1].changeDate) {
        this.startDateMessage = "Status Date Cannot be Greater than next Status Date";
      } else {
        this.startDateMessage = "";

      }


    },
    vinAudit() {
      httpdmvtitle
        .get("/DMVTitle/getVechicleInfo/" + this.selecteddmvid)
        .then(response => {

          this.vinaudit = response.data;



        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },


    getNotesListByDate() {

      //  if (this.selectedDate == 'All'  )
      //   {

      //     this.userNameData ='All';
      //   }

      if (this.selectedDate == 'All' && this.userNameData != 'All') {
        this.getDmvNotesDataByUserName();
      }
      else if (this.selectedDate != 'All' && this.userNameData == 'All') {
        this.getDmvNotesDataByCreationD();
      }
      else if (this.selectedDate == 'All' && this.userNameData == 'All') {

        this.getDmvNotes();


      }

      else {
        //this.userNameDisabled=false;
        httpdmvtitle
          .get("/DMVTitle/getDmvNotesData", {
            params: {
              dmvId: this.selecteddmvid,
              creationd: this.selectedDate == null
                ? null
                : moment(new Date(this.selectedDate)).utc().format('YYYY/MM/DD'),
              userName: this.userNameData,
            }
          })
          .then(response => {
            this.notesList = [];
            for (let i = 0; i < response.data.length; i++) {

              var creviewobject = response.data[i]
              this.notesList.push({
                "id": creviewobject.id,
                "dmvId": creviewobject.dmvId,
                "notes": creviewobject.notes,
                "creationD": creviewobject.creationD,
                "creationUserI": creviewobject.creationUserI,
                "emaiIds": creviewobject.emaiIds,
                "toEmaiIds": creviewobject.toEmaiIds,
                "ccEmaiIds": creviewobject.ccEmaiIds,
                "userName": creviewobject.userName,
                "dmvStatusNotes": creviewobject.dmvStatusNotes,
                "creationDEdit": moment(creviewobject.creationD).format("MM/DD/YYYY"),
                "creationDNew": moment(new Date()).format("MM/DD/YYYY"),
              });
            }


            return this.notesList;





            //this.notesList=response.data;



          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }
    },




    getNotesList() {

      // if (this.userNameData == 'All'  )
      //   {

      //     this.selectedDate ='All';
      //   }
      if (this.selectedDate == 'All' && this.userNameData != 'All') {
        this.getDmvNotesDataByUserName();
      }
      else if (this.selectedDate != 'All' && this.userNameData == 'All') {
        this.getDmvNotesDataByCreationD();
      }

      else if (this.selectedDate == 'All' && this.userNameData == 'All') {

        this.getDmvNotes();


      }

      else {
        //this.userNameDisabled=false;
        httpdmvtitle
          .get("/DMVTitle/getDmvNotesData", {
            params: {
              dmvId: this.selecteddmvid,
              creationd: this.selectedDate == null
                ? null
                : moment(new Date(this.selectedDate)).utc().format('YYYY/MM/DD'),
              userName: this.userNameData,
            }
          })
          .then(response => {

            var responseList = response.data;
            //  this.notesList=response.data;

            if (response.data.length == 0) {
              this.selectedDate = 'All';
              this.userNameData = 'All';
              this.getDmvNotes();
            }
            else {
              this.notesList = [];
              for (let i = 0; i < response.data.length; i++) {

                var creviewobject = response.data[i]
                this.notesList.push({
                  "id": creviewobject.id,
                  "dmvId": creviewobject.dmvId,
                  "notes": creviewobject.notes,
                  "creationD": creviewobject.creationD,
                  "creationUserI": creviewobject.creationUserI,
                  "emaiIds": creviewobject.emaiIds,
                  "toEmaiIds": creviewobject.toEmaiIds,
                  "ccEmaiIds": creviewobject.ccEmaiIds,
                  "userName": creviewobject.userName,
                  "dmvStatusNotes": creviewobject.dmvStatusNotes,
                  "creationDEdit": moment(creviewobject.creationD).format("MM/DD/YYYY"),
                  "creationDNew": moment(new Date()).format("MM/DD/YYYY"),
                });
              }


              return this.notesList;



            }
          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }
    },

    updateLoanStatus(dmvId, loanStatus, changeDate, index) {
      if (this.startDateMessage == '') {
        httpdmvtitle
          .put("/dmvNotifications/updateDMVTitleStatus/" + dmvId + '/' + loanStatus + '/' + changeDate)
          .then(response => {
            if (response.data.message == 'Successfully sent') {
              this.msgcolor.color = "Blue";
              this.saveMilestoneStatus = 'successfully saved into the system';
              this.milestoneStatusList = [];
              this.getManageMilestoneStatus();

            }

          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }
    },

    sendQuote() {

      if (this.manageTitle.serviceCompanyId == null && this.serviceProviderEmails.length == 0) {
        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Service Provider and Contact Email are required';
      }

      else if (this.manageTitle.serviceCompanyId == null && this.manageTitle.anotherServiceCompanyId == null) {

        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Service Provider is rrequired';
      }
      else if (this.serviceProviderEmails.length == 0) {
        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Contact Email is required';
      }

      else {
        console.log("enter firstr else ")
        this.requestQuoteStatus = '';
        if (this.serviceProviderEmails == null && this.contactEmails.length != 1) {
          var modal = document.getElementById("requestquote");
          modal.style.display = "block";
        }

        else if (this.serviceProviderEmails.length != 0 && this.serviceProviderEmails != null) {
          if (this.manageTitle.anotherServiceCompanyId != null && this.manageTitle.anotherServiceCompanyId != '') {

            this.getMultipleServiceProviderDetail(this.manageTitle.anotherServiceCompanyId);
          } else {

            this.saveManageTitleQuote()
          }
        }
      }

    },


    updateNotesData(id, notes, index) {
      console.log(id);


      httpdmvtitle
        .post("/DMVTitle/updateDMVNotes/" + id + '/' + notes).then(response => {

          this.msgcolor.color = "Blue";
          this.notesUpdateMessage = response.data;
          this.getNotesList();
          setTimeout(() => { this.notesUpdateMessageDisabled() }, 2000);
        }

        )
        .catch(e => {
          this.errorslist.push(e);
        });
    },
    updateAuditStatus(dmvId, loanStatus, changeDate, index) {
      //  this.milestoneStatusList=[];
      if (changeDate == null || changeDate == '') {
        this.msgcolor.color = "Red";
        this.saveMilestoneStatus = 'Please select valid date';
        setTimeout(() => { this.auditStatusMessageDisabled() }, 3000);
      }
      else {
        this.saveMilestoneStatus = '';
      }


      if (this.saveMilestoneStatus == '') {

        httpdmvtitle
          .put("/dmvNotifications/updateAuditStatus/" + this.selecteddmvid + '/' + loanStatus + '/' + changeDate + '/' + this.userId)
          .then(response => {
            if (response.data.message == 'Successfully sent') {
              this.msgcolor.color = "Blue";
              this.saveMilestoneStatus = 'successfully saved into the system';
              this.milestoneStatusList = [];
              this.getManageMilestoneStatus();
              setTimeout(() => { this.auditStatusMessageDisabled() }, 2000);
            }

          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }

    },

    cancelServiceProvider() {
      var modal = document.getElementById("myModalData");
      modal.style.display = "none";

      this.getManageQuote(this.manageTitle.quoteId)
      this.manageTitle.anotherServiceCompanyId = "";
      this.disableAnotherServiceProvider = true;


      this.serviceProviderEmails = [];


    },






    saveMultipleManageTitleContract() {


      var modal = document.getElementById("myModalData");
      modal.style.display = "none";
      var contactEmailsData = null;
      if (this.serviceContactEmails == null) {
        contactEmailsData = this.serviceProviderEmails.length != 0 ? this.serviceProviderEmails.toString() : "";
      }
      else {
        contactEmailsData = this.serviceContactEmails;
      }
      var stateVehicleIDs = null;
      var stateServiceNames = null;

      if (this.manageTitle.anotherServiceCompanyId != "") {

        stateVehicleIDs = this.manageTitle.anotherServiceCompanyId;

      }
      else {

        stateVehicleIDs = this.manageTitleServiceId;
      }
      if (this.manageTitle.anotherserviceCompanyName != "") {
        stateServiceNames = this.manageTitle.anotherserviceCompanyName;
      }
      else {
        stateServiceNames = this.manageTitle.serviceCompanyId.ServiceName
      }



      this.saveManageTitleQuote();





      //   if(this.manageTitledmvTitleId !=null)    {   


      //   if(this.manageTitle.additionalInstructions == "")
      //   {
      //     this.manageTitle.additionalInstructions = null
      //   }

      //   let manageTitle = {
      //     manageQuoteid: this.manageTitle.quoteId,
      //     dmvTitleId: this.manageTitledmvTitleId,
      //     dmvId: this.selecteddmvid,
      //     oldTitleNumber: this.manageTitle.oldTitleNumber,
      //     newTitleNumber: this.manageTitle.newTitleNumber,
      //     interimTitleNumber: this.manageTitle.interimTitleNumber,
      //     oldTitleDate: this.manageTitle.oldTitleDate,
      //      licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
      //     newTitleDate: this.manageTitle.newTitleDate,
      //      eltOrderedTitleWorkComplete:this.manageTitle.eltOrderedTitleWorkComplete,
      //       mvWorkSentDate:this.manageTitle.mvWorkSentDate,
      //          mvWorkPackageSentDate:this.manageTitle.mvWorkPackageSentDate,
      //     sendingTitleToTrust:this.manageTitle.sendingTitleToTrust,
      //     interimTitleDate: this.manageTitle.interimTitleDate,
      //     serviceCompanyId: this.manageTitleServiceId,
      //     quoteDate: this.manageTitle.quoteDate,
      //     status:"bad quote",
      //     serviceCompanyName:stateServiceNames,
      //     registrationStreet: this.manageTitle.registrationAddressStreet1,
      //     registrationCity: this.manageTitle.registrationAddressCity,
      //      titleSentToTrust:this.manageTitle.titleSentToTrust,
      //     registrationState: this.manageTitle.registrationAddressState,
      //     registrationZipcode: this.manageTitle.registrationAddressZipcode,
      //     registrationAddressCountry: "USA",
      //     serviceContactEmails: contactEmailsData,
      //     mailSentDate: this.mailSentDate,
      //     acceptedDate: null,
      //     creationUserI: this.userId,
      //     documentlink: this.manageTitle.documentLinks.length!=0? this.manageTitle.documentLinks.toString() : "",
      //     oldTitleState:this.manageTitle.selectedOldTitleStateCode,
      //     interimState:this.manageTitle.selectedInterimStateCode,
      //     newTitleState:this.manageTitle.selectedNewTitleStateCode,
      //     plateNumber:  this.manageTitle.plateNumber

      //   }
      // //  if((this.newDate=="") && (this.oldDate=="") )
      //   {
      //   httpdmvtitle
      //     .post("/dmvNotifications/saveManageTitle/"+this.manageTitle.additionalInstructions, manageTitle)
      //     .then(response => {
      //      // this.manageTitle = this.initializeManageTitle();
      //       this.manageTitle.message = "Manage Title Quote Saved Successfully";
      //       this.msgcolor.color = "green"
      //       setTimeout(()=>{
      //           this.manageTitle.message = ""
      //       },3000);
      //        this.manageTitledmvTitleId=null;
      //        this.serviceProviderEmails= [];
      //        this.manageTitle=this.initializeManageTitle();     
      //                this.manageQuoteIdList=[];
      //       this.getManageQuoteIdsByStatus();
      //         this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);

      //        this.manageTitle.anotherServiceCompanyId="";
      //         this.disableAnotherServiceProvider=true;

      //      // this.contactEmails = [];
      //       this.links=[];
      //       this.getDocuments(this.selectedDealData[0].id,this.selectedDealData[0].loan,this.selectedDealData[0].dealbookRegistrationState);
      //       this.manageTitle.additionalInstructions = null
      //       //if(this.registeredServiceProvider.length==1)
      //      // {
      //         //console.log(this.registeredServiceProvider)
      //      //   this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]
      //      console.log(this.registeredServiceProvider[0])
      //       for(var i=0;i<this.registeredServiceProvider.length;i++){
      //         if(this.registeredServiceProvider[i].StateVehicleID == this.testId){
      //            this.manageTitle.serviceCompanyId = this.registeredServiceProvider[i]
      //         this.getServiceProviderDetails(this.registeredServiceProvider[i])
      //         }
      //       }
      //       //}
      //     })
      //   }
      //   }

      this.manageTitledmvTitleId = null;
      this.serviceProviderEmails = [];
      // this.manageTitle=this.initializeManageTitle();     
      this.manageQuoteIdList = [];
      this.getManageQuoteIdsByStatus();
      this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);

      this.manageTitle.anotherServiceCompanyId = "";
      this.disableAnotherServiceProvider = true;

      // this.contactEmails = [];
      this.links = [];
      
      this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);
      this.manageTitle.additionalInstructions = null
      //if(this.registeredServiceProvider.length==1)
      // {
      //console.log(this.registeredServiceProvider)
      //   this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]
      console.log(this.registeredServiceProvider[0])
      for (var i = 0; i < this.registeredServiceProvider.length; i++) {
        if (this.registeredServiceProvider[i].StateVehicleID == this.testId) {
          this.manageTitle.serviceCompanyId = this.registeredServiceProvider[i]
          this.getServiceProviderDetails(this.registeredServiceProvider[i])
        }
      }
    },
    getManageQuoteIdsByStatus() {

      this.manageQuoteIdList = []
      httpdmvtitle.get("/dmvNotifications/getManageTitleByLoanAndStatus/" + this.selecteddmvid).then(response => {
        let quoteIdsList = []
        quoteIdsList = response.data
        if (quoteIdsList.length > 0) {
          this.manageTitledmvTitleId = quoteIdsList[0].dmvTitleId;
          this.manageTitleServiceId = quoteIdsList[0].serviceCompanyId;
          this.manageTitleQuoteId = quoteIdsList[0].manageQuoteid;
          console.log("fgfghgf" + this.manageTitledmvTitleId)
          if (quoteIdsList.length == 1 && quoteIdsList[0].status == "contract") {
            this.serviceProviderCheckList.push(quoteIdsList[0].serviceCompanyName)
            this.disabledropdown = true;
            this.disablequote = true;
            this.dmvTitleIdStatus = quoteIdsList[0].status;
            this.manageTitle.statusContract = true
            this.disableSendContract = true;
            //console.log(this.dmvTitleIdStatus+"status")

            this.manageTitle.dmvTitleId = quoteIdsList[0].dmvTitleId;
            this.manageTitle.quoteId = quoteIdsList[0].manageQuoteid;
            this.manageTitle.oldTitleNumber = quoteIdsList[0].oldTitleNumber;
            this.manageTitle.newTitleNumber = quoteIdsList[0].newTitleNumber;
            this.manageTitle.interimTitleNumber = quoteIdsList[0].interimTitleNumber;
            this.manageTitle.status = quoteIdsList[0].status;
            this.manageTitle.oldTitleDate = quoteIdsList[0].oldTitleDate == null ? null : new Date(quoteIdsList[0].oldTitleDate);
            this.manageTitle.newTitleDate = quoteIdsList[0].newTitleDate == null ? null : new Date(quoteIdsList[0].newTitleDate);
            this.manageTitle.mvWorkSentDate = quoteIdsList[0].mvWorkSentDate == null ? null : new Date(quoteIdsList[0].mvWorkSentDate);

            this.manageTitle.mvWorkPackageSentDate = quoteIdsList[0].mvWorkPackageSentDate == null ? null : new Date(quoteIdsList[0].mvWorkPackageSentDate);

            this.manageTitle.eltOrderedTitleWorkComplete = quoteIdsList[0].eltOrderedTitleWorkComplete == null ? null : new Date(quoteIdsList[0].eltOrderedTitleWorkComplete);
            this.manageTitle.sendingTitleToTrust = quoteIdsList[0].sendingTitleToTrust == null ? null : new Date(quoteIdsList[0].sendingTitleToTrust);
            this.manageTitle.interimTitleDate = quoteIdsList[0].interimTitleDate == null ? null : new Date(quoteIdsList[0].interimTitleDate);
            this.manageTitle.quoteDate = quoteIdsList[0].quoteDate == null ? null : new Date(quoteIdsList[0].quoteDate);
            //  this.serviceProviderEmails = quoteIdsList[0].serviceContactEmails;
            this.manageTitle.acceptedDate = quoteIdsList[0].acceptedDate;
            this.manageTitle.additionalInstructions = quoteIdsList[0].additionalInstructions;
            this.manageTitle.selectedOldTitleStateCode = quoteIdsList[0].oldTitleState;
            this.manageTitle.selectedNewTitleStateCode = quoteIdsList[0].newTitleState;
            this.manageTitle.selectedInterimStateCode = quoteIdsList[0].interimState;
            this.manageTitle.plateNumber = quoteIdsList[0].plateNumber;
            this.manageTitle.licensePlateNumberDate = quoteIdsList[0].licensePlateNumberDate == null ? null : new Date(quoteIdsList[0].licensePlateNumberDate);


            console.log("dddddd" + quoteIdsList[0].oldTitleState);
            for (let i = 0; i < this.serviceProviders.length; i++) {
              if (this.serviceProviders[i].StateVehicleID == quoteIdsList[0].serviceCompanyId && this.serviceProviders[i].ServiceName != '') {
                this.testId = quoteIdsList[0].serviceCompanyId;
                console.log("testId" + this.testId);
                console.log("serviceCompanyName" + quoteIdsList[0].serviceCompanyName);
                this.manageTitle.serviceCompanyId = this.serviceProviders[i]

                this.getServiceProviderDetails(this.serviceProviders[i]);
              }
            }
            this.getRegisteredAddress(this.selecteddmvid)
            setTimeout(() => {
              this.manageTitle.message = ""
            }, 3000)
            this.getDMVWorkStatus(response.data.dmvId);

            this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);

          }
          else {
            for (let j = 0; j < quoteIdsList.length; j++) {
              if (quoteIdsList[j].status != "" && quoteIdsList[j].status != null) {
                if (quoteIdsList[j].status != "bad quote") {
                  this.manageQuoteIdList.push(quoteIdsList[j])

                  //console.log( quoteIdsList[j])
                }
              }
              else {
                //console.log(quoteIdsList[j].dmvTitleId)
                this.manageTitle.dmvTitleId = quoteIdsList[j].dmvTitleId
                this.getManageTitleDmvTitle(quoteIdsList[j].dmvTitleId)
              }
            }
            for (let i = 0; i < this.manageQuoteIdList.length; i++) {
              this.serviceProviderCheckList.push(this.manageQuoteIdList[i].serviceCompanyName)
            }

            //console.log(response.data);
            quoteIdsList = []
          }
        }
      });


    },
    updateAuditStatusForDMVOrTitleWork(dmvId, dmvOrStillWorkNeeded, index) {


      if (dmvOrStillWorkNeeded.charAt(0).toUpperCase() != 'N' && dmvOrStillWorkNeeded.charAt(0).toUpperCase() != 'Y') {

        this.saveMilestoneStatus = 'Value Should be Starts With N OR Y Characters';

      }
      else {
        this.saveMilestoneStatus = '';
      }
      if (this.saveMilestoneStatus == '') {

        httpdmvtitle
          .put("/dmvNotifications/updateAuditStatusForDMVOrTitleWork/" + this.selecteddmvid + '/' + dmvOrStillWorkNeeded.toUpperCase())
          .then(response => {
            if (response.data.message == 'Successfully sent') {
              this.msgcolor.color = "Blue";
              this.saveMilestoneStatus = 'successfully saved into the system';
              this.milestoneStatusList = [];
              this.getManageMilestoneStatus();
              setTimeout(() => { this.auditStatusMessageDisabled() }, 2000);
            }

          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }
    },

    auditStatusMessageDisabled() {
      this.saveMilestoneStatus = '';
    },

    notesUpdateMessageDisabled() {
      this.notesUpdateMessage = '';
    },

    getManageMilestoneStatus() {
      this.milestoneStatusList = [];

      httpdmvtitle
        .get("/DMVTitle/getLoanStatusAudit", {
          params: {
            dmvId: this.selecteddmvid,
            loanNumber: this.deal.selectedLoan
          }
        }).then(response => {
          this.milestoneStatusList = response.data;

          for (let i = 0; i < this.milestoneStatusList.length; i++) {
            if (this.milestoneStatusList[i].changeDate != null) {
              let date1 = new Date(this.milestoneStatusList[i + 1].changeDate);
              let date2 = new Date(this.milestoneStatusList[i].changeDate);

              const diffTime = Math.abs(date2 - date1);
              let diff = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              this.milestoneStatusList[i + 1].elapsedDays = diff;

            }

            if (this.milestoneStatusList[i].changeDate == null) {

              this.milestoneStatusList[i].elapsedDays = 0;


            }
          }



        })
    },


    clearMessages() {
      this.responseMessage = ''
      this.responseFinancialMessage = ''
    },
    download() {
      //this.selectedDealData[0].dealbookRegistrationState
      httpdmvtitle
        .get("/dmvNotifications/sendDMVForm/" + this.selectedDealData[0].dealbookRegistrationState)
        .then(response => {

          this.link = response.data;
          // return response.data;
        })

    },
    deleteDocuments(link) {
      var splitLink = link.split("/")
      //console.log("SPLIT : "+splitLink[5]);
      var pdflink = splitLink[5].split("?");
      httpdmvtitle.delete('/dmvNotifications/deleteDocuments/' + this.selectedDealData[0].loan + '/' + pdflink[0]).then(response => {
        this.links = [];        
        this.msgcolor.color = "Red";
        this.responseMessage = "Document Deleted Succesfully";
        this.links = response.data;
        this.$refs.file.value = null;
        this.documents = '';
        this.documentName = ''

      })

    },




    getDocuments(id, loan, state) {
      httpdmvtitle.get('/dmvNotifications/getDocuments/' + id + '/' + loan + '/' + this.userId + '/' + state).then(response => {
        var status = response.data;
        this.links = [];
        this.links = response.data
        
        var modal = document.getElementById("uploaddoc");
        modal.style.display = "none";
        if (this.links.length == 0) {
          this.allDocs = 'N';
          var modal = document.getElementById("getdoc");
          modal.style.display = "block";
        } else {
          this.allDocs = 'N';
        }
      }, err=>{        
        this.allDocs = 'N';
        
      })
    },

    clearModal() {
      var modal = document.getElementById("getdoc");
      modal.style.display = "none";
    },
    
    myFunction(link) {
      window.open(link, "_blank");
    },
    dmvValidation() {
      if (this.deal.checkNumber != '' || this.deal.checkPayableTo != '' || this.deal.amount != '' || this.deal.checkDate != '') {
        this.dmvValidate = 'required';

      }

    },
    lesseeValidation() {
      if (this.deal.lesseeCheckNumber != '' || this.deal.lesseeCheckPayableTo != '' || this.deal.lesseeAmount != '' || this.deal.lesseeCheckDate != '') {
        this.lesseeValidate = 'required';
      }
    },


    getOwnedAmount() {
      let substract = 0;
      if (this.luxuryTaxEnable == 'Y') {
        let multiply = this.deal.monthlySalesTax * this.deal.numberAdvancedPayments;
        substract = this.deal.initialSalesTaxAtPurchase - multiply;
        this.financialSalesTax = substract.toFixed(2);
        if (this.deal.dealbookRegistrationState == 'NJ') {
          if (this.selectedDealData[0].leaseDealerType == 'New') {
            this.luxuryTax = (this.selectedDealData[0].sellingPrice * 4) / 1000;
            console.log("Selling price : " + ((this.selectedDealData[0].sellingPrice * 4) / 1000))
          }
        }

      }
      let total = substract + this.deal.dmvFees;
      this.financialTotal = total.toFixed(2);
      /*   let amount = (total - this.deal.amount).toFixed(2);
   
    if(amount == this.deal.lesseeAmount){
   this.ownedAmount = 0;
    }else{
      this.ownedAmount = amount;
    }
   
   
   if(Math.sign(this.ownedAmount) == 1){
   this.msgOwnedcolor.color = "Green";
   }else if(Math.sign(this.ownedAmount) == -1){
   this.msgOwnedcolor.color = "Red";
   }*/


    },

    getTOemailids(employeeEmails) {
      var that = this;
      that.toEmailids = [];

      $.each($("input[name='toemailids']:checked"), function () {
        that.toEmailids.push($(this).val());
        employeeEmails.push($(this).val());


      });


      var ele = document.getElementsByName('toemailids');
      var ele1 = document.getElementsByName('ccemailids');
      for (var i = 0; i < ele1.length; i++) {

        if (ele[i].checked == false && ele1[i].checked == true) {
          this.saved = true;
          this.savemessage = '';
        }


      }

      for (var i = 0; i < ele1.length; i++) {


        if (ele[i].checked == true && ele1[i].checked == true) {
          this.saved = true;
          this.msgcolor.color = "Red";
          this.savemessage = "Please mark only one checkbox either To Email or CC Email";
        }


      }

    },


    getCCemailids() {
      var that = this;
      that.ccEmailids = [];
      $.each($("input[name='ccemailids']:checked"), function () {
        that.ccEmailids.push($(this).val());
      });

      var ele = document.getElementsByName('toemailids');
      var ele1 = document.getElementsByName('ccemailids');
      for (var i = 0; i < ele.length; i++) {

        if (ele[i].checked == true && ele1[i].checked == false) {
          this.saved = true;
          this.savemessage = '';
        }


      }
      for (var i = 0; i < ele.length; i++) {

        if (ele[i].checked == true && ele1[i].checked == true) {
          this.saved = true;
          this.msgcolor.color = "Red";
          this.savemessage = "Please mark only one checkbox either To Email or CC Email";
        }


      }


    },

    sendContract() {

      if (this.manageTitle.serviceCompanyId == null && this.serviceProviderEmails.length == 0) {
        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Service Provider and Contact Email are required';
      }

      else if (this.manageTitle.serviceCompanyId == null) {
        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Service Provider is required';
      }
      else if (this.serviceProviderEmails.length == 0) {
        this.msgcolor.color = "Red";
        this.requestQuoteStatus = 'Contact Email is required';
      }

      else {
        this.requestQuoteStatus = '';
        var modal = document.getElementById("myModal");
        modal.style.display = "block";
      }
    },

    cancelContract() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";

      this.getManageQuote(this.manageTitle.quoteId)
      this.manageTitle.anotherServiceCompanyId = "";
      this.disableAnotherServiceProvider = true;
      this.contactEmails = [];
      this.serviceProviderEmails = [];
      console.log(this.serviceProviderEmails);
      var checkBox = document.getElementById("chkService");
      if (checkBox.checked == true) {
        checkBox.checked = false;
      }


    },

    getAvailableDocuments() {
      var that = this;
      that.manageTitle.documentLinks = [];
      $.each($("input[name='documentLinks']:checked"), function () {
        that.manageTitle.documentLinks.push($(this).val());
      });

    },


    getDmvNotes() {
      httpdmvtitle.get("/DMVTitle/getDmvNotes", {
        params: {
          dmvId: this.selecteddmvid
        }
      }).then(response => {


        this.notesList = [];
        for (let i = 0; i < response.data.length; i++) {

          var creviewobject = response.data[i]
          this.notesList.push({
            "id": creviewobject.id,
            "dmvId": creviewobject.dmvId,
            "notes": creviewobject.notes,
            "creationD": creviewobject.creationD,
            "creationUserI": creviewobject.creationUserI,
            "emaiIds": creviewobject.emaiIds,
            "toEmaiIds": creviewobject.toEmaiIds,
            "ccEmaiIds": creviewobject.ccEmaiIds,
            "userName": creviewobject.userName,
            "dmvStatusNotes": creviewobject.dmvStatusNotes,
            "creationDEdit": moment(creviewobject.creationD).format("MM/DD/YYYY"),
            "creationDNew": moment(new Date()).format("MM/DD/YYYY"),
          });
        }


        return this.notesList;

        // this.notesList = response.data;
        //this.selectedDate='';
        // this.userNameData='';
      });

    },
    getDmvNotesCreationDate() {
      httpdmvtitle.get("/DMVTitle/getDmvNotesCreationdate", {
        params: {
          dmvId: this.selecteddmvid
        }
      }).then(response => {
        this.dmvNotesCreationDate = response.data;
        if (response.data != null) {
          this.selectedDate = this.dmvNotesCreationDate[0].creationD;
        }
        this.getNotesList();
      });

    },



    getDmvNotesUserName() {
      httpdmvtitle.get("/DMVTitle/getDmvNotesUserName", {
        params: {
          dmvId: this.selecteddmvid
        }
      }).then(response => {
        this.dmvNotesuserName = response.data;

      });

    },
    getDmvNotesDataByUserName() {
      httpdmvtitle.get("/DMVTitle/getDmvNotesDataByUserName", {
        params: {
          dmvId: this.selecteddmvid,
          userName: this.userNameData
        }
      }).then(response => {

        this.notesList = [];
        for (let i = 0; i < response.data.length; i++) {

          var creviewobject = response.data[i]
          this.notesList.push({
            "id": creviewobject.id,
            "dmvId": creviewobject.dmvId,
            "notes": creviewobject.notes,
            "creationD": creviewobject.creationD,
            "creationUserI": creviewobject.creationUserI,
            "emaiIds": creviewobject.emaiIds,
            "toEmaiIds": creviewobject.toEmaiIds,
            "ccEmaiIds": creviewobject.ccEmaiIds,
            "userName": creviewobject.userName,
            "dmvStatusNotes": creviewobject.dmvStatusNotes,
            "creationDEdit": moment(creviewobject.creationD).format("MM/DD/YYYY"),
            "creationDNew": moment(new Date()).format("MM/DD/YYYY"),
          });
        }


        return this.notesList;

        //this.notesList = response.data;
        //this.selectedDate='';
        // this.userNameData='';
      });

    },
    getDmvNotesDataByCreationD() {
      httpdmvtitle.get("/DMVTitle/getDmvNotesDataByCreationD", {
        params: {
          dmvId: this.selecteddmvid,
          creationd: this.selectedDate == null
            ? null
            : moment(new Date(this.selectedDate)).utc().format('YYYY/MM/DD')
        }
      }).then(response => {

        this.notesList = [];
        for (let i = 0; i < response.data.length; i++) {

          var creviewobject = response.data[i]
          this.notesList.push({
            "id": creviewobject.id,
            "dmvId": creviewobject.dmvId,
            "notes": creviewobject.notes,
            "creationD": creviewobject.creationD,
            "creationUserI": creviewobject.creationUserI,
            "emaiIds": creviewobject.emaiIds,
            "toEmaiIds": creviewobject.toEmaiIds,
            "ccEmaiIds": creviewobject.ccEmaiIds,
            "userName": creviewobject.userName,
            "dmvStatusNotes": creviewobject.dmvStatusNotes,
            "creationDEdit": moment(creviewobject.creationD).format("MM/DD/YYYY"),
            "creationDNew": moment(new Date()).format("MM/DD/YYYY"),
          });
        }


        return this.notesList;


        // this.notesList = response.data;
        //this.selectedDate='';
        // this.userNameData='';
      });

    },


    deleteContact: function (index) {
      this.tempTagRegList.splice(index, 1);
    },
    deleteEmails: function (index) {
      this.employeemailids.splice(index, 1);

    },
    addnewTempTag(e) {
      if (this.tempTag == true) {

        this.saveDmvTempmessage = '';

        if (this.saveDmvTempmessage == '') {
          if (this.tempTagRegList.emailSentTo == null) {
            this.tempTagRegList.emailSentTo = [];
          }
          let newTempTag = {
            timesTempRegIssued: this.tempTagRegList.timesTempTagIssued,
            tempTag: this.tempTagRegList.temptagdata,
            whoIssued: this.tempTagRegList.whoIsIssued,
            emailSentTo: this.tempTagRegList.emailSentTo.toString(),
            issuedBy: this.tempTagRegList.issuedBy,
            dateOfExpiry: moment(this.tempTagRegList.dateOfExpiry),
            confNumber: this.tempTagRegList.confNumber,
            transDate: moment(this.tempTagRegList.transDate),
            creationD: moment(this.tempTagRegList.issueDate),
            cost: this.tempTagRegList.cost,
            location: this.tempTagRegList.location,
            tempType: this.tempTagRegList.tempType,
            dmvID: this.selecteddmvid

          }
          httpdmvtitle.post('/DMVTitle/saveDMVTempRegistration', newTempTag).then(response => {
            var status = response.data;
            if (status == "CREATED") {
              this.saved = true;
              this.msgcolor.color = "Blue";
              this.saveDmvTempmessage = 'Successfully added into the system'
              this.tempTagRegList = [];
              //  this.tempTagRegList.dateOfExpiry=moment().add(30,'days').format("YYYY-MM-DD");
              this.getDMVTempTagRegistration();
              this.tempTag = false;

              setTimeout(() => { this.tempTagMessage() }, 2000);



            }
          })

        }
      }
    }, // end if

    tempTagMessage() {

      this.saveDmvTempmessage = '';
    },
    disableNotesMessage() {
      this.savemessage = '';
    },
    addTempTagData() {
      //this.tempTagRegList.dateOfExpiry=moment().add(this.temptagAddDaysData[0].keyValue,'days').format("YYYY-MM-DD");

      var rownum = 0;
      for (var i = 0; i < this.tempTagRegListData.length; i++) {
        rownum = i + 1;
        this.tempTagRegListData[i].rownumber = rownum;
      }
      //console.log("This is")
      this.tempTagRegList.timesTempTagIssued = this.tempTagRegListData.length + 1;
      this.$validator.validateAll("addscontact").then((isValid) => {
        if (isValid) {
          this.tempTagRegList.push({
            'rownumber': rownum + 1,
            'timesTempTagIssued': this.tempTagRegList.timesTempTagIssued,
            'dateOfExpiry': this.tempTagRegList.dateOfExpiry,
            'issuedBy': this.tempTagRegList.issuedBy,
            'whoIsIssued': this.tempTagRegList.whoIsIssued,

          })






        }
      })
    },
    receiveMessage(event) {
      if (
        event.data.type != "webpackWarnings" &&
        event.data.type != "webpackClose"
      ) {
        var userdata = event.data;
        // console.log(userdata);
        sessionStorage.setItem("JWT", userdata.jwt);
        sessionStorage.setItem("USERID", userdata.userId);
        sessionStorage.setItem("LOGGEDIN", true);
        sessionStorage.setItem("USERNAME", userdata.userName);

        //this.getDMVServiceProvider();
      }
    },
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
    },
    getemailids() {
      var that = this;
      that.employeemailids = [];
      $.each($("input[name='emailids']:checked"), function () {
        that.employeemailids.push($(this).val());
        //console.log(that.employeemailids);
      });
    },
    getToemailids() {
      var that = this;
      that.tempTagRegList.emailSentTo = [];
      $.each($("input[name='Toemailids']:checked"), function () {
        that.tempTagRegList.emailSentTo.push($(this).val());
        //console.log( that.tempTagRegList.emailSentTo);
      });
    },
    emailidslist() {
      var checkList = document.getElementById("list2");
      var items1 = document.getElementById("items1");

      if (items1.classList.contains("visible")) {
        items1.classList.remove("visible");
        items1.style.display = "none";
      } else {
        items1.classList.add("visible");
        items1.style.display = "block";
      }
    },
    listemailids() {
      var checkList = document.getElementById("list1");
      var items = document.getElementById("items");


      // checkList.getElementsByClassName("anchor")[0].onclick = function(evt) {
      if (items.classList.contains("visible")) {
        items.classList.remove("visible");
        items.style.display = "none";
      } else {
        items.classList.add("visible");
        items.style.display = "block";
      }


      //};

      items.onblur = function (evt) {
        items.classList.remove("visible");
      };
    },
    issueTempTag() {
      this.addTempTagData();
      this.tempTag = true;



    },
    getDMVTitledata() {
      httpdmvtitle.get("/getDMVTitleData").then(response => {
        this.dmvTitleDataList = response.data;
      });
    },


    getServiceProviderMails() {

      // console.log("enter");
      //   var that = this;
      //   that.serviceProviderEmails= [];
      //   $.each($("input[name='serviceProviderEmails']:checked"), function() {
      //     that.serviceProviderEmails.push($(this).val());

      //     this.emailNotSelected =""
      //   });

      console.log(this.serviceProviderEmails);
    },

    getRegisteredAddress(dmvid) {
      httpdmvtitle
        .get("/DMVTitle/getDMVTitleDataById?dmvid=" + dmvid)
        .then(response => {
          let selectedDealData1 = [];
          selectedDealData1 = response.data
          this.manageTitle.registrationAddressStreet1 = selectedDealData1[0].registrationStreet,

            this.manageTitle.registrationAddressCity = selectedDealData1[0].registrationCity,

            this.manageTitle.registrationAddressZipcode = selectedDealData1[0].registrationZipcode,

            this.manageTitle.registrationAddressState = selectedDealData1[0].registrationState,
            this.manageTitle.titleSentToTrust = this.selectedDealData1[0].titleSentToTrust == null ? null : new Date(this.selectedDealData1[0].titleSentToTrust)





          this.deal.dmvTitleStatus = selectedDealData1[0].dmvTitleStatus

        })

    },
    getTitleSentToTrust() {
      this.getSelectedDealData(this.selecteddmvid)
      console.log("testing date res")
    },
    getSelectedDealData(dmvid) {
      httpdmvtitle
        .get("/DMVTitle/getDMVTitleDataById?dmvid=" + dmvid)
        .then(response => {
          console.log("HELL : " + JSON.stringify(response.data))



          this.selectedDealData = response.data;
          this.deal.selectedLoan = this.selectedDealData[0].loan;
          this.deal.loanNumber = "-Lease#" + this.selectedDealData[0].loan;
          this.deal.loanStatus = this.selectedDealData[0].loanStatus,
            this.deal.selectedLesseeName = this.selectedDealData[0].borrowername;
          this.deal.selectedLesseeCity = this.selectedDealData[0].borrowerCity;
          this.deal.selectedLesseeAddress = this.selectedDealData[0].borrowerAddress;
          this.deal.selectedLesseeZip = this.selectedDealData[0].borrowerZipcode;
          this.deal.selectedLesseeEmail = this.selectedDealData[0].borrowerEmail;
          this.deal.selectedLesseeState = this.selectedDealData[0].borrowerState;
          this.deal.selectedLesseePhone = this.selectedDealData[0].borrowerPriPhone;
          this.deal.selectedYear = this.selectedDealData[0].year;
          this.deal.selectedMake = this.selectedDealData[0].make;
          this.deal.selectedModel = this.selectedDealData[0].model;
          this.deal.selectedVin = this.selectedDealData[0].vin;
          this.deal.selectedColor = this.selectedDealData[0].color;
          this.deal.dealbookRegistrationState = this.selectedDealData[0].dealbookRegistrationState;
          this.deal.referringDealer = this.selectedDealData[0].sourceCompany;
          this.deal.dmvTitleStatus = this.selectedDealData[0].dmvTitleStatus;
          this.deal.titleState = this.selectedDealData[0].titleState,
            this.deal.dealerDMVStatus = this.selectedDealData[0].dealerDMVStatus,
            this.deal.registrationState = this.selectedDealData[0].registrationState,
            this.deal.dmvStatusDate = this.selectedDealData[0].dmvStatusDate,

            this.deal.dmvOrTitleWorkStillNeeded = this.selectedDealData[0].dmvOrTitleWorkStillNeeded,

            this.manageTitle.registrationAddressStreet1 = this.selectedDealData[0].registrationStreet,

            this.manageTitle.registrationAddressCity = this.selectedDealData[0].registrationCity,
            this.manageTitle.titleSentToTrust = this.selectedDealData[0].titleSentToTrust == null ? null : new Date(this.selectedDealData[0].titleSentToTrust);

          this.manageTitle.registrationAddressZipcode = this.selectedDealData[0].registrationZipcode == null ? "" : this.selectedDealData[0].registrationZipcode.replace(".0", ""),

            this.manageTitle.registrationAddressState = this.selectedDealData[0].registrationState,

            this.deal.curbWeight = this.selectedDealData[0].curbWeight,

            this.deal.registrationCounty = this.selectedDealData[0].registrationCounty,
            this.deal.milesReported = this.selectedDealData[0].milesReported,
            this.deal.dateOfSaleToLLP = this.selectedDealData[0].dateOfSaleToLLP,
            this.deal.initialSalesTaxAtPurchase = this.selectedDealData[0].initialSalesTaxAtPurchase,

            this.deal.monthlySalesTax = this.selectedDealData[0].monthlySalesTax,

            this.deal.numberAdvancedPayments = this.selectedDealData[0].numberAdvancedPayments,
            this.deal.dmvFees = this.selectedDealData[0].dmvFees,
            this.deal.dealbookRegistrationState = this.selectedDealData[0].dealbookRegistrationState,
            this.deal.additionalEmail = this.selectedDealData[0].additionalEmail,
            this.deal.odometer = this.selectedDealData[0].odometer,
            this.deal.emailMilestone = this.selectedDealData[0].emailMilestone,

            this.deal.dealerDMV = this.selectedDealData[0].dealerDMV,

            this.registeredServiceProvider = []


          for (var i = 0; i < this.serviceProviders.length; i++) {
            if (
              this.serviceProviders[i].StateCode == this.deal.dealbookRegistrationState && this.serviceProviders[i].ServiceName != "" && this.serviceProviders[i].ServiceName != null
            ) {


              if (this.registeredServiceProvider.length == 0) {


                httpdmvtitle.get("/DMVTitle/getdmvserviceProviderByIdAndStateCode", {
                  params: {
                    stateCode: this.deal.dealbookRegistrationState
                  }
                }).then(response => {
                  this.registeredServiceProvider = [];
                  this.registeredServiceProvider = response.data;
                });
                this.registeredServiceProvider.push(this.serviceProviders[i]);
              }
              else {
                for (let i = 0; i < this.registeredServiceProvider; i++) {
                  if (this.registeredServiceProvider[i].ServiceName == this.serviceProviders[i].ServiceName) {
                    this.registeredServiceProvider.push(this.serviceProviders[i]);
                  }

                }
              }
            }
            if (this.registeredServiceProvider.length != 0 && this.registeredServiceProvider.length != null) {
              this.disableSendContract = false;
              this.disablequote = false;
            }
            else {
              this.disableSendContract = true;
              this.disablequote = true
            }
          }
          if (this.registeredServiceProvider.length == 1) {
            this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]

            this.getServiceProviderDetails(this.registeredServiceProvider[0])
          }
          if (this.registeredServiceProvider.length == 0) {
            this.manageTitle.serviceCompanyId = "No Data available"
          }

          if (this.deal.dealbookRegistrationState == 'VT' ||
            this.deal.dealbookRegistrationState == 'TX' ||
            this.deal.dealbookRegistrationState == 'GA' ||
            this.deal.dealbookRegistrationState == 'IL' ||
            this.deal.dealbookRegistrationState == 'MD' ||
            this.deal.dealbookRegistrationState == 'VA' ||
            this.deal.dealbookRegistrationState == 'MO' ||
            this.deal.dealbookRegistrationState == 'SC') {


            this.luxuryTaxEnable = 'Y';


          }
          if (this.deal.dealbookRegistrationState == 'NJ') {
            if (this.selectedDealData[0].leaseDealerType == 'New') {
              this.luxuryTaxEnable = 'Y';
            } else {
              this.luxuryTaxEnable = 'N';
            }
          }
          this.getReminderStoppedDetails(this.selectedDealData[0].id);
          this.getkeyData();
          this.getkeyData1();
          this.getDMVServiceProvider();
          this.getDmvLoanStatus();

          this.vinAudit();
          this.getMVPenality();
          this.getDMVDealerConatcs(this.deal.referringDealer);
          this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);
          this.getFinancialData(this.selectedDealData[0].id);

          this.getManageQuoteIds();

          this.getDmvMileStone();
          this.getManageMilestoneStatus();
          this.download();
          this.getDmvNotesCreationDate();
          this.selectedDate = this.dmvNotesCreationDate[0].creationD;
          this.getNotesList();
          this.statesList();
        });



    },

    getSeviceNamesByIdAndState(stateCode) {
      this.serviceProviderStatesList = [];
      httpdmvtitle.get("DMVTitle/getdmvserviceProviderByIdAndStateCode", {
        params: {

          stateCode: stateCode

        }
      }).then(response => {
        this.serviceProviderStatesList1 = response.data;

        for (var i = 0; i < this.serviceProviderStatesList1.length; i++) {
          console.log(JSON.stringify(this.serviceProviderStatesList1))
          console.log(this.serviceProviderStatesList1[i].StateVehicleID != this.testId);
          console.log("id" + this.serviceProviderStatesList1[i].StateVehicleID + " ," + this.testId)
          if (
            this.serviceProviderStatesList1[i].StateVehicleID.toString() !== this.testId.toString() && this.serviceProviderStatesList1[i].StateVehicleID != "" && this.serviceProviderStatesList1[i].StateVehicleID != null
          ) {
            console.log("inside loop");
            this.serviceProviderStatesList.push(this.serviceProviderStatesList1[i]);
            //console.log(this.registeredServiceProvider);


          }

        }
        console.log(JSON.stringify(this.serviceProviderStatesList))
      })

    },



    getMVPenality() {
      if (this.selectedDealData[0].contractDate != null) {
        httpdmvtitle.get("/dmvNotifications/getPenaltyForState/" + this.selectedDealData[0].id + "/" + this.deal.dealbookRegistrationState).then(response => {
          this.penaltyStateList = response.data;
          if (this.penaltyStateList.length != 0) {
            if (this.penaltyStateList[0].penalty_tax.length != 0) {
              this.mvPenaltyEnable = 'Y';
              this.mvPenalityFee = this.penaltyStateList[0].penalty_tax
            }
            if (this.penaltyStateList[0].penalty_color.length != 0 && this.penaltyStateList[0].penalty_color == 'red') {
              this.penaltyApplied = 'Y';
            } else if (this.penaltyStateList[0].penalty_color.length != 0 && this.penaltyStateList[0].penalty_color == 'green') {
              this.penaltyApplied = 'N';
            }
          } else {
            this.mvPenaltyEnable = 'N';
          }
        });
      }
      else {
        this.mvPenaltyEnable = 'N';
      }

    },

    getDMVDealerConatcs(dealer) {
      httpdmvtitle.get("/DMVTitle/getDMVDealerContacts/" + dealer).then(response => {
        this.dmvDealerContactsList = response.data;
        if (this.deal.dealerDMV == "Y") {
          this.dmvOrLlpDisbale = true;
          this.hideQuoteDate = false;
          this.hideLLPDoingQuoteDate = true;
        } else if (this.deal.dealerDMV == "N") {
          this.dmvOrLlpDisbale = false;
          this.hideQuoteDate = true;
          this.hideLLPDoingQuoteDate = false;
        }
        //console.log("DMV AAAAAAA : "+JSON.stringify(this.dmvDealerContactsList));
      });
    },
    getFinancialData(loan) {
      let multiply = this.deal.monthlySalesTax * this.deal.numberAdvancedPayments;
      let substract = this.deal.initialSalesTaxAtPurchase - multiply;
      let total = substract + this.deal.dmvFees;
      let owned = total - this.deal.amount;
      //console.log("FINANCIAL LOAN: " + JSON.stringify(loan))
      httpdmvtitle
        .get("/dmvNotifications/getFinancials/" + loan)
        .then(response => {
          //console.log("FINANCIAL RESPOSNE : " + JSON.stringify(response.data))
          if (response.data != "") {
            this.selectedFinancialData = response.data;
            this.deal.checkNumber = this.selectedFinancialData.checkNumber,

              this.deal.checkPayableTo = this.selectedFinancialData.checkPayableTo,

              this.deal.amount = this.selectedFinancialData.amount,
              this.deal.checkDate = this.selectedFinancialData.checkDate == null ? null : new Date(this.selectedFinancialData.checkDate),

              this.deal.lesseeCheckNumber = this.selectedFinancialData.lesseeCheckNumber,

              this.deal.lesseeCheckPayableTo = this.selectedFinancialData.lesseeCheckPayableTo,

              this.deal.lesseeAmount = this.selectedFinancialData.lesseeAmount,

              this.deal.lesseeCheckDate = this.selectedFinancialData.lesseeCheckDate == null ? null : new Date(this.selectedFinancialData.lesseeCheckDate)
            this.getOwnedAmount();
            this.getOwnedAmountData();
          } else {
            this.selectedFinancialData = []
          }


          if (owned == this.deal.lesseeAmount) {
            this.ownedAmount = 0
          } else {
            this.getOwnedAmount();
            this.getOwnedAmountData();
          }
        });
    },
    getOwnedAmountData() {

      if (this.deal.amount != '') {
        let amount = (this.financialTotal - this.deal.amount).toFixed(2);
        this.deal.amount = parseFloat(this.deal.amount).toFixed(2)
        if (Math.sign(amount) == 1) {
          if (this.deal.amount != '') {
            this.msgOwnedcolor.color = "Green";
            if (amount == this.deal.lesseeAmount) {
              this.paybackToLessee = "";
              this.ownedToLessee = "";
              this.ownedToLLP = "";
            } else {
              this.paybackToLessee = amount;
              this.deal.lesseeAmount = amount;
              this.ownedToLessee = amount;
              this.ownedToLLP = "";
            }
          }
        } else if (Math.sign(amount) == -1) {
          if (this.selectedFinancialData.length == 0) {

            this.deal.lesseeAmount = amount;
            this.ownedToLLP = Number(amount);
          } else {
            this.ownedToLLP = Number(amount) + Number(this.deal.lesseeAmount);



          }

          this.msgOwnedcolor.color = "Red";

          this.ownedToLessee = "";
          this.paybackToLessee = "";
        }
      }
    },

    getManageQuoteIds() {

      this.manageQuoteIdList = []
      httpdmvtitle.get("/dmvNotifications/getManageTitleByLoan/" + this.selecteddmvid).then(response => {
        let quoteIdsList = []
        quoteIdsList = response.data
        this.manageTitledmvTitleId = quoteIdsList[0].dmvTitleId;
        this.manageTitleServiceId = quoteIdsList[0].serviceCompanyId;
        console.log(response.data)
        if (quoteIdsList.length == 1 && quoteIdsList[0].status == "contract") {
          this.serviceProviderCheckList.push(quoteIdsList[0].serviceCompanyName)
          this.disabledropdown = true;
          this.disablequote = true;
          this.dmvTitleIdStatus = quoteIdsList[0].status;
          this.manageTitle.statusContract = true
          this.disableSendContract = true;

        }
        {
          // console.log(quoteIdsList[0].serviceContactEmails+"status")
          this.manageTitle.dmvTitleId = quoteIdsList[0].dmvTitleId;
          this.manageTitle.quoteId = quoteIdsList[0].manageQuoteid;
          this.manageTitle.oldTitleNumber = quoteIdsList[0].oldTitleNumber;
          this.manageTitle.newTitleNumber = quoteIdsList[0].newTitleNumber;
          this.manageTitle.interimTitleNumber = quoteIdsList[0].interimTitleNumber;
          this.manageTitle.status = quoteIdsList[0].status;
          this.manageTitle.oldTitleDate = quoteIdsList[0].oldTitleDate == null ? null : new Date(quoteIdsList[0].oldTitleDate);
          this.manageTitle.newTitleDate = quoteIdsList[0].newTitleDate == null ? null : new Date(quoteIdsList[0].newTitleDate);
          this.manageTitle.mvWorkSentDate = quoteIdsList[0].mvWorkSentDate == null ? null : new Date(quoteIdsList[0].mvWorkSentDate);

          this.manageTitle.mvWorkPackageSentDate = quoteIdsList[0].mvWorkPackageSentDate == null ? null : new Date(quoteIdsList[0].mvWorkPackageSentDate);

          this.manageTitle.eltOrderedTitleWorkComplete = quoteIdsList[0].eltOrderedTitleWorkComplete == null ? null : new Date(quoteIdsList[0].eltOrderedTitleWorkComplete);
          this.manageTitle.sendingTitleToTrust = quoteIdsList[0].sendingTitleToTrust == null ? null : new Date(quoteIdsList[0].sendingTitleToTrust);
          this.manageTitle.interimTitleDate = quoteIdsList[0].interimTitleDate == null ? null : new Date(quoteIdsList[0].interimTitleDate);
          this.manageTitle.quoteDate = quoteIdsList[0].quoteDate == null ? null : new Date(quoteIdsList[0].quoteDate);
          //  this.serviceContactEmails = quoteIdsList[0].serviceContactEmails;

          this.serviceContactEmails = quoteIdsList[0].serviceContactEmails.length != 0 ? quoteIdsList[0].serviceContactEmails.toString() : "",


            this.manageTitle.acceptedDate = quoteIdsList[0].acceptedDate;
          this.manageTitle.additionalInstructions = quoteIdsList[0].additionalInstructions;
          this.manageTitle.selectedOldTitleStateCode = quoteIdsList[0].oldTitleState;
          this.manageTitle.selectedNewTitleStateCode = quoteIdsList[0].newTitleState;
          this.manageTitle.selectedInterimStateCode = quoteIdsList[0].interimState;
          this.manageTitle.plateNumber = quoteIdsList[0].plateNumber;
          this.manageTitle.mailSentDate = quoteIdsList[0].mailSentDate,
            this.manageTitle.licensePlateNumberDate = quoteIdsList[0].licensePlateNumberDate == null ? null : new Date(quoteIdsList[0].licensePlateNumberDate);


          console.log("dddddd" + quoteIdsList[0].oldTitleState);
          for (let i = 0; i < this.serviceProviders.length; i++) {
            if (this.serviceProviders[i].StateVehicleID == quoteIdsList[0].serviceCompanyId && this.serviceProviders[i].ServiceName != '') {
              this.testId = quoteIdsList[0].serviceCompanyId;
              this.manageTitle.serviceCompanyId = this.serviceProviders[i]

              this.getServiceProviderDetails(this.serviceProviders[i]);
            }
          }
          this.getRegisteredAddress(this.selecteddmvid)
          setTimeout(() => {
            this.manageTitle.message = ""
          }, 3000)
          this.getDMVWorkStatus(response.data.dmvId);

          this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);

        }

        {
          for (let j = 0; j < quoteIdsList.length; j++) {
            if (quoteIdsList[j].status != "" && quoteIdsList[j].status != null) {
              if (quoteIdsList[j].status != "bad quote") {
                this.manageQuoteIdList.push(quoteIdsList[j])
                //console.log( quoteIdsList[j])
              }
            }
            else {
              //console.log(quoteIdsList[j].dmvTitleId)
              this.manageTitle.dmvTitleId = quoteIdsList[j].dmvTitleId
              this.getManageTitleDmvTitle(quoteIdsList[j].dmvTitleId)
            }
          }
          for (let i = 0; i < this.manageQuoteIdList.length; i++) {
            this.serviceProviderCheckList.push(this.manageQuoteIdList[i].serviceCompanyName)
          }

          //console.log(response.data);
          quoteIdsList = []
        }
      });

    },
    getManageQuote(selectedQuote) {
      this.manageTitle.acceptedDate = '';
      httpdmvtitle.get("/dmvNotifications/getManageTitle/" + selectedQuote).then(response => {
        this.selectedQuoteList = response.data;
        //console.log(response.data)
        this.manageTitle.quoteId = selectedQuote;
        this.manageTitle.dmvTitleId = response.data.dmvTitleId;
        this.manageTitle.oldTitleNumber = response.data.oldTitleNumber;
        this.manageTitle.newTitleNumber = response.data.newTitleNumber;
        this.manageTitle.interimTitleNumber = response.data.interimTitleNumber;
        this.manageTitle.status = response.data.status;
        this.manageTitle.oldTitleDate = response.data.oldTitleDate == null ? null : new Date(response.data.oldTitleDate);
        this.manageTitle.newTitleDate = response.data.newTitleDate == null ? null : new Date(response.data.newTitleDate);
        this.manageTitle.eltOrderedTitleWorkComplete = response.data.eltOrderedTitleWorkComplete == null ? null : new Date(response.data.eltOrderedTitleWorkComplete);
        this.manageTitle.sendingTitleToTrust = response.data.sendingTitleToTrust == null ? null : new Date(response.data.sendingTitleToTrust);
        this.manageTitle.mvWorkSentDate = response.data.mvWorkSentDate == null ? null : new Date(response.data.mvWorkSentDate);
        this.manageTitle.mvWorkPackageSentDate = response.data.mvWorkPackageSentDate == null ? null : new Date(response.data.mvWorkPackageSentDate);

        this.manageTitle.interimTitleDate = response.data.interimTitleDate == null ? null : new Date(response.data.interimTitleDate);
        this.manageTitle.quoteDate = response.data.quoteDate == null ? null : new Date(response.data.quoteDate);
        //this.serviceProviderEmails = response.data.serviceContactEmails;
        this.manageTitle.acceptedDate = response.data.acceptedDate;
        this.manageTitle.additionalInstructions = response.data.additionalInstructions;
        this.manageTitle.plateNumber = response.data.plateNumber;
        this.manageTitle.selectedNewTitleStateCode = response.data.newTitleState;
        this.manageTitle.selectedInterimStateCode = response.data.interimState;
        this.manageTitle.licensePlateNumberDate = response.data.licensePlateNumberDate == null ? null : new Date(response.data.licensePlateNumberDate);
        for (let i = 0; i < this.serviceProviders.length; i++) {
          if (this.serviceProviders[i].StateVehicleID == response.data.serviceCompanyId) {
            this.manageTitle.serviceCompanyId = this.serviceProviders[i]

            this.getServiceProviderDetails(this.serviceProviders[i]);
          }
        }
        this.getRegisteredAddress(this.selecteddmvid)
        setTimeout(() => {
          this.manageTitle.message = ""
        }, 3000)
        this.getDMVWorkStatus(response.data.dmvId);
        if (response.data.serviceContactEmails != null) {
          this.serviceProviderEmails = response.data.serviceContactEmails.split(",");
        }
      });

      var checkBox = document.getElementById("chkService");

      if (checkBox.checked == true) {

        checkBox.checked = false;

      }


    },

    getDMVWorkStatus(dmvId) {
      httpdmvtitle.get("/dmvNotifications/getDMVWorkStatus/" + dmvId).then(response => {
        this.manageTitle.dmvWorkSentDate = response;
      })
    },

    checkOldDate() {
      if (this.manageTitle.newTitleDate != null) {
        if (this.manageTitle.oldTitleDate > this.manageTitle.newTitleDate) {
          this.oldDate = "Reassigned Title Date Cannot be Greater than Final Title Date"
          this.msgcolor.color = "Red";
        }
        else {
          this.oldDate = ""
        }
      }
    },
    checkNewDate() {
      if (this.manageTitle.newTitleDate < this.manageTitle.oldTitleDate) {
        this.newDate = "Final Title Date Cannot be Less than Reassigned Title Date"
        this.msgcolor.color = "Red";
      }
      else {
        this.newDate = ""
      }
    },
    saveManageTitleContract() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";

      var stateVehicleIDs = null;
      var stateServiceNames = null;
      console.log("testxx" + this.manageTitle.anotherServiceCompanyId)
      if (this.manageTitle.anotherServiceCompanyId != "") {
        console.log("test" + this.manageTitle.anotherServiceCompanyId)
        stateVehicleIDs = this.manageTitle.anotherServiceCompanyId;

      }
      else {
        console.log("tddddest" + this.manageTitle.anotherServiceCompanyId)
        stateVehicleIDs = this.manageTitle.serviceCompanyId.StateVehicleID;
      }
      if (this.manageTitle.anotherserviceCompanyName != "") {
        stateServiceNames = this.manageTitle.anotherserviceCompanyName;
      }
      else {
        stateServiceNames = this.manageTitle.serviceCompanyId.ServiceName
      }
      //this.serviceProviderEmails = this.contactEmails;

      console.log("qytwiuaruw" + this.serviceProviderEmails)
      if (this.serviceProviderEmails == null && this.contactEmails.length != 1) {
        this.emailNotSelected = " please select service provider email "
      }

      if (this.manageTitle.additionalInstructions == "") {
        this.manageTitle.additionalInstructions = null
      }
      if (this.testId != this.manageTitle.anotherServiceCompanyId && this.manageTitle.anotherServiceCompanyId != '') {
        this.manageTitle.dmvTitleId = null;
        this.manageTitle.mailSentDate = null;
      }
      if (this.manageTitle.dmvTitleId == null) {
        let manageTitle = {
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          // quoteDate: this.manageTitle.quoteDate,
          manageQuoteid: null,
          status: "contract",
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipCode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: this.serviceProviderEmails.toString(),
          mailSentDate: this.manageTitle.mailSentDate,
          acceptedDate: null,
          creationUserI: this.userId,
          documentlink: this.manageTitle.documentLinks.toString(),
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber,
          mvWorkSentDate: new Date()
        }
        if ((this.newDate == "") && (this.oldDate == "")) {
          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              this.msgcolor.color = "green"
              //this.manageTitle =this.initializeManageTitle();
              this.manageTitle.additionalInstructions = null;
              this.manageTitle.message = "Manage Title contract has sent Successfully";
              setTimeout(function () {
                this.manageTitle.message = ""
              }, 3000);
              this.serviceProviderEmails = [];
              this.manageQuoteIdList = []
              this.getManageQuoteIds();
              this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);
              // this.serviceProviderEmails= [];
            })
        }
      }
      else {

        //  this.serviceProviderEmails = this.contactEmails;

        if (this.serviceProviderEmails == null) {
          this.emailNotSelected = " please select service provider email "
        }

        let manageTitle = {
          dmvTitleId: this.manageTitle.dmvTitleId,
          manageQuoteid: this.manageTitle.quoteId,
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          quoteDate: this.manageTitle.quoteDate,
          status: "contract",
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipCode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: this.serviceProviderEmails.toString(),
          mailSentDate: this.manageTitle.mailSentDate,
          acceptedDate: null,
          creationUserI: this.userId,
          documentlink: this.manageTitle.documentLinks.toString(),
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber,
          mvWorkSentDate: new Date()
        }
        if ((this.newDate == "") && (this.oldDate == "")) {
          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              this.msgcolor.color = "green"
              // this.manageTitle =this.initializeManageTitle();
              this.manageTitle.additionalInstructions = null;
              this.manageTitle.message = "Manage Title contract has sent Successfully";
              setTimeout(function () {
                this.manageTitle.message = ""
              }, 3000);
              this.serviceProviderEmails = [];
              this.manageQuoteIdList = []
              this.getManageQuoteIds();
              this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);
              //this.serviceProviderEmails= [];
            })
        }

      }
      this.manageTitle.anotherServiceCompanyId = "";
      this.disableAnotherServiceProvider = true;



    },

    saveManageTitle() {
      console.log(this.serviceContactEmails);
      var contactEmailsData = null;
      if (this.serviceContactEmails == null) {
        contactEmailsData = this.serviceProviderEmails.length != 0 ? this.serviceProviderEmails.toString() : "";
      }
      else {
        contactEmailsData = this.serviceContactEmails;
      }
      var stateVehicleIDs = null;
      var stateServiceNames = null;
      console.log("testxx" + this.manageTitle.anotherServiceCompanyId)
      if (this.manageTitle.anotherServiceCompanyId != "") {
        console.log("test" + this.manageTitle.anotherServiceCompanyId)
        stateVehicleIDs = this.manageTitle.anotherServiceCompanyId;

      }
      else {
        console.log("tddddest" + this.manageTitle.anotherServiceCompanyId)
        stateVehicleIDs = this.manageTitle.serviceCompanyId.StateVehicleID;
      }
      if (this.manageTitle.anotherserviceCompanyName != "") {
        stateServiceNames = this.manageTitle.anotherserviceCompanyName;
      }
      else {
        stateServiceNames = this.manageTitle.serviceCompanyId.ServiceName
      }
      // this.serviceProviderEmails = this.contactEmails;

      if (this.manageTitle.additionalInstructions == "") {
        this.manageTitle.additionalInstructions = null
      }
      if (this.manageTitle.dmvTitleId == null) {
        let manageTitle = {
          manageQuoteid: null,
          dmvTitleId: null,
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          quoteDate: this.manageTitle.quoteDate,
          status: this.manageTitle.status,
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipcode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: contactEmailsData,
          mailSentDate: this.manageTitle.mailSentDate,
          creationUserI: this.userId,
          acceptedDate: null,
          documentlink: this.manageTitle.documentLinks.length != 0 ? this.manageTitle.documentLinks.toString() : "",
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber
        }
        if ((this.newDate == "") && (this.oldDate == "")) {

          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              this.initializeManageTitle();
              this.msgcolor.color = "green"
              this.manageTitle.message = "Manage Title Saved Successfully";
              setTimeout(() => {
                this.manageTitle.message = "";
              }, 3000)
              let dmvMangageTitleData = []
              dmvMangageTitleData = response.data
              this.getManageTitleDmvTitle(dmvMangageTitleData[0].dmvTitleId)
              this.getRegisteredAddress(this.selecteddmvid)
              this.serviceProviderEmails = [];
              console.log(this.manageTitle.selectedNewTitleStateCode)
            })

        }

      }
      else {

        let manageTitle = {
          dmvTitleId: this.manageTitle.dmvTitleId,
          manageQuoteid: this.manageTitle.quoteId,
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          quoteDate: this.manageTitle.quoteDate,
          status: this.manageTitle.status,
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipcode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: contactEmailsData,
          mailSentDate: this.manageTitle.mailSentDate,
          acceptedDate: null,
          creationUserI: this.userId,
          documentlink: this.manageTitle.documentLinks.length != 0 ? this.manageTitle.documentLinks.toString() : "",
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber
        }
        if ((this.newDate == "") && (this.oldDate == "")) {

          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              this.msgcolor.color = "green"
              this.manageTitle.message = "Manage Title Saved Successfully";
              setTimeout(() => {
                this.manageTitle.message = "";
              }, 3000)
              this.serviceProviderEmails = [];
              if (this.manageTitle.status != "" && this.manageTitle.status != null) {
                this.getManageQuoteIds();
                this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);
                for (let i = 0; i < this.manageQuoteIdList.length; i++) {
                  if (this.manageQuoteIdList[i].status == "quote") {

                    this.contactEmails = [];
                    this.manageTitle = this.initializeManageTitle();
                    this.serviceProviderEmails = "";
                    this.state = "",
                      this.serviceName = "",
                      this.companyName = "",
                      this.street1 = "",
                      this.street2 = "",
                      this.stateCode = "",
                      this.zipcode = "",
                      this.license = "",
                      this.contactPerson = "",
                      this.emailId = "",
                      this.phonePerson = "",
                      this.serviceFee = "",
                      this.checklistCSV = "",
                      this.webURL = "",
                      this.instructionNotes = "",
                      this.specialNotes = "",
                      this.processingNotes = "",
                      this.addressNotes = "",
                      this.reviewNotes = "",
                      this.recordType = "";
                  }
                }

              }
              else {

                this.getManageTitleDmvTitle(this.manageTitle.dmvTitleId)
                this.getRegisteredAddress(this.selecteddmvid)
                //console.log("managesave")

              }
            })
        }
      }



    },

    saveManageTitleQuote() {
      var modal = document.getElementById("requestquote");
      modal.style.display = "none";
      var stateVehicleIDs = null;
      var stateServiceNames = null;
      if (this.manageTitle.quoteDate != null) {
        this.manageTitle.dmvTitleId = null;
      }
      if (this.manageTitle.anotherServiceCompanyId != "") {

        stateVehicleIDs = this.manageTitle.anotherServiceCompanyId;

      }
      else {

        stateVehicleIDs = this.manageTitle.serviceCompanyId.StateVehicleID;
      }
      this.testId = stateVehicleIDs;
      if (this.manageTitle.anotherserviceCompanyName != "") {
        stateServiceNames = this.manageTitle.anotherserviceCompanyName;
      }
      else {
        stateServiceNames = this.manageTitle.serviceCompanyId.ServiceName
      }

      this.manageTitle.quoteId = "Q" + moment(new Date()).format('MM-DD-YYYYHH:MM:SS').replaceAll("-", "").replaceAll(":", "");

      if (this.manageTitle.dmvTitleId == null && this.manageTitle.quoteId != null && this.manageTitle.quoteId != "") {

        console.log("12345")
        // this.serviceProviderEmails = this.contactEmails;

        if (this.serviceProviderEmails.length != 0) {
          this.mailSentDate = new Date();
        }
        if (this.serviceProviderEmails == null && this.contactEmails.length != 1) {
          this.emailNotSelected = " please select service provider email "

        }

        if (this.manageTitle.additionalInstructions == "") {
          this.manageTitle.additionalInstructions = null
        }

        let manageTitle = {
          manageQuoteid: this.manageTitle.quoteId,
          dmvTitleId: null,
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          quoteDate: new Date(),
          status: "quote",
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipcode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: this.serviceProviderEmails.length != 0 ? this.serviceProviderEmails.toString() : "",
          mailSentDate: this.mailSentDate,
          acceptedDate: null,
          creationUserI: this.userId,
          documentlink: this.manageTitle.documentLinks.length != 0 ? this.manageTitle.documentLinks.toString() : "",
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber

        }
        if ((this.newDate == "") && (this.oldDate == "")) {
          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              // this.manageTitle = this.initializeManageTitle();
              this.manageTitle.message = "Manage Title Quote Saved Successfully";
              this.msgcolor.color = "green"
              setTimeout(() => {
                this.manageTitle.message = ""
              }, 3000);
              this.serviceProviderEmails = [];
              this.manageQuoteIdList = []
              this.getManageQuoteIds();
              this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);

              // this.contactEmails = [];
              this.links = [];              
              this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);
              this.manageTitle.additionalInstructions = null
              if (this.registeredServiceProvider.length == 1) {
                //console.log(this.registeredServiceProvider)
                this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]
                console.log("testgv")
                this.getServiceProviderDetails(this.registeredServiceProvider[0])
              }
            })
        }
      }
      else {
        console.log("1234567")
        if (this.manageTitle.additionalInstructions == "") {
          this.manageTitle.additionalInstructions = null
        }
        // this.serviceProviderEmails = this.contactEmails;

        if (this.serviceProviderEmails.length != 0) {
          this.mailSentDate = new Date();
        }
        if (this.serviceProviderEmails == null && this.contactEmails.length != 1) {
          this.emailNotSelected = " please select service provider email "
          //console.log("email not selected")
        }

        if (this.serviceProviderEmails.length != 0 && this.mailSentDate == null) {
          this.mailSentDate = new Date();
        }
        let manageTitle = {
          manageQuoteid: this.manageTitle.quoteId,
          dmvTitleId: this.manageTitle.dmvTitleId,
          dmvId: this.selecteddmvid,
          oldTitleNumber: this.manageTitle.oldTitleNumber,
          newTitleNumber: this.manageTitle.newTitleNumber,
          interimTitleNumber: this.manageTitle.interimTitleNumber,
          oldTitleDate: this.manageTitle.oldTitleDate,
          licensePlateNumberDate: this.manageTitle.licensePlateNumberDate,
          newTitleDate: this.manageTitle.newTitleDate,
          eltOrderedTitleWorkComplete: this.manageTitle.eltOrderedTitleWorkComplete,
          mvWorkSentDate: this.manageTitle.mvWorkSentDate,
          mvWorkPackageSentDate: this.manageTitle.mvWorkPackageSentDate,
          sendingTitleToTrust: this.manageTitle.sendingTitleToTrust,
          interimTitleDate: this.manageTitle.interimTitleDate,
          serviceCompanyId: stateVehicleIDs,
          quoteDate: new Date(),
          status: "quote",
          serviceCompanyName: stateServiceNames,
          registrationStreet: this.manageTitle.registrationAddressStreet1,
          registrationCity: this.manageTitle.registrationAddressCity,
          titleSentToTrust: this.manageTitle.titleSentToTrust,
          registrationState: this.manageTitle.registrationAddressState,
          registrationZipcode: this.manageTitle.registrationAddressZipcode,
          registrationAddressCountry: "USA",
          serviceContactEmails: this.serviceProviderEmails.length != 0 ? this.serviceProviderEmails.toString() : "",
          mailSentDate: this.mailSentDate,
          acceptedDate: null,
          creationUserI: this.userId,
          documentlink: this.manageTitle.documentLinks.length != 0 ? this.manageTitle.documentLinks.toString() : "",
          oldTitleState: this.manageTitle.selectedOldTitleStateCode,
          interimState: this.manageTitle.selectedInterimStateCode,
          newTitleState: this.manageTitle.selectedNewTitleStateCode,
          plateNumber: this.manageTitle.plateNumber,
        }
        if ((this.newDate == "") && (this.oldDate == "")) {
          httpdmvtitle
            .post("/dmvNotifications/saveManageTitle/" + this.manageTitle.additionalInstructions, manageTitle)
            .then(response => {
              // this.manageTitle = this.initializeManageTitle();
              this.manageTitle.message = "Manage Title Quote Saved Successfully";
              this.msgcolor.color = "green"
              setTimeout(() => {
                this.manageTitle.message = ""
              }, 3000);
              this.serviceProviderEmails = [];
              this.manageQuoteIdList = []
              this.getManageQuoteIds();
              this.getSeviceNamesByIdAndState(this.deal.dealbookRegistrationState);
              //    this.contactEmails = [];
              this.links = [];
              this.links = [{docReceivedDate:'20-10-2024', docName:'test doc', docId:'12546'}]
              this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);

              this.manageTitle.additionalInstructions == null
              if (this.registeredServiceProvider.length == 1) {
                //console.log(this.registeredServiceProvider)
                this.manageTitle.serviceCompanyId = this.registeredServiceProvider[0]
                console.log("testgvyyy")
                this.getServiceProviderDetails(this.registeredServiceProvider[0])
              }
            })
        }

      }
      this.manageTitle.anotherServiceCompanyId = "";
      this.disableAnotherServiceProvider = true;






    },

    saveManageTitleMessage() {
      this.manageTitle.message = "Manage Title saved Successfully"
    },

    getManageTitleDmvTitle(dmvTitleId) {

      httpdmvtitle
        .get("/dmvNotifications/getManageTitleBydmvTitleId/" + dmvTitleId).then(response => {
          let saveManageTitleData = []
          saveManageTitleData = response.data
          this.manageTitle.quoteId = saveManageTitleData[0].manageQuoteid;
          this.manageTitle.dmvTitleId = saveManageTitleData[0].dmvTitleId;
          this.manageTitle.oldTitleNumber = saveManageTitleData[0].oldTitleNumber;
          this.manageTitle.newTitleNumber = saveManageTitleData[0].newTitleNumber;
          this.manageTitle.oldTitleDate = saveManageTitleData[0].oldTitleDate == null ? null : new Date(saveManageTitleData[0].oldTitleDate);
          this.manageTitle.eltOrderedTitleWorkComplete = saveManageTitleData[0].eltOrderedTitleWorkComplete == null ? null : new Date(saveManageTitleData[0].eltOrderedTitleWorkComplete);
          this.manageTitle.newTitleDate = saveManageTitleData[0].newTitleDate == null ? null : new Date(saveManageTitleData[0].newTitleDate);
          this.manageTitle.sendingTitleToTrust = saveManageTitleData[0].sendingTitleToTrust == null ? null : new Date(saveManageTitleData[0].sendingTitleToTrust);
          this.manageTitle.mvWorkSentDate = saveManageTitleData[0].mvWorkSentDate == null ? null : new Date(saveManageTitleData[0].mvWorkSentDate);
          this.manageTitle.acceptedDate = saveManageTitleData[0].acceptedDate == null ? null : new Date(saveManageTitleData[0].acceptedDate);
          this.manageTitle.mvWorkPackageSentDate = saveManageTitleData[0].mvWorkPackageSentDate == null ? null : new Date(saveManageTitleData[0].mvWorkPackageSentDate);

          this.manageTitle.quoteDate = saveManageTitleData[0].quoteDate == null ? null : new Date(saveManageTitleData[0].quoteDate);
          this.manageTitle.registrationAddressCountry = saveManageTitleData[0].registrationAddressCountry;
          //this.serviceProviderEmails = saveManageTitleData[0].serviceContactEmails;
          this.mailSentDate = saveManageTitleData[0].mailSentDate;
          this.manageTitle.additionalInstructions = saveManageTitleData[0].additionalInstructions;
          this.manageTitle.selectedInterimStateCode = saveManageTitleData[0].interimState;
          this.manageTitle.plateNumber = saveManageTitleData[0].plateNumber;
          this.manageTitle.selectedNewTitleStateCode = saveManageTitleData[0].newTitleState;
          this.manageTitle.interimTitleNumber = saveManageTitleData[0].interimTitleNumber;
          this.manageTitle.selectedOldTitleStateCode = saveManageTitleData[0].oldTitleState;
          this.manageTitle.interimTitleDate = saveManageTitleData[0].interimTitleDate == null ? null : new Date(saveManageTitleData[0].interimTitleDate);

          this.manageTitle.licensePlateNumberDate = saveManageTitleData[0].licensePlateNumberDate == null ? null : new Date(saveManageTitleData[0].licensePlateNumberDate);
          for (let i = 0; i < this.serviceProviders.length; i++) {
            if (this.serviceProviders[i].StateVehicleID == saveManageTitleData[0].serviceCompanyId) {
              // this.manageTitle.serviceCompanyId = this.serviceProviders[i]

              // this.getServiceProviderDetails(this.serviceProviders[i]);
            }
          }
        }
        )
    },

    saveTitle(dmvid) {
      this.responseMessage = '';
      //console.log("SAVE TITLE : " + JSON.stringify(this.selectedFinancialData))
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {

          //console.log("dmvid"+this.selectedDealData[0].id)
          let multiply = this.deal.monthlySalesTax * this.deal.numberAdvancedPayments;
          let substract = this.deal.initialSalesTaxAtPurchase - multiply;
          let total = substract + this.deal.dmvFees;
          let owned = total - this.deal.amount;

          //console.log("this.selectedFinancialData : " + JSON.stringify(this.selectedFinancialData.dmvFinancialsId))
          var financeId;
          if (this.selectedFinancialData.dmvFinancialsId == null) {
            financeId = null;
          } else {
            financeId = this.selectedFinancialData.dmvFinancialsId
          }
          var saveFinancials = {
            dmvFinancialsId: financeId,
            dmvId: this.selectedDealData[0].id,

            checkNumber: this.deal.checkNumber,

            checkPayableTo: this.deal.checkPayableTo,

            amount: this.deal.amount,

            checkDate: this.deal.checkDate,

            lesseeCheckNumber: this.deal.lesseeCheckNumber,

            lesseeCheckPayableTo: this.deal.lesseeCheckPayableTo,

            lesseeAmount: this.deal.lesseeAmount,

            lesseeCheckDate: this.deal.lesseeCheckDate,

          };
          httpdmvtitle
            .post("/dmvNotifications/saveFinancials", saveFinancials)
            .then(response => {
              this.getFinancialData(this.selectedDealData[0].id);
              this.responseFinancialMessage = "Financials Submitted Succesfully";
              this.msgcolor.color = "Blue";
              if (owned == this.deal.lesseeAmount) {
                this.ownedAmount = 0
              } else {
                this.getOwnedAmount();
                this.getOwnedAmountData();
                //console.log("HELLO2 : " + this.deal.amount)
              }
            });



        }
      });

    },

    saveServiceProvider(dmvid) {
      // var emailids = "";
      // for (var i = 0; i < this.serviceProviderEmails.length; i++) {
      //   if (this.serviceProviderEmails.length > 1) {
      //     if (i < this.serviceProviderEmails.length - 1) {
      //       emailids = this.serviceProviderEmails[i] + ",".join();
      //     }
      //   } else {
      //     emailids = this.serviceProviderEmails[i];
      //   }
      // }
      // console.log(emailids);
      var serviceprovider = {
        id: dmvid,
        loan: this.selectedDealData[0].loan,
        loanCreated: this.selectedDealData[0].loanCreated,
        loanStatus: this.selectedDealData[0].loanStatus,
        registrationState: this.selectedDealData[0].registrationState,
        borrowername: this.selectedDealData[0].borrowername,
        borrowerAddress: this.selectedDealData[0].borrowerAddress,
        borrowerCity: this.selectedDealData[0].borrowerCity,
        borrowerState: this.selectedDealData[0].borrowerState,
        borrowerZipcode: this.selectedDealData[0].borrowerZipcode,
        borrowerPriPhone: this.selectedDealData[0].borrowerPriPhone,
        borrowerEmail: this.selectedDealData[0].borrowerEmail,
        year: this.selectedDealData[0].year,
        make: this.selectedDealData[0].make,
        model: this.selectedDealData[0].model,
        vin: this.selectedDealData[0].vin,
        color: this.selectedDealData[0].color,
        dmvFees: this.selectedDealData[0].dmvFees,
        referringDealer: this.selectedDealData[0].referringDealer,
        salesPerson: this.selectedDealData[0].salesPerson,
        emailFlag: this.selectedDealData[0].emailFlag,
        titleNumber: this.selectedDealData[0].titleNumber,
        titleDate: this.selectedDealData[0].titleDate,
        serviceProvider: this.serviceProvider,
        status: this.selectedDealData[0].status,
        newTitleNumber: this.deal.newTitleNumber,
        oldTitleNumber: this.deal.oldTitleNumber,
        newTitleDate: this.deal.newTitleDate,
        eltOrderedTitleWorkComplete: this.deal.eltOrderedTitleWorkComplete,
        mvWorkSentDate: this.deal.mvWorkSentDate,
        mvWorkPackageSentDate: this.deal.mvWorkPackageSentDate,
        sendingTitleToTrust: this.deal.sendingTitleToTrust,
        oldTitleDate: this.deal.oldTitleDate,
        licensePlateNumberDate: this.deal.licensePlateNumberDate,
        titleState: this.deal.titleState,
        dealerDMVStatus: this.deal.dealerDMVStatus,

        dmvStatusDate: this.deal.dmvStatusDate,

        dmvOrTitleWorkStillNeeded: this.deal.dmvOrTitleWorkStillNeeded,

        registrationStreet: this.deal.registrationStreet,

        registrationCity: this.deal.registrationCity,

        registrationZipcode: this.deal.registrationZipcode,

        registrationCounty: this.deal.registrationCounty,

        curbWeight: this.deal.curbWeight,

        milesReported: this.deal.milesReported,

        checkNumber: this.deal.checkNumber,

        checkPayableTo: this.deal.checkPayableTo,

        amount: this.deal.amount,

        checkDate: this.deal.checkDate,

        dateOfSaleToLLP: this.deal.dateOfSaleToLLP,

        registrationAddress: this.deal.registrationAddress,

        lesseeCheckNumber: this.deal.lesseeCheckNumber,

        lesseeCheckPayableTo: this.deal.lesseeCheckPayableTo,

        lesseeAmount: this.deal.lesseeAmount,

        lesseeCheckDate: this.deal.lesseeCheckDate,

        registrationAddressStreet1: this.deal.registrationAddressStreet1,

        registrationAddressStreet2: this.deal.registrationAddressStreet2,

        registrationAddressCity: this.deal.registrationAddressCity,

        titleSentToTrust: this.deal.titleSentToTrust,

        registrationAddressZipcode: this.deal.registrationAddressZipcode,

        registrationAddressState: this.deal.registrationAddressState,

        registrationAddressCountry: this.deal.registrationAddressCountry,

        initialSalesTaxAtPurchase: this.deal.initialSalesTaxAtPurchase,

        monthlySalesTax: this.deal.monthlySalesTax,

        numberAdvancedPayments: this.deal.numberAdvancedPayments,

        dmvServiceContactEmail: {
          dmvId: dmvid,
          contactEmail: "kishore@syntrino.net,kishore@syntrino.net"
        }
      };
      httpdmvtitle
        .put("/dmvNotifications/save", serviceprovider)
        .then(response => {
          //console.log(response);
        });
    },
    getEmployeeDetails() {
      this.employeeEmails = [];
      httpdmvtitle.get("/DMVTitle/getEmployeeDetails", {
        params: {
          dmvId: this.selecteddmvid
        }
      }).then(response => {
        this.employeelist = response.data;
        //         for(let i=0 ;i<response.data.length;i++){
        // var creviewobject = response.data[i]   
        // console.log("emailSentTo"+creviewobject.emailSentTo);
        //  this.employeeEmails.push(
        // creviewobject.emailId
        //  )

        //         }

        console.log("this.employeeEmails" + JSON.stringify(this.employeeEmails));
      });
    },
    getDMVTempTagRegistration: function () {
      // this.getkeyData();
      //this.getkeyData1();
      let date1 = null;
      let date2 = null;
      httpdmvtitle.get('/DMVTitle/getDMVTempRegistrationById/', {
        params: {
          dmvID: this.selecteddmvid
        }
      }).then(response => {
        this.tempTagRegListData = response.data;

        this.temptagRegListDataUpdate = [];
        for (let i = 0; i < response.data.length; i++) {

          var creviewobject = response.data[i]
          let employeeEmails = [];
          employeeEmails.push(
            creviewobject.emailSentTo
          )

          console.log("emailSentTo" + creviewobject.emailSentTo);
          this.temptagRegListDataUpdate.push({
            "dmvTempID": creviewobject.dmvTempID,
            "confNumber": creviewobject.confNumber,
            "cost": creviewobject.cost,
            "creationD": moment(creviewobject.creationD).format("yyyy-MM-DD"),
            "creationUserI": creviewobject.creationUserI,
            "dateOfExpiry": moment(creviewobject.dateOfExpiry).format("yyyy-MM-DD"),
            "dmvID": creviewobject.dmvID,
            "emailSentTo": creviewobject.emailSentTo,
            "issuedBy": creviewobject.issuedBy,
            "location": creviewobject.location,
            "tempTag": creviewobject.tempTag,
            "tempType": creviewobject.tempType,
            "timesTempRegIssued": creviewobject.timesTempRegIssued,
            "transDate": moment(creviewobject.transDate).format("yyyy-MM-DD"),
            "updatedD": creviewobject.updatedD,
            "whoIssued": creviewobject.whoIssued,
            "employeeEmails": employeeEmails.toString().split(",")
          });
        }




        if ((this.tempTagRegListData.length) == 2) {
          this.isActive = true;
        }
        //for(var i=0;i<this.tempTagRegListData.length;i++)
        //       {
        //   date1 = new Date(this.tempTagRegListData[i].dateOfExpiry);
        //    date2 = new Date(moment().toDate());

        // const diffTime = Math.abs(date2 - date1);

        // this.daysdiff = Math.ceil(diffTime / (1000 * 60 * 60 * 24));



        //     }
        //console.log(JSON.stringify(this.temptagAddDaysData));
        // if(  this.tempTagRegListData !='' &&  moment(date2).isBefore(  date1 )) 
        // {
        //     this.isActive = true;
        // }
        // if( this.temptagAddDaysData[0].keyValue == null )
        //     {
        //         this.isActive = false;

        //     }
        console.log("dateOfExpiry" + JSON.stringify(this.temptagRegListDataUpdate))
      })





      return this.temptagRegListDataUpdate;

    },



    updateTempRegistrationById(index, dmvTempID, tempTag, creationD, dateOfExpiry, issuedBy, confNumber, whoIssued, transDate, tempType, cost, location, emailSentTo) {
      var updateTempTag = {
        dmvTempID: dmvTempID,
        tempTag: tempTag,
        creationD: creationD,
        dateOfExpiry: dateOfExpiry,
        issuedBy: issuedBy,
        confNumber: confNumber,
        whoIssued: whoIssued,
        transDate: transDate,
        tempType: tempType,
        cost: cost,
        location: location,
        emailSentTo: emailSentTo.toString()

      }
      httpdmvtitle
        .put("/DMVTitle/updateTempRegistrationById/", updateTempTag)
        .then(response => {
          if (response.data != null) {
            this.saved = true;
            this.msgcolor.color = "Blue";
            this.saveDmvTempmessage = 'Successfully Updated into the system'

            //  this.tempTagRegList.dateOfExpiry=moment().add(30,'days').format("YYYY-MM-DD");
            this.getDMVTempTagRegistration();


            setTimeout(() => { this.tempTagMessage() }, 2000);

          }

        })
        .catch(e => {
          this.errorslist.push(e);
        });
    },









    getkeyData1: function () {

      httpdmvtitle.get('/DMVTitle/getkeyvalues/' + 26).then(response => {
        this.temptagAddDaysData = response.data
        //console.log(JSON.stringify(this.temptagAddDaysData));
      }).catch(e => { this.errorslist.push(e) })



    },
    getkeyData: function () {
      httpdmvtitle.get('/DMVTitle/getkeyvalues/' + 30).then(response => {
        this.stopReminderReasons = response.data
        //console.log(JSON.stringify(this.temptagAddDaysData));
      }).catch(e => { this.errorslist.push(e) })

    },
    fetchdata() {
      this.getkeyData();
      this.getkeyData1();

    },
    getServiceProviderDetails(option) {

      console.log("hhhh" + option)
      this.contactEmails = [];
      this.serviceProviderEmails = [];
      this.newEmail = '';
      var vehicleId = "";
      if (this.manageTitle.anotherServiceCompanyId == "") {
        vehicleId = option.StateVehicleID;
      }
      else {
        vehicleId = option;
        this.disableSendContract = false;

      }
      console.log("gu" + JSON.stringify(vehicleId));
      if (vehicleId != "") {
        httpdmvtitle
          .get("/DMVTitle/getdmvserviceProviderById?id=" + vehicleId)
          .then(response => {
            this.providerDetails = response.data;
            //console.log(response.data);
            var serviceProviderObject = this.providerDetails[0];
            console.log(serviceProviderObject.serviceName);
            (this.state = serviceProviderObject.state),
              (this.serviceName = serviceProviderObject.serviceName),
              (this.companyName = serviceProviderObject.companyName),
              (this.street1 = serviceProviderObject.street1),
              (this.street2 = serviceProviderObject.street2),
              (this.stateCode = serviceProviderObject.stateCode),
              (this.zipcode = serviceProviderObject.zipcode),
              (this.license = serviceProviderObject.license),
              (this.contactPerson = serviceProviderObject.contactPerson),
              (this.emailId = serviceProviderObject.emailId),
              (this.phonePerson = serviceProviderObject.phonePerson),
              (this.serviceFee = serviceProviderObject.serviceFee),
              (this.checklistCSV = serviceProviderObject.checklistCSV),
              (this.webURL = serviceProviderObject.webURL),
              (this.instructionNotes = serviceProviderObject.instructionNotes),
              (this.specialNotes = serviceProviderObject.specialNotes),
              (this.processingNotes = serviceProviderObject.processingNotes),
              (this.addressNotes = serviceProviderObject.addressNotes),
              (this.reviewNotes = serviceProviderObject.reviewNotes),
              (this.recordType = serviceProviderObject.recordType),
              (this.manageTitle.anotherserviceCompanyName = serviceProviderObject.serviceName);
            if (this.contactEmails.length == 0) {
              for (var i = 0; i < this.providerDetails.length; i++) {
                if (this.providerDetails[i].emailId != "") {
                  if (this.providerDetails[i].emailId != null) {
                    this.contactEmails.push(this.providerDetails[i].emailId);
                  }

                }
                console.log(JSON.stringify(this.contactEmails));

              }
            }
            else if (this.registeredServiceProvider[0] != "") {
              this.contactEmails = [];
              for (var i = 0; i < this.providerDetails.length; i++) {
                if (this.providerDetails[i].emailId != "") {
                  this.contactEmails.push(this.providerDetails[i].emailId);
                }
              }
            }
            for (var i = 0; i < this.contactEmails.length; i++) {
              //console.log(this.contactEmails[i]);
            }
          });
      }
      else {
        this.disableSendContract = true;
        this.disablequote = true
      }
    },
    displayContents(name) {
      return this.activetab === name;
    },
    getDmvMileStone() {
      if (this.deal.dealbookRegistrationState == null) {
        this.deal.dealbookRegistrationState = 'NA';
      }
      httpdmvtitle.get("/email/getDMVMilestoneMaster", {
        params: {
          stateCode: this.deal.dealbookRegistrationState,
          dmvId: this.selecteddmvid
        }
      }).then(response => {
        this.dmvMilestoneList = response.data;
        //console.log( this.deal.dealbookRegistrationState);
        //console.log(JSON.stringify(this.dmvMilestoneList));

      });

    },
    getDMVServiceProvider() {
      //console.log("Entered");
      httpdmvtitle.get("/DMVTitle/getdmvserviceProvider").then(response => {
        this.serviceProviders = response.data;

        //console.log(response.data);

        // console.log(
        //   JSON.stringify(this.serviceProviders) + "serviceProviderData"
        // );
      });
    },
    saveDmvNotes(id) {
      var checkBox = document.getElementById("statusNotes");
      if (checkBox.checked == true) {
        this.dmvStatusNotes = 'Y'
      }
      else {
        this.dmvStatusNotes = 'N'
      }
      if (this.content == '') {
        this.saved = true;
        this.msgcolor.color = "Red";
        this.savemessage = 'Notes Field is Required';
      }

      if (this.content != '') {


        if (this.savemessage != 'Please mark only one checkbox either To Email or CC Email') {



          if (id == 1) {
            this.toEmailids = [];
            this.ccEmailids = [];

          }
          if ((this.toEmailids.length == 0) && (id == 2)) {
            // this.ccEmailids =  [];
            this.saved = true;
            this.msgcolor.color = "Red";
            this.savemessage = 'Please Select Atleast One To Email Address'
          }
          else {
            this.saved = true;
            this.savemessage = ''
          }
          if (this.savemessage == '') {
            let dmvnotespayload = {
              dmvId: this.selecteddmvid,
              notes: this.content,
              creationUserI: this.userId,
              emaiIds: this.employeemailids.toString(),
              toEmaiIds: this.toEmailids.toString(),
              ccEmaiIds: this.ccEmailids.toString(),
              userName: this.userName,
              dmvStatusNotes: this.dmvStatusNotes,

            };
            //console.log((this.toEmailids.length != 0));

            if ((this.toEmailids.length != 0) || ((this.toEmailids.length == 0) && (this.ccEmailids.length == 0))) {
              httpdmvtitle
                .post("/DMVTitle/saveDMVNotes", dmvnotespayload)
                .then(response => {

                  var status = response.data;
                  if (status == "CREATED") {
                    this.saved = true;
                    this.msgcolor.color = "Blue";
                    this.savemessage = 'Successfully added into the system'
                    setTimeout(() => { this.disableNotesMessage() }, 2000);
                    this.dmvStatusNotes = false;
                  }
                  this.employeemailids = [];
                  this.ccEmailids = [];
                  this.toEmailids = [];

                  this.content = '';
                  var ele = document.getElementsByName('emailids');
                  for (var i = 0; i < ele.length; i++) {
                    if (ele[i].type == 'checkbox')
                      ele[i].checked = false;
                  }
                  //this.getDmvNotes();
                  this.getDmvNotesUserName();
                  this.getDmvNotesCreationDate();
                  this.resetDmvNotes();

                });
            }
          }
        }
      }
    },

    serviceProviderNames(option) {
      return `${option.serviceName}`;
    },
    selectedNotes() {
      this.notes = "notes";
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0]
      //console.log("Selcted file : " + event.target.files[0])
      this.clearMessages();
    },
    onFileSelectedForm(event) {
      console.log("Selcted file 2 : " + this.$refs.fileForm.files[0])
      this.selectedFileForm = this.$refs.fileForm.files[0]
      this.clearMessages();
    },
    uploadDocuments(docName, docId, index) {
      //  console.log("DOC : " + docName)
      //  console.log("DOC Id : " + docId)

      //  console.log("files : " + this.$refs.['file'+index][0].files.length)

      if (this.$refs.['file' + index][0].files.length == 1) {
        var modal = document.getElementById("uploaddoc");
        modal.style.display = "block";
        this.responseFinancialMessage = ''
        this.documentName = 'doc'
        let formData = new FormData();
        let file = this.$refs.['file' + index][0].files[0];
        formData.append('file', file);
        formData.append('loan', this.selectedDealData[0].loan);
        formData.append('documentName', docName);

        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        httpdmvtitle.post("/dmvNotifications/uploadDocuments/" + docId + "/" + this.userId + "/" + this.selectedDealData[0].id, formData, config)
          .then(response => {
            //console.log("Uploaded Succesfully ll" + JSON.stringify(response))
            //console.log("Uploaded Succesfully" + JSON.stringify(response.data))
            if (response.data == "document uploded") {
              this.responseMessage = 'Document uploaded Succesfully';
              this.msgcolor.color = "Blue";
              this.$refs.['file' + index][0].value = null;
              this.documents = '';
              this.documentName = ''
              this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);

              //console.log("Uploaded Succesfully" + JSON.stringify(response.data))
            } else if (response.data == "file already exist") {
              this.responseMessage = "Document already uploaded";
              this.$refs.['file' + index][0].value = null;
              this.msgcolor.color = "Red";
              this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);
              var modal = document.getElementById("uploaddoc");
              modal.style.display = "none";
            }

            else {
              this.responseMessage = "Error in submiting form to drop box";
              this.msgcolor.color = "Red";
              this.getDocuments(this.selectedDealData[0].id, this.selectedDealData[0].loan, this.selectedDealData[0].dealbookRegistrationState);
            }
            setTimeout(() => {
              this.responseMessage = ""
            }, 3000)

          })
          .catch(e => {
            this.errorslist.push(e);
          });
      }
      else if (this.$refs.['file' + index][0].files.length == 0) {
        this.responseMessage = "Please attach document";
        this.msgcolor.color = "Red";
      }
    },
    deleteStateForm(formPath) {
      httpdmvtitle.delete("/dmvNotifications/deleteStateDmvForm/" + formPath.split("/")[1] + "/" + formPath.split("/")[2]).then(response => {
        this.download();

      });
    },
    uploadStateForm() {
      if (this.$refs.fileForm.files.length == 1) {
        let formData = new FormData();
        let file = this.$refs.fileForm.files[0];
        formData.append('file', file);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        httpdmvtitle.post("/dmvNotifications/postDMVForm/" + this.selectedDealData[0].dealbookRegistrationState, formData, config)
          .then(response => {
            if (response.data == "document uploded") {
              this.responseMessage = 'Document uploaded Succesfully';
              this.msgcolor.color = "Blue";
              this.$refs.fileForm.value = null;
              this.enableDmvForm = 'N';
              this.download();

            }
          })
      }
      setTimeout(() => {
        this.responseMessage = ""
      }, 3000)
    },
    displayAllDeals() {
      this.selecteddmvid = "";
      window.location.reload();
    },
    // displayFullName(option) {
    //   return `${option.firstName}  ,${
    //     option.lastName != null && option.lastName.length != 0
    //       ? option.lastName
    //       : ""
    //   }`;
    // },
    statesList() {
      httpcommon
        .get("/statefip/")
        .then(response => {
          this.states = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        })
    },
    intializeSelectedDeal() {
      return {
        selectedLoan: "",
        selectedLesseeName: "",
        selectedLesseeCity: "",
        selectedLesseeAddress: "",
        selectedLesseeState: "",
        selectedLesseeZip: "",
        selectedLesseePhone: "",
        selectedLesseeEmail: "",
        selectedYear: "",
        selectedMake: "",
        selectedModel: "",
        selectedColor: "",
        selectedVin: "",
        selectedTrim: "",
        loanNumber: "",
        registrationState: "",
        selectedMileage: "",
        referringDealer: "",
        oldtitleNumber: "",
        newTitleNumber: "",
        oldTitleDate: "",
        newTitleDate: "",
        contactEmail: "",
        dmvTitleStatus: "",
        dealbookRegistrationState: "",
        registrationAddressStreet1: "",
        registrationAddressStreet2: "",
        registrationAddressCity: "",
        titleSentToTrust: "",
        registrationAddressState: "",
        registrationAddressZipcode: "",
        registrationAddressCountry: "USA",
        dateOfSaleToLLP: "",
        checkNumber: "",
        lesseeCheckNumber: "",
        checkPayableTo: "",
        lesseeCheckPayableTo: "",
        amount: "",
        lesseeAmount: "",
        checkDate: "",
        lesseeCheckDate: "",
        initialSalesTaxAtPurchase: "",
        monthlySalesTax: "",
        numberAdvancedPayments: "",
        dmvFees: "",
        dealbookRegistrationState: "",
        emailMilestone: "",
        loanStatus: "",
        sourceCompany: "",
        additionalEmail: "",
        odometer: "",
        dealerDMV: "",
        loanStatusData: "",
        licensePlateNumberDate: "",
        eltOrderedTitleWorkComplete: "",
        sendingTitleToTrust: "",
        mvWorkSentDate: "",
        mvWorkPackageSentDate: "",
        acceptedDate: "",
      };
    },

    initializeManageTitle() {
      return {
        quoteId: "Q" + moment(new Date()).format('MM-DD-YYYYHH:MM:SS').replaceAll("-", "").replaceAll(":", ""),
        selectedQuote: "",
        dmvTitleId: null,
        oldtitleNumber: "",
        plateNumber: "",
        newTitleNumber: "",
        intrimTitleNumber: "",
        oldTitleDate: "",
        newTitleDate: null,
        interimTitleDate: null,
        contactEmail: "",
        serviceCompanyId: "",
        anotherServiceCompanyId: "",
        quoteDate: null,
        status: "",
        serviceCompanyName: "",
        anotherserviceCompanyName: "",
        registrationState: "",
        registrationAddressStreet1: "",
        registrationAddressStreet2: "",
        registrationAddressCity: "",
        titleSentToTrust: "",
        registrationAddressState: "",
        registrationAddressZipcode: "",
        registrationAddressCountry: "USA",
        acceptedDate: "",
        message: "",
        additionalInstructions: null,
        statusContract: false,
        dmvWorkSentDate: "",
        documentLinks: [],
        selectedNewTitleStateCode: "",
        selectedOldTitleStateCode: "",
        selectedInterimStateCode: "",
        licensePlateNumberDate: null,
        eltOrderedTitleWorkComplete: null,
        mvWorkSentDate: null,
        sendingTitleToTrust: null,
        mvWorkPackageSentDate: null

      };
    },
    // initializeCheckdata(){
    //   return{
    //     dmvCheckNumber:"",
    //     lesseeCheckNumber:"",
    //     dmvCheckPayableTo:"",
    //     lesseeCheckPayableTo:"",
    //     dmvAmount:"",
    //     lesseeAmount:"",
    //     dmvCheckDate:"",
    //     lesseeCheckDate:""
    //   }
    // },
    scrolltop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  },

  mounted() {


    //this.getDMVServiceProvider();

  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  created() {
    window.addEventListener("message", this.receiveMessage);
    //this.fetchdata();
    // this.tempTagRegList.dateOfExpiry=moment().add(30,'days').format("YYYY-MM-DD");
    this.tempTagRegList.timesTempTagIssued = this.tempTagRegListData.length + 1;
    bus.$on("userName", data => {
      this.tempTagRegList.whoIsIssued = data;
      this.userName = data;
      this.userNameData = data;
      this.userNameDataOne = data;
    });
    bus.$on("loanStatusData", data => {
      this.deal.loanStatusData = data;


    });
    bus.$on("userId", data => {
      this.userId = data;

    });

    //this.selecteddmvid = sessionStorage.getItem("dmvid");
    bus.$on("dealerId", data => {
      this.selecteddmvid = data;
      // console.log(this.selecteddmvid);
      this.getSelectedDealData(this.selecteddmvid);
      //   this.getDmvNotes();
      this.getDmvNotesCreationDate(this.selecteddmvid);
      this.getDmvNotesUserName(this.selecteddmvid);
      this.getManageMilestoneStatus();
      this.getDMVTempTagRegistration();
      // this.getkeyData();
      // this.getkeyData1();
      this.getEmployeeDetails();
      this.statesList();
    });

    bus.$on("activetab", data => {
      this.selecteddmvid = data;
      this.getSelectedDealData(this.selecteddmvid);
      setTimeout(function () {
        document.getElementById("note1").click();
      }, 2000);
    });
    bus.$on("activeTabName", data => {
      this.activetab = data;

      this.displayContents(this.activetab);
      //console.log(this.activetab);
      // this.getDmvNotes();
      this.getDmvNotesCreationDate(this.selecteddmvid);
      this.getDmvNotesUserName(this.selecteddmvid);
      this.getManageMilestoneStatus();
      this.getDMVTempTagRegistration();
      this.getEmployeeDetails();
      this.getDmvMileStone();
      this.statesList();
    });
    bus.$on("scrollToTop", data => {
      window.scrollTo(0, 0);
    });


  }
};
</script>
<style scoped>
@import "../css/vue2-datepicker.css";
@import "../css/vue-multiselect.min.css";

.emailmsgcolor {
  color: red;
}

.mobviewItems {
  font-size: 14px !important;
  overflow-x: auto;
}

.horizontmenu {
  padding-right: 0px !important;
}

.form-control {}

.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}

.input-create:focus {
  /* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #757575;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus~.label-create,
.label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}

.dropdown-check-list {
  display: inline-block;
}

.dropdown-check-list .anchor {
  position: relative;
  cursor: pointer;
  display: inline-block;
  padding: 20px 50px 15px 60px;
  border: 1px solid #ccc;
}

.dropdown-check-list .anchor:after {
  position: absolute;
  content: "";
  border-left: 2px solid black;
  border-top: 2px solid black;
  padding: 5px;
  right: 10px;
  top: 20%;
  -moz-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

.dropdown-check-list .anchor:active:after {
  right: 8px;
  top: 21%;
}

.dropdown-check-list ul.items {
  padding: 2px;
  display: none;
  margin: 0;
  border: 1px solid #ccc;
  border-top: none;
}

.dropdown-check-list ul.items li {
  list-style: none;
}

.labelFont {
  opacity: 0.6;
  font-size: 14px;
}

.list-group {
  max-height: 300px;
  margin-bottom: 10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.btn-blue-save {
  width: 10% !important;
}

.container {
  width: 600px;
  margin: 100px auto;
}

.progressbar {
  counter-reset: step;
}

.progressbar li {
  list-style-type: none;
  width: 10%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
}

.progressbar li:before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 30px;
  border: 2px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}

.progressbar li:after {
  width: 100%;
  height: 2px;
  content: '';
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}

.progressbar li:first-child:after {
  content: none;
}

.progressbar li.active {
  color: green;
}

.progressbar li.active:before {
  border-color: #55b776;
}

.progressbar li.active+li:after {
  background-color: #55b776;
}

.title_fields {
  margin-top: -14px;
  margin-bottom: 5px;

}

.buttonwrapper {
  display: inline-block;
}

.blur {
  image-rendering: -moz-crisp-edges;
  /* Firefox */
  image-rendering: -o-crisp-edges;
  /* Opera */
  image-rendering: -webkit-optimize-contrast;
  /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  /* IE (non-standard property) */

}

.card {
  box-shadow: 1px 1px 1px #757575;
}
</style>
